// English (US) translations — cdnX Admin Console.
// Keep keys in lockstep with zh-CN.ts — add to both when adding new strings.
export default {
  common: {
    deleted: 'Deleted',
    loadFailed: 'Failed to load',
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    refresh: 'Refresh',
    submit: 'Submit',
    loading: 'Loading…',
    empty: 'No data',
    actions: 'Actions',
    status: 'Status',
    name: 'Name',
    type: 'Type',
    yes: 'Yes',
    no: 'No',
    on: 'On',
    off: 'Off',
    search: 'Search',
    copy: 'Copy',
    copied: 'Copied',
    back: 'Back',
    next: 'Next',
    more: 'More',
  },
  app: {
    switchLanguage: 'Switch to 中文',
    fullscreen: 'Full screen',
    exitFullscreen: 'Exit full screen',
    console: 'Console',
    toggleNav: 'Toggle navigation',
    openMenu: 'Open menu',
    collapseMenu: 'Collapse menu',
    expandMenu: 'Expand menu',
    foldMenu: 'Collapse',
    searchPlaceholder: 'Search by page, site domain or node',
    search: 'Search',
    searchPage: 'Page',
    searchHint: 'Type a page, site or node name; press / to open from anywhere',
    notifications: 'Notifications',
    toDashboard: 'Open the dashboard',
    pageSettings: 'Customize',
    searchNoHit: 'No matches',
    searchSite: 'Site',
    searchNode: 'Node',
    title: 'cdnX Admin Console',
    logout: 'Logout',
  },
  navbar: {
    tasks: 'Tasks',
    tickets: 'Tickets',
    audit: 'Audit',
    roleAdmin: 'Administrator',
    roleOperator: 'Operator',
    accountIdFull: 'Account ID: {id}',
    lostNodes: 'Offline',
    openTickets: 'Tickets',
    failedTasks: 'Failed',
    unread: 'Unread',
  },
  nav: {
    dashboard: 'Dashboard',
    cnameZones: 'Access domains',
    regions: 'Regions',
    securityEvents: 'Security Events',
    accessLogs: 'Access Logs',
    analytics: 'Analytics',
    accessStats: 'Access Stats',
    originStats: 'Origin Stats',
    login: 'Sign in',
    nodes: 'Node List',
    tasks: 'Task Queue',
    domains: 'Site List',
    lineGroups: 'Line Groups',
    dnsProviders: 'DNS Providers',
    users: 'Customer List',
    userGroups: 'Customer Groups',
  },
  auth: {
    welcomeBack: 'Welcome back',
    loginFailed: 'Login failed',
    signInSubtitle: 'Sign in to the {name} admin console',
    username: 'Username',
    password: 'Password',
    usernamePlaceholder: 'admin',
    passwordPlaceholder: '•••••••',
    signIn: 'Sign in',
    unauthorized: 'Unauthorized or session expired, please sign in again',
    mfaLabel: 'Verification code',
    mfaHint: 'Enter the 6-digit code from your authenticator app',
    mfaVerify: 'Verify',
    mfaBack: 'Back to sign in',
    smsLabel: 'Text message code',
    smsHint: 'The code goes to {phone}',
    smsSentHint: 'Code sent to {phone}; it holds for {minutes} minutes',
    useSms: 'Use a text message code instead',
    useMfa: 'Use the MFA code instead',
    forgot: 'Forgot password?',
    resetSubtitle: 'Reset your password with your verified phone',
    resetCodeHint: 'The code goes to the verified phone of this account',
    resetSubmit: 'Reset password',
    resetDone: 'Password reset. Sign in with the new password',
    resetFailed: 'Reset failed',
    backToSignIn: 'Back to sign in',
  },
  security: {
    title: 'Security events',
    statBlocked: 'Blocked',
    statEvents: '{n} events in all',
    statIps: 'Attacking IPs',
    statWaf: 'WAF blocks',
    statCc: 'CC blocks',
    unitTimes: 'times',
    unitIps: 'IPs',
    listTitle: 'Events',
    filterAllModules: 'All modules',
    filterAllActions: 'All actions',
    ipPlaceholder: 'Client IP',
    timeCol: 'Time',
    hostCol: 'Hostname',
    ipCol: 'Client IP',
    moduleCol: 'Module',
    actionCol: 'Action',
    ruleCol: 'Rule',
    uriCol: 'Request',
    nodeCol: 'Node',
    rulePlaceholder: 'Rule name',
    topAttackers: 'Top attacking IPs',
    topHosts: 'Most attacked hostnames',
    modulesCol: 'Modules',
    domainsCol: 'Hosts',
    ipsCol: 'Source IPs',
    blockedCol: 'Blocked',
    lastSeenCol: 'Last seen',
    block: 'Block',
    blockNote: 'Blocked from Security Events · {window}',
    onlyThisIp: 'Only this IP',
    noBlocks: 'Nothing was blocked in this window',
    detailTitle: 'Event details',
    scoreCol: 'Score',
    statusCol: 'Status',
    categoryCol: 'Category',
    uaCol: 'User agent',
    ja3Col: 'JA3 fingerprint',
    pageN: 'Page {n}',
    prev: 'Previous',
    next: 'Next',
    noLogs: 'Log storage is not connected, so there are no security events yet',
    empty: 'No security events in this window',
    module_waf: 'WAF',
    module_cc: 'CC',
    module_acl: 'ACL',
    module_bot: 'Bot',
    module_geo: 'Region',
    module_iplist: 'IP list',
    module_challenge: 'Challenge',
    module_edge: 'Edge',
    module_guard: 'Node guard',
    module_site: 'Site',
    module_quota: 'Quota',
    module_upstream: 'Origin',
    action_pass: 'Pass',
    action_redirect_https: 'HTTPS redirect',
    action_challenge: 'Challenge',
    action_challenge_verify: 'Answer',
    action_block: 'Denylist block',
    action_block_acl: 'ACL block',
    action_block_waf: 'WAF block',
    action_block_bot: 'Bot block',
    action_block_cc: 'CC block',
    action_block_ban: 'Ban block',
    action_block_geo: 'Region block',
    action_log_geo: 'Region log',
    action_block_cross_site: 'Cross-site block',
    action_ban: 'Failure ban',
    action_suspended: 'Site suspended',
    action_conn_limit: 'Connection limit',
    action_shed: 'Origin overload',
    action_websocket_off: 'WebSocket off',
  },
  geoBlock: {
    title: 'Region block',
    mode: 'Mode',
    modes: { off: 'Off', block: 'Block selected', allow: 'Allow only selected' },
    modeHint_off: 'No restriction by country or region.',
    modeHint_block: 'Visitors from the selected countries and regions get the action below; everyone else passes.',
    modeHint_allow: 'Only the selected countries and regions pass; everyone else gets the action below.',
    action: 'Action',
    actions: {
      drop: 'Drop (444)',
      deny: 'Block (403)',
      challenge_js: 'JS challenge',
      challenge_slider: 'Slider challenge',
      ban_kernel: 'Kernel ban',
      log: 'Log only',
    },
    actionHint_drop: 'Close the connection without answering. Cheaper than a 403, and tells the client nothing.',
    actionHint_deny: 'Answer with 403, so the visitor can see they were refused.',
    actionHint_ban_kernel: "Drop the first request and hand the IP to the node's firewall (nftables). From then on its packets are dropped in the kernel and cost the proxy nothing.",
    actionHint_challenge_js: 'Visitors must pass a JS challenge first, and are not asked again while the pass lasts.',
    actionHint_challenge_slider: 'Visitors must pass a slider challenge first, and are not asked again while the pass lasts.',
    actionHint_log: 'Block nothing; record a security event. Useful to see what would be affected before enforcing.',
    banSeconds: 'Ban duration (s)',
    banSecondsHint: '60 seconds to 30 days. Lifts on its own; the ban log can lift it early.',
    kernelWarn: 'A kernel ban covers the whole node: the firewall cannot tell which site a packet is for, so a banned IP cannot reach any site on that node, not only this one. Use it only when every site on the node should refuse these regions.',
    regionsBlock: 'Places to block',
    regionsAllow: 'Places allowed',
    levelCountry: 'Countries/regions ({count})',
    levelProvince: 'China provinces ({count})',
    levelCity: 'Cities ({count})',
    rowCountries: 'Countries ({count})',
    rowProvinces: 'Provinces ({count})',
    rowCities: 'Cities ({count})',
    allProvinces: 'All {count} provinces of mainland China',
    useCountryInstead: 'Select China as a whole instead (no City database needed, more accurate)',
    unfold: 'Show all {count}',
    fold: 'Show less',
    levelProvinceAll: 'China provinces (all)',
    provincesCovered: 'All of China is selected, so every province is included. To pick only some provinces, untick China under Countries/regions first.',
    cityCovered: 'All of {country} is selected, so every city in it is included already.',
    summaryAllow: 'Only visitors from {places} can visit; everyone else gets "{action}".',
    summaryBlock: 'Visitors from {places} get "{action}"; everyone else passes.',
    summaryMore: '{list} and {count} places in all',
    nothingSelected: 'Nothing selected yet',
    provinceHint: "Mainland China's 31 provincial-level divisions. Hong Kong, Macao and Taiwan are under Countries/regions.",
    cityPlaceholder: 'City name, e.g. Shenzhen or 深圳',
    addCity: 'Add',
    cityHint: "Matched against the GeoIP database's English or Chinese city name; suffixes such as 市 are optional. Cities of the same name are told apart by the country chosen. At most 200.",
    searchPlaceholder: 'Search by name or code',
    addGreaterChina: '+ Mainland China, HK, Macao, Taiwan',
    selectAll: 'Select all',
    clearAll: 'Clear',
    selectContinent: 'Select continent',
    clearContinent: 'Clear continent',
    noMatch: 'No matching country or region',
    continents: { AS: 'Asia', EU: 'Europe', NA: 'North America', SA: 'South America', AF: 'Africa', OC: 'Oceania', AN: 'Antarctica' },
    notesTitle: 'Notes',
    noteUnknown: "The country comes from the visitor's IP. An IP no country can be found for (no GeoIP database on the node, private addresses) always passes, in either mode.",
    noteCityDb: "Provinces and cities need the GeoLite2-City database on the node. Without it the visitor's province and city cannot be told, so those entries never refuse anyone; in allow mode the rule then works at country level.",
    noteWhitelist: 'Addresses on the IP whitelist are exempt, so a partner inside a blocked region can still be let in.',
    noteOrder: 'Region block runs before forced verification and the CC, WAF and other rules; a blocked request goes no further.',
    saved: 'Region block saved',
    saveFailed: 'Failed to save region block',
  },
  ccProtection: {
    title: 'CC protection',
    level: 'Protection level',
    levels: { off: 'Off', loose: 'Low', normal: 'Medium', strict: 'High', attack: 'Under attack' },
    levelHint_off: 'No built-in protection; only the custom rules below apply.',
    levelHint_loose: 'A JS challenge for any IP over 600 requests in 10 seconds. Almost never hits real users; suits busy, API-heavy sites.',
    levelHint_normal: 'An IP over 300 requests in 10 seconds must pass a JS challenge for 5 minutes; 5 repeat offences ban it for 10 minutes.',
    levelHint_strict: 'An IP over 120 requests in 10 seconds must pass a JS challenge for 10 minutes; 3 repeat offences kernel-ban it for 30 minutes.',
    levelHint_attack: 'Every visitor gets a JS challenge; an IP over 60 requests in 10 seconds gets a slider challenge for 15 minutes; 2 repeat offences kernel-ban it for an hour.',
    attackWarn: 'Under attack mode challenges every visitor, which breaks APIs and clients that cannot run JavaScript. Turn it back down once the attack is over.',
    auto: 'Adaptive CC',
    autoHint_off: 'Never switches on by itself. Under a CC attack, set the protection level to Under attack by hand.',
    autoHint_loose: 'Challenges new visitors once requests reach 6× the usual while half the requests to the origin fail or slow right down. Suits sites whose traffic swings a lot.',
    autoHint_normal: 'Challenges new visitors once requests reach 4× the usual while the origin starts failing or slowing; switches off 5 minutes after requests are back to normal.',
    autoHint_strict: 'Challenges new visitors at 2.5× the usual requests and the first sign of origin trouble. Suits origins with little headroom.',
    autoCommon: 'Each node judges by the site\'s usual requests and origin speed. Visitors who already passed, exempt paths and search engines are never challenged.',
    autoMode: 'Verification',
    autoActiveTitle: 'Adaptive CC is on',
    autoActive: 'Since {since}, new visitors are being challenged because {reason} (nodes: {nodes}). Requests now: {rps} a second, against about {baseline} usually. It switches off by itself 5 minutes after requests are back to normal.',
    autoReason_failing: 'the origin was failing requests',
    autoReason_slow: 'the origin was answering slowly',
    autoMoot: 'With the level at Under attack, or forced challenges on, every new visitor is challenged already; adaptive CC adds nothing.',
    failBan: 'Ban on failed challenges',
    failBanDesc: 'An IP that fails the challenge this many times within the period is blacklisted: the node drops it in the kernel and records it in the ban log. Applies to forced challenges and to challenges from CC rules.',
    failMax: 'Failures',
    failMaxHint: 'Each challenge page not passed, and each wrong answer, counts once. Passing resets the count.',
    failWindow: 'Period (s)',
    failBanSec: 'Ban duration (s)',
    failBanSecHint: 'At most 30 days.',
    saved: 'CC protection saved',
    saveFailed: 'Failed to save CC protection',
  },
  challenge: {
    title: 'Forced verification',
    desc: 'Every visitor must pass a human check before reaching the site. Those who pass are not asked again until the pass expires.',
    warn: 'This changes the first page every visitor sees. Check the search-engine and exempt-path settings below before enabling, or you risk losing search indexing or breaking API calls.',
    mode: 'Method',
    mode_wait: '5-second shield',
    mode_js: 'JS check',
    mode_click: 'Click to verify',
    mode_slider: 'Slide to verify',
    modeHint_wait: 'Shows "checking your browser" and passes on its own once the work finishes. No interaction.',
    modeHint_js: 'Same as the shield, with a visible progress bar.',
    modeHint_click: 'One button click. The work runs on page load; the click only confirms it.',
    modeHint_slider: 'The visitor drags a slider to the right.',
    ttl: 'Pass duration (seconds)',
    ttlHint: 'How long a passing visitor goes unchallenged. Default 1800 (30 minutes).',
    difficulty: 'Work factor',
    difficultyHint: 'Each step doubles the cost to a bot. Default 16, roughly tens of milliseconds in a modern browser. Below 12 offers little protection; above 20 is noticeably slow on low-end phones.',
    bypassSpiders: 'Allow search engines',
    bypassSpidersHint: 'Crawlers whose address reverse-resolves to the search engine skip verification; a forged user-agent still does not. Turning this off removes the site from search indexes, because crawlers do not run JavaScript.',
    exemptPaths: 'Exempt paths',
    exemptPathsHint: 'One path prefix per line; matching requests skip verification. APIs, payment callbacks and health checks belong here — they are not browsers and can never pass. Matched on whole segments: /api exempts /api/orders but not /apiary.',
    saved: 'Saved and published',
    saveFailed: 'Could not save',
  },
  logs: {
    distribution: 'Requests over time',
    total: '{n} in all',
    noRows: 'No log rows match',
    pickHint: 'Click to look at this stretch',
    list: 'Log rows',
    export: 'Export page',
    requestCol: 'Request',
    clientCol: 'Client',
    pageInfo: 'Page {n} · {rows} rows',
    pivot: 'Filter by',
    byIp: 'This IP',
    byUrl: 'This URL',
    byUa: 'This UA',
    byJa4: 'This JA4',
    byStatus: 'This status',
    bytesUpCol: 'Request size',
    argsCol: 'Query string',
    noUpstream: 'Not sent to the origin',
    actionCol: 'Action',
    action_pass: 'Pass',
    action_redirect_https: 'HTTPS redirect',
    action_challenge: 'Challenge',
    action_block_acl: 'ACL block',
    action_block_waf: 'WAF block',
    action_block_bot: 'Bot block',
    action_block_cc: 'CC block',
    action_block_ban: 'Ban block',
    action_block_geo: 'Region block',
    action_log_geo: 'Region log',
    action_block_cross_site: 'Cross-site block',
    action_suspended: 'Site suspended',
    requestIdCol: 'Request ID',
    geoCol: 'Location',
    ispCol: 'Operator',
    contentTypeCol: 'Content type',
    upstreamStatusCol: 'Origin status',
    protoCol: 'Protocol',
    portCol: 'port',
    tlsVersionCol: 'TLS version',
    tlsCipherCol: 'Cipher',
    plaintext: 'plaintext (no TLS)',
    ja3Pending: 'no fingerprint for this connection (plaintext HTTP, or not captured at handshake)',
    ja4Hint: 'Extensions are sorted before hashing, so one browser keeps one JA4 across visits — unlike JA3.',
    grpRequest: 'Request',
    grpClient: 'Client',
    grpTls: 'TLS',
    grpResponse: 'Response & origin',
    grpHeaders: 'Request headers',
    redactHint: 'Values of credential headers (Cookie, Authorization, ...) are redacted to their length. A log page must never be able to show a customer\'s session token.',
    headersTruncated: 'Too many or too large headers; this list is truncated.',
    search: 'Search',
    reset: 'Reset',
    detail: 'Detail',
    prev: 'Previous',
    next: 'Next',
    pageN: 'Page {n}',
    rangeLabel: 'Range',
    timeCol: 'Time',
    domainCol: 'Domain',
    uriCol: 'Path',
    statusCol: 'Status',
    clientIpCol: 'Client IP',
    rtCol: 'Duration',
    upstreamTime: 'upstream',
    bytesCol: 'Bytes',
    nodeCol: 'Node',
    upstreamCol: 'Upstream',
    cacheCol: 'Cache',
    unavailable: 'Log storage (ClickHouse) is not configured, so search is unavailable. Live metrics and everything else still work.',
    action_websocket_off: 'WebSocket off',
  },
  analytics: {
    rangeBeyondLogs: 'The access log keeps {n} days',
    site: 'Site',
    allSites: 'All sites',
    refresh: 'Refresh',
    updatedAt: 'Updated at {time}',
    noLogs: 'Log storage (ClickHouse) is not configured, so there is no traffic to analyse. Once it is, new requests show up here.',
    noLogsShort: 'Log storage is not configured',
    noData: 'No data yet',
    loadFailed: 'Failed to load',
    overview: 'Traffic overview',
    requests: 'Requests',
    traffic: 'Traffic',
    bandwidth: 'Peak bandwidth',
    hitRate: 'Cache hit rate',
    unitTimes: '',
    trend: 'Traffic trend',
    tab_bandwidth: 'Bandwidth',
    tab_requests: 'Requests',
    tab_traffic: 'Traffic',
    tab_hitRate: 'Hit rate',
    tab_errors: 'Errors',
    tab_latency: 'Response time',
    step_60: 'One point a minute',
    step_600: 'One point every 10 minutes',
    step_3600: 'One point an hour',
    step_86400: 'One point a day',
    customer: 'Customer',
    allCustomers: 'All customers',
    subscription: 'Package order',
    allSubscriptions: 'All package orders',
    expiresOn: 'until {date}',
    time: 'Time',
    from: 'From',
    to: 'To',
    reset: 'Reset',
    current_custom: 'Selected period',
    prev_custom: 'Period before',
    vs_custom: 'vs the period before',
    prev_days: '{n} days earlier',
    vs_days: 'vs {n} days earlier',
    prev_1h: 'Hour before',
    prev_today: 'Yesterday',
    prev_yesterday: 'Day before',
    prev_7d: 'Previous 7 days',
    prev_30d: 'Previous 30 days',
    status: 'Status codes',
    status_1xx: 'Informational',
    status_2xx: 'Success',
    status_3xx: 'Redirect',
    status_4xx: 'Client error',
    status_5xx: 'Server error',
    totalRequests: 'Requests',
    cache: 'Cache results',
    cache_HIT: 'Hit',
    cache_MISS: 'Miss',
    cache_STALE: 'Stale hit',
    cache_BYPASS: 'Bypassed',
    cache_NONE: 'Not cached',
    protocol: 'Protocols',
    device: 'Devices',
    device_desktop: 'Desktop',
    device_mobile: 'Mobile',
    device_tablet: 'Tablet',
    device_bot: 'Crawlers',
    device_tool: 'Scripts & tools',
    device_unknown: 'Unknown',
    region: 'Locations',
    regionCountry: 'Countries',
    regionProvince: 'China provinces',
    isp: 'Carriers',
    carrier_telecom: 'China Telecom',
    carrier_unicom: 'China Unicom',
    carrier_mobile: 'China Mobile',
    carrier_cernet: 'CERNET',
    carrier_tencent: 'Tencent Cloud',
    carrier_alibaba: 'Alibaba Cloud',
    carrier_huawei: 'Huawei Cloud',
    rank: 'Top lists',
    rank_domain: 'Hostnames',
    rank_url: 'URLs',
    rank_ip: 'IPs',
    rank_referer: 'Referrers',
    rank_node: 'Nodes',
    colRank: 'Rank',
    colRequests: 'Requests',
    colRequestShare: 'Share of requests',
    colTraffic: 'Traffic',
    colTrafficShare: 'Share of traffic',
    direct: 'Direct',
    unknown: 'Unknown',
  },
  access: {
    viewLogs: 'View logs',
    grp_visitor: 'Visitor',
    grp_client: 'Client',
    grp_tls: 'TLS & protocol',
    grp_request: 'Request',
    grp_response: 'Response',
    dim_ip: 'IP',
    dim_ip24: 'IP /24',
    dim_country: 'Country/region',
    dim_province: 'Province',
    dim_city: 'City',
    dim_isp: 'Carrier',
    dim_asn: 'ASN',
    dim_ua: 'User agent',
    short_ua: 'UA',
    dim_browser: 'Browser',
    dim_os: 'OS',
    dim_device: 'Device type',
    dim_ja4: 'JA4',
    dim_ja3: 'JA3',
    dim_tls: 'TLS version',
    dim_protocol: 'HTTP version',
    dim_scheme: 'HTTP / HTTPS',
    dim_host: 'Hostname',
    dim_url: 'URL',
    dim_method: 'Method',
    dim_referer: 'Referring site',
    dim_referer_url: 'Referring page',
    dim_content_type: 'Content type',
    dim_request_id: 'Request ID',
    dim_status: 'Status code',
    dim_status_class: 'Status class',
    dim_cache: 'Cache status',
    dim_action: 'Security action',
    dim_node: 'Node',
    op_eq: 'equals',
    op_ne: 'does not equal',
    op_contains: 'contains',
    op_not_contains: 'does not contain',
    op_prefix: 'starts with',
    op_cidr: 'in network',
    filters: 'Filters',
    addFilter: 'Add filter',
    editFilter: 'Edit filter',
    removeFilter: 'Remove filter',
    clearFilters: 'Clear filters',
    valuePlaceholder: 'Type or pick a value',
    cidrPlaceholder: 'e.g. 203.0.113.0/24',
    needValue: 'Enter a value to match',
    badCidr: 'Not a network, e.g. 203.0.113.0/24',
    apply: 'Apply',
    cancel: 'Cancel',
    emptyUa: '(empty)',
    noFingerprint: 'None (plain HTTP)',
    plaintext: 'Plain HTTP',
    none: 'None',
    other: 'Other',
    added: 'Filter added: {cond}',
    logs: 'Logs',
    profile: 'Up close',
    summaryTop: 'the top {n} below',
    selected: '{n} selected',
    blockSelected: 'Block selected',
    clearSelection: 'Clear selection',
    searchRows: 'Find in results',
    topN: 'Top {n}',
    export: 'Export CSV',
    colRequests: 'Requests',
    colPeak: 'Peak / min',
    colErrors: 'Errors',
    colBlocked: 'Blocked',
    colTraffic: 'Traffic',
    colUrls: 'URLs',
    colIps: 'IPs',
    colLast: 'Last seen',
    colActions: 'Actions',
    perMinute: 'per minute',
    seen: 'First — last seen',
    block: 'Block',
    denied: 'Blocked',
    deniedSome: 'Partly blocked',
    deniedBy: 'On the deny list: {entry}',
    deniedByRule: 'Blocked by {rule}',
    deniedEverywhere: 'on every site',
    deniedOnSites: 'on all {n} sites in scope',
    deniedOnSome: 'On {n} of {of} sites by {rule}',
    deniedRest: 'Blocking adds the other {n}',
    ruleRef: 'rule “{name}”',
    ruleRefMore: '{n} rules incl. “{name}”',
    signal_burst: 'Bursting',
    signal_errors: 'Mostly errors',
    signal_scan: 'Scanning',
    signal_blocked: 'Mostly blocked',
    signalHint_burst: 'Too many requests in its busiest minute: over 300 for one IP, over 3000 for a /24',
    signalHint_errors: 'Over half of its requests were answered 4xx or 5xx',
    signalHint_scan: 'Over 100 distinct paths, and over 30% answered 4xx',
    signalHint_blocked: 'Over half of its requests were already refused by a protection rule',
    ago_now: 'just now',
    ago_min: '{n} min ago',
    ago_hour: '{n} h ago',
    ago_day: '{n} d ago',
    blockTitle: 'Block {n} × {dim}',
    blockConfirm: 'Block',
    andMore: '{n} in all',
    cannotBlockSome: '{n} of them are empty or unknown and cannot be blocked; skipped',
    blockScope: 'Applies to',
    scopeSystem: 'The whole platform (every site)',
    scopeUser: 'Only {name}\'s sites',
    scopeUserNone: 'Only one customer\'s sites (pick a customer or a site in the filters first)',
    enforcement: 'How',
    enforcementHint: 'A normal block answers 403 at the edge; a kernel block drops packets in the node\'s firewall — cheapest, but for the whole node.',
    note: 'Note',
    blockNote: 'Blocked from Access Stats · {window} · {dim}',
    blockedOnList: 'Added to the deny list: {n} × {dim}',
    blockedSkipped: 'Added to the deny list: {n} × {dim}; {s} were on it already',
    blockSites: 'Sites',
    blockSitesHint: 'Adds one access-control rule to each of {n} sites and publishes them now.',
    blockSitesDone: ' Left out: {n} that block it already.',
    siteDenied: '{name} (blocked)',
    pickSites: 'Pick the sites it applies to',
    nameRule: 'Name the rule',
    blockAction: 'Action',
    action_deny403: 'Deny (403)',
    action_deny444: 'Drop the connection',
    action_log: 'Log only',
    ruleName: 'Rule name',
    blockRuleName: 'Blocked from Access Stats · {dim}',
    blockedByRule: 'Rule added and published on {n} sites',
    blockedPartly: '{n} sites done, {f} failed: {sites}',
    summaryKeys: '{keys} {dim} values',
    summaryRequests: '{requests} requests',
  },
  origin: {
    overview: 'Origin overview',
    requests: 'Origin requests',
    traffic: 'Origin traffic',
    bandwidth: 'Peak origin bandwidth',
    failRate: 'Origin failure rate',
    noCompare: 'Not compared',
    noCompareTip: 'Access logs are kept for 30 days, so the period before is no longer complete and is not compared.',
    estimated: '{pct} of origin requests came from nodes not yet upgraded to report origin bytes; their origin traffic and bandwidth are estimated from the bytes sent to clients.',
    trend: 'Origin trend',
    tab_bandwidth: 'Bandwidth',
    tab_requests: 'Requests',
    tab_traffic: 'Traffic',
    tab_rate: 'Origin ratio',
    tab_status: 'Status codes',
    tab_latency: 'Origin time',
    status: 'Origin status codes',
    status_fail: 'No response',
    status_fail_note: 'Refused, timed out or unresolvable',
    status_fail_short: 'Refused or timed out',
    totalRequests: 'Requests',
    codes: 'Status code detail',
    cause: 'Why requests reached the origin',
    cause_MISS: 'Cache miss',
    cause_NONE: 'No cache rule',
    cause_BYPASS: 'Bypassed',
    cause_STALE: 'Stale copy',
    time: 'Origin time distribution',
    rank: 'Origin top lists',
    rank_domain: 'Hostnames',
    rank_origin: 'Origins',
    rank_url: 'URLs',
    rank_node: 'Nodes',
    colRequests: 'Origin requests',
    colShare: 'Share',
    colTraffic: 'Origin traffic',
    colFailRate: 'Failure rate',
    colAvgTime: 'Avg. time',
    failSplit: '5xx: {s5xx} · No response: {failed}',
  },
  serving: {
    col: 'Config in effect',
    title: 'Config in effect',
    intro: 'What the node actually serves against what was published: the edge reports its own load, the agent probes each site every minute, and the control plane judges every 15 seconds.',
    status_ok: 'In effect',
    status_syncing: 'Syncing',
    status_partial: 'Partial',
    status_risk: 'At risk',
    status_probe_failed: 'Probes failing',
    status_not_effective: 'Not in effect',
    status_unknown: 'Unknown',
    reason_inactive: 'The node is not active',
    reason_offline: 'The node is offline; nothing to judge by',
    reason_no_report: 'The agent is too old to report this',
    reason_edge_without_state: 'The edge is too old to report this',
    reason_state_broken: 'The edge state file cannot be read',
    reason_state_stale: 'The edge stopped updating its state: stopped, or not the process serving',
    reason_behind: 'The edge still serves an older config',
    reason_load_failed: 'The edge could not load the new config',
    reason_root: 'The edge cannot read its config directory',
    reason_delivery_failed: 'The new config did not reach the node',
    reason_skipped: 'The edge skipped sites; they cannot be reached on this node',
    reason_parts: 'Platform-wide settings not applied',
    reason_probe: 'Sites keep failing their probes',
    reason_outside_unit: 'The edge runs outside cdnx-edge.service; upgrades and restarts cannot manage it',
    reason_grace: 'The new config is on its way',
    code_tls: 'TLS handshake failed: the node does not know the name',
    code_cert_mismatch: 'The certificate served is not the configured one',
    code_unknown_host: 'The node does not serve the name',
    code_stale_bundle: 'The node serves the wrong config version',
    code_connect: 'Cannot reach the edge',
    code_bad_answer: 'The edge answered unexpectedly',
    code_bundle_cert: 'The configured certificate cannot be read',
    code_skipped: 'Skipped by the edge',
    code_part: 'Not applied',
    part_ip_lists: 'IP lists',
    part_protection: 'Node protection',
    part_pages: 'Default pages',
    part_quota: 'Package quotas',
    part_l4: 'App acceleration',
    part_branding: 'Branding',
    latest: 'Should serve',
    serving: 'Serves',
    none: 'Nothing',
    sites: 'Sites loaded',
    sitesOf: '{loaded} / {expected}',
    bundleRoot: 'Config directory',
    process: 'Edge process',
    processOf: 'PID {pid} · {version}',
    inUnit: 'Service unit',
    inUnitYes: 'In cdnx-edge.service',
    inUnitNo: 'Outside the unit',
    stateAge: 'State updated',
    agoSec: '{n}s ago',
    probe: 'Last probe',
    probeOf: '{probed} / {total} sites · {age} ago',
    probeNone: 'Not probed yet',
    applied: 'Last delivery',
    effective_effective: 'Loaded by the edge',
    effective_partial: 'Loaded, partly',
    effective_not_effective: 'Not loaded',
    effective_unknown: 'Not reported',
    problems: 'Problems',
    otherProblems: 'Other problems',
    noProblem: 'The node serves the latest published config',
    colSite: 'Site',
    colProblem: 'Problem',
    colDetail: 'Detail',
    colFor: 'For',
    skippedTitle: 'Skipped sites',
    warningsTitle: 'Rules not in effect',
    warningsHint: 'The sites still serve, without these rules',
    probeTitle: 'Sites failing their probes',
    alertsTitle: 'Alarms',
    colKind: 'Alarm',
    colOpened: 'Started',
    colResolved: 'Recovered',
    open: 'Ongoing',
    moreSites: '{n} more',
    failure: 'Last failed load',
    versionsLine: 'Should serve {latest}; serves {serving}',
    partLine: '{name}: {problem}',
    siteNodes: 'Serving nodes',
    siteNodesOf: '{serving} / {nodes}',
    siteNodesHint: 'Nodes serving this site\'s latest config / nodes that should',
    siteNodesUnknown: '{n} node(s) too old to tell',
    siteNodesHintUnknown: 'Nodes serving this site\'s latest config / nodes that should; {n} node(s) too old to tell',
    dh: '{d}d {h}h',
    hm: '{h}h {m}m',
    m: '{m}m',
    s: '{s}s',
    since: 'Since {time}',
    viewNode: 'View node',
  },
  nodes: {
    manage: 'Manage',
    backToList: 'Back to nodes',
    ipCol: 'IP address',
    edgeCol: 'Edge version',
    osCol: 'OS',
    cpuCoresCol: 'CPU cores',
    uptimeCol: 'Uptime',
    sectionOverview: 'Overview',
    sectionIPs: 'IP addresses',
    liveMetrics: 'Live metrics',
    history: 'History',
    historyUnavailable: 'Charts require ClickHouse, which is not configured. Live metrics are unaffected.',
    noSamplesYet: 'No samples yet',
    metricsStale: 'This node has not reported metrics for over 30 seconds; the values below are its last sample.',
    specs: 'Hardware',
    cpuUsage: 'CPU',
    memUsage: 'Memory',
    diskUsage: 'Disk',
    network: 'Network',
    netIn: 'Inbound',
    netOut: 'Outbound',
    pktIn: 'Inbound packets',
    pktOut: 'Outbound packets',
    connChart: 'Concurrent conns',
    dropChart: 'Conn drops',
    loadAvg: 'Load',
    cores: 'cores',
    uptimeDHM: '{d}d {h}h {m}m',
    uptimeHM: '{h}h {m}m',
    addIP: 'Add IP',
    ipAdded: 'Address added',
    ipAddFailed: 'Could not add the address',
    ipDeleted: 'Address deleted',
    ipDeleteFailed: 'Could not delete the address',
    ipDeleteTitle: 'Delete address',
    ipDeleteConfirm: 'Delete {ip}? If it is currently in DNS, it will be removed from the A records.',
    ipDnsUpdated: 'DNS setting updated',
    ipUpdateFailed: 'Could not update',
    ipFamilyCol: 'Family',
    ipInDnsCol: 'In DNS',
    ipNoteCol: 'Note',
    ipPrimary: 'Primary',
    ipPrimaryLocked: 'The primary address is discovered and maintained by heartbeats and cannot be deleted. Turn off "In DNS" to stop serving from it.',
    ipDnsHint: 'Only addresses with "In DNS" on are published as A records. Turning it off keeps the address on this node but sends no user traffic to it.',
    ipPublicOnlyHint: 'Must be a routable public address. Private ranges (10.x, 192.168.x, 127.0.0.1, ...) are rejected — publishing one would black-hole every user who resolves the hostname.',
    title: 'Nodes',
    nameCol: 'Identifier',
    statusCol: 'Status',
    publicIpCol: 'Public IP',
    aliasCol: 'Nickname',
    aliasHint: 'A name you give this machine; console display only. The Identifier column is the name the node reported when it registered, and cannot be changed.',
    aliasPlaceholder: 'e.g. Hangzhou #1',
    editModalTitle: 'Edit node - {name}',
    editSuccess: 'Node updated',
    editFailed: 'Update failed',
    regionHint: 'Only regions registered under Regions can be picked. Leave empty if unassigned.',
    regionPlaceholder: 'Pick a region (optional)',
    noRegionsHint: 'No regions yet — add one on the Regions page first',
    ispCol: 'ISP',
    ispPlaceholder: 'e.g. China Telecom',
    networkCol: 'Network',
    netUp: 'Up',
    netDown: 'Down',
    connCol: 'Connections',
    connConcurrent: 'Concurrent',
    connDropped: 'Conn drops',
    pktDropped: 'Pkt drops',
    regionCol: 'Region',
    agentCol: 'Agent',
    versionCol: 'Agent version',
    lastHeartbeatCol: 'Last heartbeat',
    issueToken: 'New register token',
    issueTokenDesc: 'Run the command below on the edge host',
    tokenTtl: 'TTL (seconds)',
    tokenIssued: 'Token issued — use it on the edge host now, it expires soon',
    tokenModalTitle: 'One-time registration token',
    tokenWarn: 'This token is shown once. Copy it now — it cannot be retrieved later.',
    tokenExpiresAt: 'Expires at',
    tokenInstallHint: 'Run this one command on the new node (as root):',
    tokenInstallNote: 'The script, binaries and config public key are all served by the control plane — the node only needs to reach the address above. The command stops working once the token expires.',
    activate: 'Activate',
    init: 'Mark initialized',
    initSuccess: 'Node activated',
    initFailed: 'Activation failed',
    issueFailed: 'Failed to issue token',
    statusPendingInit: 'Pending init',
    statusActive: 'Active',
    statusDisabled: 'Disabled',
    statusMaintenance: 'Maintenance',
    statusOffline: 'Offline',
    sendCommand: 'Send command',
    commandSent: 'Command sent',
    commandFailed: 'Failed to send command',
    taskType: {
      resync_nftables: 'Resync firewall rules',
      reload_config: 'Pull config now',
    },
    upgradeAll: 'Update all ({n})',
    upgrade: 'Update',
    upgradeQueued: '{n} updates queued',
    upgradeTo: 'to {v}',
    upgrade_running: 'Updating',
    upgrade_outdated: 'Update',
    upgrade_failed: 'Failed',
    upgradeReason_agentTooOld: 'This agent predates online updates: run the node bootstrap command from System update on the node once first',
    upgradeReason_noUpdater: 'The node has no updater yet: run the node bootstrap command from System update on the node once first',
    upgradeReason_noAnswer: 'No answer from the node in 30 minutes; update it again',
  },
  tasks: {
    timeCol: 'Time',
    lastRunShort: 'Last',
    nextRunShort: 'Next',
    createdShort: 'Created',
    finishedShort: 'Finished',
    attemptOf: 'Attempt {n}/{max}',
    type_auto_renew: 'Auto-renew a package',
    type_cert_renew: 'Renew certificate',
    type_clickhouse_cleanup: 'Clean up ClickHouse',
    filterAllTypes: 'All types',
    searchTarget: 'Search targets',
    detail_names: 'Names',
    detail_expires: 'Old certificate expires',
    detail_new_cert_id: 'New certificate ID',
    detail_updated: 'Updated',
    detail_lines: 'Lines',
    detail_dropped: 'Deleted',
    detail_freed: 'Freed',
    detail_disk: 'Disk usage',
    detail_trigger: 'Trigger',
    type_cert_issue: 'Issue certificate',
    type_control_cert_issue: 'Issue control plane certificate',
    type_console_cert_issue: 'Issue console certificate',
    detail_site: 'Console',
    detail_domain: 'Domain',
    detail_issuer: 'Issuer',
    detail_not_after: 'Expires',
    detail_error: 'Error',
    detail_email: 'Email',
    detail_ca: 'CA',
    detail_cert_id: 'Certificate ID',
    detail_line: 'Resolve line',
    detail_ttl: 'TTL',
    type_line_publish: 'Publish line DNS',
    detail_node_group_id: 'Line group ID',
    detail_addresses: 'Node IPs',
    detail_created: 'Added',
    detail_deleted: 'Removed',
    tabSystem: 'System tasks',
    tabNode: 'Node tasks',
    targetCol: 'Target',
    resultCol: 'Result',
    nextRunCol: 'Next run',
    lastRunCol: 'Last run',
    actionsCol: 'Actions',
    retry: 'Retry',
    retried: 'Queued to run again',
    autoRefresh: 'Refreshes every 10s',
    rawMessage: 'Raw message',
    detail: 'Details',
    warningWith: 'Warning: {message}',
    type_cname_publish: 'Publish CNAME record',
    type_cname_verify: 'Verify site DNS',
    type_cname_remove: 'Remove site CNAME record',
    type_alias_verify: 'Verify alias DNS',
    type_l4_cname_publish: 'Publish App Acceleration CNAME',
    type_resync_nftables: 'Resync firewall',
    type_reload_config: 'Reload config',
    type_release_ban: 'Release ban',
    type_cache_purge: 'Purge cache',
    type_cache_prefetch: 'Prefetch cache',
    detail_site_id: 'Site ID',
    detail_rule_id: 'Rule ID',
    detail_host: 'CNAME host',
    detail_zone: 'CNAME domain',
    detail_dns_provider_id: 'DNS account ID',
    detail_target: 'Points at',
    detail_action: 'Action',
    detail_record_id: 'Provider record ID',
    detail_expected: 'Expected',
    detail_resolved: 'Resolved',
    systemHint: 'Automation the control plane runs itself: site and line DNS, certificate issuance and renewal, ClickHouse cleanup, package auto-renewal. Failures are retried on a schedule and every attempt is recorded here; line DNS is checked every 10 minutes and a check that changes nothing updates the same row. Finished tasks are kept 30 days.',
    title: 'Task Queue',
    idCol: 'ID',
    nodeCol: 'Node',
    typeCol: 'Type',
    statusCol: 'Status',
    createdAtCol: 'Created',
    finishedAtCol: 'Finished',
    errorCol: 'Error',
    filterAllNodes: 'All nodes',
    filterAllStatus: 'All statuses',
    statusPending: 'Pending',
    statusLeased: 'Leased',
    statusSuccess: 'Success',
    statusFailed: 'Failed',
    statusCancelled: 'Cancelled',
    loadFailed: 'Failed to load tasks',
    type_system_update: 'Update the control plane',
    type_upgrade: 'Update a node component',
  },
  domains: {
    aliasDeleteConfirm: 'Remove {host}? The nodes will stop answering on it.',
    originDeleteConfirm: 'Remove origin {addr}?',
    originAddrRequired: 'Enter the origin address',
    deleteSite: 'Delete site',
    changePackageAction: 'Change package',
    listTitle: 'All sites',
    listCount: '{n} in all',
    listFiltered: '{n} shown',
    searchPlaceholder: 'Search by domain or CNAME',
    filterAllOwners: 'All owners',
    filterAllPackages: 'All packages',
    filterAllStatus: 'All statuses',
    filterAllSsl: 'All SSL modes',
    filterSuspended: 'Suspended',
    resetFilters: 'Reset',
    statTotal: 'Sites',
    statToday: 'Today +{n}',
    statActive: 'Active',
    statDraft: 'Provisioning',
    statDisabled: 'Disabled',
    statSuspended: '{n} suspended',
    statDraftNote: 'waiting on the customer\'s CNAME',
    siteCol: 'Site',
    createdAtCol: 'Created',
    updatedAtCol: 'Last changed',
    more: 'More',
    ssl_off: 'Off',
    ssl_flexible: 'Flexible',
    ssl_full: 'Full',
    ssl_strict: 'Full (strict)',
    ssl_force_https: 'Force HTTPS',
    sslHint_off: 'Visitors use plain HTTP only; the nodes do not listen on HTTPS.',
    sslHint_flexible: 'HTTPS from the visitor to the node, HTTP from the node to the origin. For an origin without a certificate.',
    sslHint_full: 'HTTPS end to end; the origin\'s certificate is not checked, so a self-signed one works.',
    sslHint_strict: 'HTTPS end to end, and the origin\'s certificate must be valid and match the origin Host.',
    sslHint_force_https: 'HTTPS end to end; plain HTTP requests are redirected with a 301. The origin\'s certificate is not checked.',
    proxy_proxy: 'Proxied',
    proxy_dns_only: 'DNS only',
    proxyHint_proxy: 'Traffic goes through the nodes: caching, protection rules and certificates apply there.',
    proxyHint_dns_only: 'Only the DNS record is kept; traffic reaches the origin directly and nothing on the nodes applies.',
    realIpHeaderHint: 'The nodes put the visitor\'s real IP in this header for the origin, which reads the client address from it.',
    hostCol: 'Hostname',
    hostTypeCol: 'Type',
    primaryTag: 'Primary',
    aliasTag: 'Alias',
    aliasCount: '{n} hostname(s)',
    hostVerifyCol: 'DNS check',
    hostVerified: 'Verified',
    hostPending: 'Pending',
    hostForced: 'Forced',
    hostForcedTip: 'An admin skipped the CNAME check',
    hostPendingTip: 'Point the CNAME of {host} at {target}. It is checked automatically; once changed, Verify checks it now.',
    hostPrimaryPendingTip: 'The main domain is verified under CNAME setup in Overview.',
    hostNoTargetTip: 'The site has no CNAME address yet, so it cannot be verified.',
    aliasVerify: 'Verify',
    aliasVerified: '{host} verified; the nodes now serve it',
    aliasVerifyMismatch: 'The CNAME does not point here yet',
    aliasVerifyFailed: 'Verification failed',
    aliasForceFailed: 'Could not force it',
    aliasForce: 'Force',
    aliasForceConfirm: 'Skip the CNAME check and serve {host} now? Make sure the domain really belongs to this customer.',
    aliasForced: '{host} is now served',
    addOrigin: 'Add origin',
    addOriginTitle: 'Add origin',
    originScheme: 'Scheme',
    originPort: 'Port',
    originWeight: 'Weight',
    originRole: 'Role',
    originPrimary: 'Primary',
    originBackup: 'Backup',
    originBackupLabel: 'Use as a backup origin',
    originBackupHint: 'Used only when every primary origin is unreachable.',
    originWeightHint: 'Requests are shared between primary origins by weight.',
    originSni: 'SNI',
    originAddrPlaceholder: 'IP or hostname, e.g. 10.0.0.8 or origin.example.com',
    originStatus_active: 'Enabled',
    originStatus_disabled: 'Disabled',
    originCount: '{n} origin(s)',
    basicSettings: 'Basic settings',
    facts: 'Details',
    switchCnameTitle: 'New CNAME',
    switchCnameChangedAdmin: 'The new package uses another line, so the CNAME of {name} is now {new}, queued for publication. The customer needs to point their DNS record at it; until then the old one, {old}, keeps working.',
    packageBound: 'Package changed',
    packageBindFailed: 'Could not change the package',
    noPackage: 'None',
    changePackage: 'Change',
    bindPackageTitle: 'Package for {name}',
    heldUntil: 'valid until {at}',
    noPackageHint: 'never suspended for an expiry; for internal or test sites',
    ownerHoldsNothing: 'The customer holds no package right now, so only "None" is possible.',
    goSubscriptions: 'Assign a package',
    bindPackageNote: 'Only packages the site\'s owner holds now can be chosen; assign another under Subscriptions first. If the new package uses another line, the site gets a new CNAME; the old one keeps working until the customer points their DNS at the new one.',
    suspended_plan_expired: 'Suspended: plan expired',
    suspended_traffic_exceeded: 'Suspended: traffic used up',
    suspended_requests_exceeded: 'Suspended: requests used up',
    suspendedTip: 'The customer\'s plan has expired and visitors see the "Plan expired" page. Service resumes within a minute of assigning the plan again; expiry handling is set under System → Default pages → Plan expired.',
    status_active: 'Active',
    status_draft: 'Draft',
    status_disabled: 'Disabled',
    navPerformance: 'Performance',
    navAnalytics: 'Analytics & logs',
    siteId: 'Site ID',
    sectionTitle_overview: 'Overview',
    sectionDesc_overview: 'How the site behaves: HTTPS redirect, SSL mode, protocol switches. Changes publish to every node automatically.',
    sectionTitle_domains: 'Domains',
    sectionDesc_domains: 'Several hostnames can share one configuration, including its origins, certificate and every protection rule.',
    'sectionTitle_cache-prefetch': 'Cache Prefetch',
    'sectionDesc_cache-prefetch': 'Pull content to the nodes ahead of time so the first visitor already gets a hit. Can run now or at a chosen time.',
    'sectionTitle_cache-jobs': 'Cache Purge',
    'sectionDesc_cache-jobs': 'Make the nodes discard what they have cached so the next request refetches it. Jobs are sent to every node.',
    sectionTitle_origins: 'Origins',
    sectionDesc_origins: 'Where requests are forwarded. Multiple origins are weighted; backups are used only when the primaries are unreachable.',
    sectionTitle_certificates: 'Certificates',
    sectionDesc_certificates: 'Issue or upload the HTTPS certificate. Automatic issuance is available from Let\'s Encrypt and ZeroSSL.',
    navBasics: 'Basics',
    navProtection: 'Protection',
    title: 'Sites',
    add: 'New site',
    addModalTitle: 'New site',
    addPlaceholder: 'e.g. cdn.example.com',
    nameLabel: 'Primary domain',
    nameCol: 'Primary domain',
    manage: 'Manage',
    detailTitle: 'Site detail',
    backToList: '← Back to sites',
    syncStatusLabel: 'Sync status',
    syncFailedTitle: 'Sync failed (retries exhausted — needs attention)',
    syncRetryingTitle: 'Sync failed, retrying (attempt {attempt}/{max})',
    syncNextRetry: 'Next retry: {at}',
    syncNodeCol: 'Node',
    syncAttemptCol: 'Attempts',
    syncErrorCol: 'Error',
    syncNow: 'Sync now',
    syncNodes: '{synced}/{total} nodes synced',
    syncState_never: 'Not synced',
    syncState_pending: 'Queued',
    syncState_syncing: 'Syncing',
    syncState_synced: 'Synced',
    syncState_failed: 'Sync failed',
    forceHttpsLabel: 'Force HTTPS',
    forceHttpsHint: 'Redirects plain HTTP requests to HTTPS with a 301. Certificate validation requests are exempt.',
    sectionOverview: 'Overview',
    sectionDomains: 'Domains',
    upstreamLimitTitle: 'Origin concurrency limit',
    upstreamLimitHelp: 'The most requests one node will have in flight to the origin at once. Anything beyond it is refused with 503 at the edge instead of being forwarded. This is the one protection that does not depend on a filter being right — however much traffic the edge absorbs, the origin never sees more than this at a time. 0 means no limit.',
    upstreamLimitOff: '0 = no limit',
    upstreamLimitOn: 'Currently capped at {n} concurrent origin requests per node; the rest get a 503 at the edge.',
    upstreamLimitOffHint: 'No limit: the edge forwards everything it receives, so origin load tracks attack volume. Set it from the origin\'s measured capacity.',
    sectionOrigins: 'Origins',
    sectionCertificates: 'Certificates',
    aliases: 'Aliases',
    aliasesHint: 'Every domain on a site shares its origin and rules. A new one is served once its CNAME points here and passes the check.',
    aliasHostnameCol: 'Domain',
    aliasesEmpty: 'No aliases yet',
    aliasesPlaceholder: 'e.g. www.example.com',
    aliasAdd: 'Add',
    aliasAddSuccess: 'Added',
    aliasAddFailed: 'Failed to add',
    ownerCol: 'Owner',
    cnameTargetCol: 'CNAME Target',
    statusCol: 'Status',
    sslCol: 'SSL',
    sslModeCol: 'SSL mode',
    proxyModeCol: 'Proxy mode',
    publishCol: 'Version',
    liveVersionCol: 'Live version',
    rules: 'Rules',
    origins: 'Origins',
    protocolsLabel: 'Protocols',
    realIpHeaderLabel: 'Real IP header',
    originAddr: 'Origin address',
    originHostHeader: 'Origin Host',
    originHostHeaderPlaceholder: 'Origin Host (empty: the site name)',
    originSniPlaceholder: 'SNI (empty: same as Origin Host)',
    originTlsHint: "For an HTTPS origin the certificate is checked only when the SSL mode is strict; otherwise a self-signed or IP certificate works. Origin Host is the Host header the origin receives — set it to the origin's own name for a virtual host or an object store.",
    originsEmpty: 'No origins yet',
    originAddSuccess: 'Origin added',
    originAddFailed: 'Failed to add origin',
    publish: 'Publish',
    publishSuccess: 'Published',
    publishedTo: 'Published {version} → {n} node(s)',
    publishedToPlain: 'Published {version}',
    saveFailed: 'Save failed',
    publishFailed: 'Publish failed',
    nameRequired: 'Pick an owner and enter a domain name',
    packageLabel: 'Package',
    packagePlaceholder: "Select the user's currently-active package",
    packageRequired: 'Please select a package',
    noActivePackageHint: 'This user has no active package',
    requestSSL: 'Request certificate',
    createSuccess: 'Site created',
    createFailed: 'Failed to create site',
    saveSuccess: 'Saved',
    deleteModalTitle: 'Delete site',
    deleteModalContent: 'Delete site "{name}"? This cannot be undone.',
    deleteSuccess: 'Deleted',
    deleteFailed: 'Delete failed',
    loadFailed: 'Failed to load sites',
    emptyHint: 'No sites yet',
    statusDraft: 'Provisioning',
    statusPendingVerify: 'Pending verify',
    statusActive: 'Active',
    statusPaused: 'Paused',
    statusDisabled: 'Disabled',
    disable: 'Disable',
    enable: 'Enable',
    disableConfirmTitle: 'Disable site',
    disableConfirmContent: 'Disable "{name}"? Nodes will stop proxying traffic for this domain.',
    disableSuccess: 'Disabled',
    disableFailed: 'Disable failed',
    enableSuccess: 'Enabled',
    enableFailed: 'Enable failed',
    notInPackage: 'Not in package',
    hostnameQuota: 'Package hostnames {used} / {max}',
    apexQuota: 'Apex domains {used} / {max}',
    notInPackageTipOps: 'This site’s package “{package}” does not include {feature}: it can be set, but does not apply.',
  },
  rules: {
    customRules: 'Custom rules',
    ruleCount: '{n} in all',
    kindDesc_acl: 'Allow or block by IP, network, region, ASN, user-agent or TLS fingerprint. An explicit allow wins over every other rule.',
    kindDesc_geo: 'Block, challenge or allow visitors by their country or region. Runs before the other protection rules.',
    kindDesc_cc: 'Rate limiting. When one source exceeds the threshold within the window it can be throttled, blocked, challenged or banned.',
    kindDesc_waf: 'Matches SQL injection, XSS and command execution signatures. Hits accumulate a score and only block past the site threshold, so one false match cannot take a site down.',
    kindDesc_bot: 'Catches crawlers impersonating search engines, and known scanners. Genuine spiders pass via reverse-DNS verification.',
    kindDesc_cache: 'Match by suffix, directory, path or status code, and set how long the nodes cache it and whether to force caching.',
    backToDomain: 'Back to site',
    title: 'Rules',
    backToDomains: '← Back to sites',
    pageTitle: 'Site #{id} — rules',
    selectKind: 'Select rule kind',
    kindAcl: 'Access control',
    kindGeo: 'Region block',
    kindWaf: 'WAF',
    kindCc: 'CC protection',
    kindBot: 'Bot',
    kindCache: 'Cache Rules',
    add: 'New rule',
    publish: 'Publish',
    priority: 'Priority',
    priorityHint: 'Lower numbers run first.',
    enabledHint: 'This rule is active and will be applied on the next publish.',
    disabledHint: 'This rule is saved but will not be applied.',
    action: 'Action',
    typeCol: 'Type',
    categoryCol: 'Category',
    statusCol: 'Status',
    addModalTitle: 'New {kind} rule',
    editModalTitle: 'Edit {kind} rule',
    deleteModalTitle: 'Delete rule?',
    deleteModalContent: 'Rule #{id} ({name}) will be removed. Republish the domain to apply on edge.',
    deleteConfirm: 'Delete this rule?',
    deleteSuccess: 'Deleted',
    deleteFailed: 'Delete failed',
    addSuccess: 'Rule added',
    addFailed: 'Failed to add',
    updateSuccess: 'Rule updated',
    validationFailed: 'Please fix the highlighted fields',
    loadFailed: 'Failed to load rules',
    invalidJson: 'Invalid JSON',
    publishedTo: 'Published {version} → {n} node(s)',
    publishedToPlain: 'Published {version}',
    publishFailed: 'Publish failed',
    emptyHint: 'No rules yet — click New rule to create one.',
    actions: {
      allow: 'Allow',
      log: 'Log only',
      rate_limit429: 'Rate limit (429)',
      challenge_js: 'JS challenge',
      challenge_slider: 'Slider challenge',
      challenge_click: 'Click challenge',
      deny403: 'Block (403)',
      deny444: 'Block (444, silent)',
      ban: 'Ban IP',
      deny: 'Deny (custom status)',
      ban_kernel: 'Kernel ban',
    },
    acl: {
      matchCol: 'Match',
      namePlaceholder: 'e.g. block-known-scanners',
      types: {
        ip: 'IP address',
        cidr: 'IP range (CIDR)',
        geo: 'Country',
        asn: 'ASN',
        ua: 'User-Agent',
        referer: 'Referer',
        header: 'Request header',
        ja4: 'JA4 fingerprint',
        ja3: 'JA3 fingerprint',
      },
      matchValues: 'Values',
      matchCountries: 'Countries',
      matchAsn: 'ASN numbers',
      matchContains: 'Contains (case-insensitive)',
      headerName: 'Header name',
      placeholderIp: 'e.g. 203.0.113.7 — press Enter to add',
      placeholderCidr: 'e.g. 203.0.113.0/24 — press Enter to add',
      placeholderCountry: 'e.g. CN, US — press Enter to add',
      placeholderAsn: 'e.g. 13335 — press Enter to add',
      placeholderSubstring: 'e.g. curl/ — press Enter to add',
      placeholderJa4: 'e.g. t13d1516h2_8daaf6152771_02713d6af862 — press Enter to add',
      placeholderJa3: 'e.g. 773906b0efdefa24a7f2b8eb6985bf37 — press Enter to add',
      fingerprintHint: 'The TLS client fingerprint, matched exactly as the access log shows it (case aside). Plain-HTTP requests have none and never match.',
    },
    cc: {
      namePlaceholder: 'e.g. login-bruteforce',
      matchTitle: 'Match',
      methods: 'Methods',
      methodsPlaceholder: 'Any',
      path: 'Path',
      pathPlaceholder: 'Leave empty for every path, e.g. /api/login',
      pathModes: { prefix: 'Starts with', exact: 'Equals', contains: 'Contains' },
      countStatus: 'Count only responses with status',
      countStatusPlaceholder: 'e.g. 401,403 or 5xx; empty counts every request',
      countStatusHint: 'Counts only requests answered with these statuses. Use 401,403 against credential stuffing, 404 against path scanning.',
      countTitle: 'Counting',
      dimensions: 'Count by',
      dimensionsHint: 'Requests are grouped by these fields before counting, up to 3. IP + path counts each visitor separately per endpoint; a header gives each API key its own limit.',
      fingerprintHint: 'Every copy of one browser version has the same TLS fingerprint, so counting by fingerprint alone counts all of them as one client. Use it for scripts and tools with fingerprints of their own, or together with the path. Plain-HTTP requests have no fingerprint and are counted together. Chrome changes its JA3 on every connection; prefer JA4.',
      dims: {
        ip: 'Client IP',
        uri: 'Request path',
        ua: 'User-Agent',
        host: 'Hostname',
        ja4: 'TLS fingerprint (JA4)',
        ja3: 'TLS fingerprint (JA3)',
        country: 'Country/region',
        header: 'Request header',
        cookie: 'Cookie',
      },
      dimNamePlaceholder_header: 'Header name, e.g. X-Api-Key',
      dimNamePlaceholder_cookie: 'Cookie name, e.g. session_id',
      addDimension: '+ Add dimension',
      windowSeconds: 'Period (s)',
      threshold: 'Requests',
      thresholdCol: 'Limit / period',
      matchCol: 'Match',
      anyRequest: 'All requests',
      statusOnly: 'only {status}',
      actionTitle: 'Action',
      statusCode: 'Response status',
      mitigation: 'Mitigation',
      mitigations: { throttle: 'Throttle', penalty: 'Penalty' },
      mitigationHint_throttle: 'Only the requests over the limit get the action; traffic recovers as soon as the rate drops.',
      mitigationHint_penalty: 'Once tripped, every request from the source gets the action for the whole duration.',
      ttlSeconds: 'Duration (s)',
      ttlHint: 'How long a passed challenge is remembered, or how long the ban or penalty lasts.',
      escalationTitle: 'Escalation (optional)',
      addTier: '+ Add tier',
      escalationHint: 'A source that keeps tripping the rule gets a harsher action after this many violations, up to 5 tiers.',
      escalationEmpty: 'None: every violation gets the action above.',
      afterViolations: 'After',
      thenAction: 'violations, escalate to',
      forSeconds: 'for (s)',
    },
    waf: {
      namePlaceholder: 'e.g. block-sqlmap-signature',
      categories: {
        sqli: 'SQL injection',
        xss: 'Cross-site scripting',
        rce: 'Remote code execution',
        traversal: 'Path traversal',
        scanner: 'Scanner / recon',
        webshell: 'Webshell',
        custom: 'Custom',
      },
      targets: 'Inspect',
      targetsCol: 'Inspects',
      targetsPlaceholder: 'Select one or more',
      targetLabels: { uri: 'URL path', args: 'Query string', cookie: 'Cookie header', method: 'HTTP method' },
      alsoInspectHeader: 'Also inspect a specific request header',
      pattern: 'Pattern (regex)',
      patternHint: 'Matched case-insensitively against every selected target.',
      score: 'Score',
      scoreHint: 'Added to the domain\'s running total when this rule matches; the request is blocked once the total crosses the WAF threshold.',
    },
    bot: {
      namePlaceholder: 'e.g. block-scraping-tool',
      matchMode: 'Match mode',
      modeSimple: 'Contains (simple)',
      modeAdvanced: 'Regex (advanced)',
      uaContains: 'User-Agent contains',
      uaContainsHint: 'Case-insensitive substring match — no regex syntax needed.',
      uaRegex: 'User-Agent regex',
      uaRegexHint: 'Full regular expression, matched case-insensitively.',
      patternCol: 'Pattern',
    },
    cache: {
      matchCol: 'Match',
      matchSuffix: 'File extensions',
      matchDir: 'Path prefixes',
      matchUri: 'Exact paths',
      matchStatus: 'Status codes',
      ttlSeconds: 'TTL (seconds)',
      forceCache: 'Force cache (ignore origin cache headers)',
      bypassCookies: 'Bypass on cookie names',
      varyQuery: 'Vary cache key by query params',
    },
    notInPackage_waf: 'Your package “{package}” does not include WAF: no WAF rule runs on this site, the built-in ones included, and none can be added or changed. On a package with WAF the rules below take effect again.',
    notInPackageOps_waf: 'This site’s package “{package}” does not include WAF: the nodes run none of its WAF rules, the built-in ones included. The rules below are kept and take effect when the site moves to a package with WAF.',
    notInPackage_cc: 'Your package “{package}” does not include custom CC rules: the protection level and forced verification above still apply; the rules below do not, and none can be added or changed.',
    notInPackageOps_cc: 'This site’s package “{package}” does not include custom CC rules: the rules below are kept but do not apply; the protection level and forced verification still do.',
    notInPackageShort: 'Not included in your package',
    quotaUsed: 'Rules {used} / {max}',
    quotaFull: 'Your package allows {max} rules per site, all in use',
  },

  // What keeps a site from being served properly (SiteReadiness.vue,
  // utils/readiness.ts).
  readiness: {
    noOrigin: 'No origin yet: every request is answered with a 502 (Bad gateway).',
    noCert: 'No usable certificate for {hosts}: HTTPS fails outright, and browsers report an unsupported protocol.',
    certMismatch: 'Certificate does not match {hosts}: browsers warn that the connection is not secure.',
    addOrigin: 'Add origin',
    getCert: 'Get certificate',
    changeCert: 'Change certificate',
    nameSep: ', ',
    andMore: '{names} and {n} more',
    shortNoOrigin: 'No origin',
    shortNoCert: 'No certificate',
    shortMismatch: 'Certificate mismatch',
    aliasPending: 'CNAME not verified yet for {hosts}: not served until it is.',
    verifyAlias: 'Verify',
    shortAliasPending: 'Alias pending',
    listHint: 'This site cannot be served properly yet',
  },
  domainDetail: {
    back: '← Back',
    overview: 'Overview',
    rules: 'Rules',
    origins: 'Origins',
    certificates: 'Certificates',
    addOrigin: 'Add origin',
    issueCert: 'Issue certificate',
    cnameGenerating: 'Generating…',
  },
  siteCerts: {
    daysLeft: '{n} days left',
    expiresToday: 'expires today',
    expiredDays: 'expired {n} days ago',
    hostCount: '{n} hostname(s)',
    intro: 'Each hostname can have its own certificate. Free certificates are issued and renewed by the platform; custom certificates are uploaded on the certificates page and replaced by you before they expire.',
    applyFree: 'Apply for free certificate',
    blockedUnverified: 'A certificate can be requested once the domain passes its CNAME check',
    blockedSiteOff: 'The site is disabled; no certificate can be requested',
    useExisting: 'Use existing certificate',
    hostCol: 'Hostname',
    certCol: 'Certificate',
    typeCol: 'Type',
    statusCol: 'Status',
    expiresCol: 'Expires',
    primary: 'primary',
    typeFree: 'Free',
    typeCustom: 'Custom',
    stateOk: 'OK',
    stateExpiring: 'Expiring soon',
    stateExpired: 'Expired',
    stateMismatch: 'Mismatch',
    stateNone: 'Not configured',
    issuing: 'Issuing',
    issueFailed: 'Issuance failed',
    issueCancelled: 'Issuance cancelled',
    issuingAttempt: 'Issuing (attempt {n}/{max})',
    nextRun: 'Next retry: {t}',
    retryNow: 'Retry now',
    apply: 'Apply',
    change: 'Change',
    choose: 'Choose',
    unbind: 'Unbind',
    unbindTitle: 'Unbind certificate',
    unbindContent: '{host} will fall back to the site\'s newest certificate that covers it; without one, HTTPS will stop working for it.',
    issuer: 'Issuer',
    validity: 'Valid',
    algorithm: 'Algorithm',
    source: 'Source',
    source_bound: 'Chosen',
    source_auto: 'Automatic (the site\'s newest certificate covering this hostname)',
    source_fallback: 'Nothing covers this hostname; the site\'s newest certificate is served for now',
    source_none: '—',
    mismatchHint: 'No certificate covers {host}, so the nodes answer with another of the site\'s certificates and browsers show an error. Apply for or choose one for it.',
    noCert: 'No certificate yet — apply for one or choose an existing one',
    pickHost: 'Choose a hostname',
    pickCert: 'Choose a certificate',
    bindHint: 'Only valid certificates that cover this hostname are listed. Certificates are uploaded on the certificates page.',
    noBindable: 'No valid certificate covers this hostname',
    bound: 'Applied',
    issueQueued: 'Queued — the status appears in the table',
    issueQueueHint: 'Issuance runs in the background queue; you can close this dialog. A failure\'s reason shows in that hostname\'s expanded row.',
    notInPackage: 'Uploads not in package',
  },
  certificates: {
    stateCancelled: 'Cancelled',
    attachTitle: 'Use an existing certificate',
    issueCancelled: 'Cancelled',
    issueRetryNow: 'Retry now',
    uploadMoved: 'Upload certificates on the certificates page:',
    attachSuccess: 'Applied to this site',
    attachPlaceholder: 'Pick an existing certificate',
    attach: 'Use this certificate',
    pemRequired: 'Both the certificate and the key are required',
    siteRequired: 'Choose a site',
    sitePlaceholder: 'Choose a site',
    siteHint: 'The certificate is bound to this site and pushed to the nodes. It can be re-pointed at another site from that site\'s page.',
    siteLabel: 'Apply to site',
    noSite: 'unassigned',
    siteCol: 'Site',
    emailHint: 'Used to register with the CA and receive expiry notices. Requesting a certificate accepts that CA\'s terms of service.',
    stateNextRun: 'Next retry: {t}',
    stateFailed: 'Issuance failed',
    stateSuccess: 'Certificate issued',
    statePending: 'Issuing… (attempt {n}/{max})',
    issueRetry: 'Request again',
    issueQueueHint: 'Issuance runs in the background queue; you can leave this page. Failures are shown above, and an operator can read every attempt in Task Queue → System tasks.',
    issueQueued: 'Queued — the result appears above',
    title: 'Certificates',
    sectionTitle: 'Certificate management',
    domain: 'Domain',
    typeUpload: 'Upload',
    typeAcme: 'ACME',
    commonNameCol: 'Common name',
    issuerCol: 'Issuer',
    notBeforeCol: 'Not before',
    notAfterCol: 'Not after',
    statusCol: 'Status',
    fingerprintCol: 'Fingerprint',
    expiringDays: 'Expires in {n} day(s)',
    expired: 'Expired',
    issueAcme: 'Request via ACME',
    emailLabel: 'Email',
    emailRequired: 'Email is required',
    caLabel: 'Certificate authority',
    issueFailed: 'Failed to issue certificate',
    uploadCert: 'Upload certificate',
    uploadSuccess: 'Certificate uploaded',
    uploadFailed: 'Failed to upload certificate',
    refresh: 'Refresh',
    empty: 'No certificates for this domain yet',
    aboutExpire: 'Expiring soon',
    statTotal: 'Certificates',
    statValid: 'Valid',
    statExpiring: 'Expiring',
    statExpiringNote: 'within {n} days',
    statExpired: 'Expired',
    statRevoked: '{n} revoked',
    listTitle: 'All certificates',
    listCount: '{n} in all',
    listFiltered: '{n} shown',
    searchPlaceholder: 'Search names or issuer',
    filterAllSites: 'All sites',
    filterAllTypes: 'All types',
    filterAllStatus: 'All statuses',
    state_valid: 'Valid',
    state_expiring: 'Expiring',
    state_expired: 'Expired',
    state_revoked: 'Revoked',
    certCol: 'Certificate',
    moreNames: '+{n} more',
    typeCol: 'Type',
    expiresCol: 'Expires',
    emptyHint: 'No certificates yet. Get a free one on a site\'s SSL pane, or upload one here.',
    certPem: 'Certificate (PEM)',
    certPemHint: 'The server certificate first, then the intermediates: the whole chain.',
    keyPem: 'Private key (PEM)',
    keyPemHint: 'Stored encrypted; used only for the HTTPS handshake on the nodes.',
    filterAllOwners: 'All customers',
  },
  lineDns: {
    linesUnavailableTitle: 'Could not read the lines this access domain supports',
    showDetail: 'Show the full error',
    hideDetail: 'Hide',
    poolDown: 'No usable address',
    poolDownHint: 'No usable address on this line: its records stay as they are until an address recovers.',
    poolEmpty: 'No address',
    ttlSeconds: '{n}s',
    plan: 'DNS plan',
    boundSummary: '{total} in all · {usable} usable',
    candidatesSummary: '{n} in all',
    checkedCount: '{n} selected',
    pickPoolFirst: 'Pick a line on the right first',
    poolsSummary: '{n} in all',
    poolLive: '{live}/{total} in DNS',
    manageNodes: 'Manage nodes',
    nodeOk: 'ok',
    group_other: 'Other lines',
    group_search: 'Search engines',
    group_region: 'Region',
    group_isp: 'ISP',
    group_default: 'Default',
    calibrateQueued: 'Calibrating — see Task Queue → System tasks for the result',
    calibrateHint: 'Check the DNS records against this configuration and fix them. Not normally needed — every edit applies on its own; this is for drift caused outside the console or a write that failed.',
    calibrate: 'Calibrate',
    back: 'Back to line groups',
    intro: 'Which node addresses this line group returns on each ISP line. Pick addresses on the left, put them on a line on the right — every edit applies immediately, no publish step.',
    zone: 'CNAME domain',
    loadFailed: 'Failed to load',
    saved: 'Saved — republishing',
    noResolveValue: 'This line group has no resolve value yet. Set one, and a CNAME domain, on the line group first.',
    noPoolsHint: 'No line pools yet. For now every usable member address is published on the group\'s own line; once you add a pool, the pools decide.',
    linesUnavailable: 'Could not read the lines this CNAME domain supports:',
    boundNodes: 'Bound nodes',
    noNodes: 'No nodes bound to this line group',
    stale: 'no heartbeat',
    candidates: 'Addresses to assign',
    noCandidates: 'No addresses left to add',
    alreadyInLines: 'in {n} line(s)',
    notUsable: 'not usable',
    addAsPrimary: 'Add as primary',
    addAsBackup: 'Add as standby',
    pools: 'Line pools',
    addPool: 'New line pool',
    noPools: 'No line pools yet',
    poolSummary: '{live} live of {total}',
    off: 'disabled',
    onBackup: 'on standby',
    poolDetail: 'Line “{line}” · records',
    disablePool: 'Disable line',
    enablePool: 'Enable line',
    deletePool: 'Delete pool',
    poolOffHint: 'This line is disabled; its records are removed on the next publish.',
    failoverHint: 'No usable primary address on this line — the standby addresses have taken over.',
    deletePoolTitle: 'Delete line pool',
    deletePoolContent: 'Delete the {line} pool? Its DNS records are removed too.',
    poolAdded: 'Line pool created',
    poolDeleted: 'Line pool deleted',
    noPoolSelected: 'Select a line pool first',
    pickAddress: 'Select the addresses to add',
    addressesAdded: 'Added',
    ipCol: 'Address',
    nodeCol: 'Node',
    manualIP: 'added by hand',
    roleCol: 'Role',
    primary: 'Primary',
    backup: 'Standby',
    stateCol: 'State',
    live: 'in DNS',
    paused: 'paused',
    nodeDown: 'node down',
    standby: 'waiting',
    makeBackup: 'Make standby',
    makePrimary: 'Make primary',
    pause: 'Pause',
    resume: 'Resume',
    removeMemberTitle: 'Remove address',
    removeMemberContent: 'Remove {ip} from this line?',
    memberRemoved: 'Removed',
    noMembers: 'No addresses on this line yet — pick some on the left',
    line: 'Resolve line',
    lineHint: 'Only the lines this CNAME domain\'s DNS plan supports, filed the way the DNS console files them: default, ISP, region, search engines.',
    pickLine: 'Choose a resolve line',
    publishQueued: 'Queued',
  },
  lineGroups: {
    unit: 'groups',
    statTotal: 'Line groups',
    statOk: 'Healthy',
    statAbnormal: 'Unhealthy',
    statUnset: 'Not set up',
    statLines: '{n} resolve lines',
    statDown: '{n} with no usable node',
    health_ok: 'Healthy',
    health_degraded: 'Degraded',
    health_down: 'Down',
    health_unset: 'Not set up',
    listTitle: 'All line groups',
    listCount: '{n} in all',
    listFiltered: '{n} shown',
    searchPlaceholder: 'Search name, description or resolve value',
    filterAllStatus: 'All statuses',
    filterAllZones: 'All access domains',
    filterAbnormal: 'Unhealthy (degraded or down)',
    resetFilters: 'Reset',
    groupCol: 'Line group',
    nodesCol: 'Nodes',
    nodesUsable: '{usable}/{total} usable',
    nodesNone: 'None bound',
    linesCol: 'Lines',
    linesCount: '{n} line(s)',
    linesDisabled: '{n} off',
    linesDefault: 'Group line',
    linesDefaultTip: 'No line pools yet: every usable node address is published on the group\'s own line ({line}).',
    statusCol: 'Status',
    more: 'More',
    deleteGroup: 'Delete line group',
    emptyHint: 'No line groups yet',
    membersSelected: '{n} selected',
    membersSearch: 'Search by node name or IP',
    membersNoMatch: 'No node matches',
    nodeState_usable: 'Usable',
    nodeState_stale: 'No heartbeat',
    nodeState_pending: 'Pending init',
    nodeState_off: 'Disabled',
    publishResolve: 'Calibrate DNS',
    publishQueued: 'Calibrating — see Task Queue → System tasks for the result',
    publishAlreadyQueued: 'A calibration is already queued for this line',
    publishFailed: 'Could not queue the publish',
    title: 'Line Groups',
    add: 'New Line Group',
    nameCol: 'Name',
    descCol: 'Description',
    memberCountCol: 'Nodes',
    zoneCol: 'Access domain',
    zoneHint: 'The resolve value lives under this base domain. Manage domains on the Access domains page.',
    zonePlaceholder: 'Pick an access domain',
    noZonesHint: 'No access domains yet — add one on the Access domains page first',
    zoneRequired: 'Pick an access domain',
    resolveValueRequired: 'Resolve value is required',
    resolveLabelPlaceholder: 'e.g. line1',
    resolveLabelInvalid: 'Only letters, digits and hyphens are allowed',
    resolvePreview: 'Full resolve value: ',
    resolveValueRandom: 'Generate',
    resolveValueNotUnderZone: 'The resolve value must be a subdomain of {domain}',
    pickZoneFirst: 'Pick an access domain first',
    resolveValueCol: 'Resolve value',
    resolveValueHint: 'The hostname this line resolves to; customer sites CNAME here. Leave empty if none is assigned yet.',
    resolveValuePlaceholder: 'e.g. line1.niaodns.com',
    manageMembers: 'Bind nodes',
    addModalTitle: 'New Line Group',
    editModalTitle: 'Edit Line Group',
    namePlaceholder: 'e.g. Line 1',
    descPlaceholder: 'Optional',
    deleteModalTitle: 'Delete Line Group',
    deleteModalContent: 'Delete line group "{name}"?',
    loadFailed: 'Failed to load line groups',
    addSuccess: 'Created',
    addFailed: 'Create failed',
    updateSuccess: 'Updated',
    updateFailed: 'Update failed',
    deleteSuccess: 'Deleted',
    deleteFailed: 'Delete failed',
    membersModalTitle: 'Bind nodes - {name}',
    membersHint: 'Check the nodes to bind to this line group. One node can be bound to several groups.',
    noNodesHint: 'No nodes yet — add one on the Nodes page first',
    saveMembersSuccess: 'Node bindings updated',
    saveMembersFailed: 'Failed to update node bindings',
    records: {
      manage: 'Manage DNS',
    },
  },
  cnameZones: {
    ttlCol: 'TTL',
    ttlHint: 'Every record the platform publishes under this domain (site CNAMEs, line A records) uses this TTL. Alidns\' free plan floor is 600 seconds.',
    ttlHintPlan: 'The {plan} plan accepts a minimum of {min} seconds. Every record the platform publishes under this domain uses this TTL.',
    ttlRange: 'TTL must be between {min} and {max} seconds',
    intro: 'Access domains are base domains this platform owns; customer sites CNAME into them. A line group\'s resolve value must be a subdomain of one of these.',
    add: 'Add access domain',
    addModalTitle: 'Add access domain',
    editModalTitle: 'Edit access domain',
    deleteModalTitle: 'Delete access domain',
    deleteModalContent: 'Delete "{name}"? It cannot be removed while line groups still use it.',
    domainCol: 'Base domain',
    providerCol: 'DNS account',
    remarkCol: 'Remark',
    statusCol: 'Status',
    statusActive: 'Active',
    statusDisabled: 'Disabled',
    groupCountCol: 'Line groups',
    domainHint: 'The base domain only, e.g. niaodns.com — line groups get subdomains of it.',
    domainPlaceholder: 'e.g. niaodns.com',
    providerHint: 'The DNS account that can write records under this domain.',
    providerPlaceholder: 'Pick a DNS account',
    remarkPlaceholder: 'Optional',
    searchPlaceholder: 'Search domain or remark',
    domainInvalid: 'Enter a valid domain — no scheme, path or port',
    domainNotApex: 'Enter the base domain only (e.g. niaodns.com), not a subdomain of it',
    providerRequired: 'Pick a DNS account',
    empty: 'No access domains yet — add one first',
    noProvidersHint: 'No DNS accounts yet. Add one on the DNS providers page first.',
    addSuccess: 'Added',
    updateSuccess: 'Updated',
    addFailed: 'Save failed',
    deleteFailed: 'Delete failed',
  },
  dnsProviders: {
    title: 'DNS Providers',
    add: 'Add DNS Provider',
    typeCol: 'Type',
    nameCol: 'Name',
    akPreviewCol: 'Key Preview',
    statusCol: 'Status',
    createdAtCol: 'Created',
    addModalTitle: 'Add DNS Provider',
    editModalTitle: 'Edit DNS Provider',
    keepUnchangedPlaceholder: 'Leave blank to keep unchanged',
    type: 'Provider Type',
    typeAliyun: 'Alibaba Cloud',
    typeTencent: 'Tencent Cloud',
    typeCloudflare: 'Cloudflare',
    comingSoon: 'Coming soon',
    name: 'Name',
    namePlaceholder: 'e.g. Main account',
    accessKey: 'Access Key',
    accessSecret: 'Access Secret',
    accessKeyPlaceholder: 'Enter Access Key',
    accessSecretPlaceholder: 'Enter Access Secret',
    encryptionHint: 'Credentials are encrypted at rest with AES-256-GCM; only a preview is ever shown, the plaintext is never echoed back.',
    deleteModalTitle: 'Delete DNS Provider',
    deleteModalContent: 'Delete "{name}"? Any DNS lines using it will fail to sync.',
    loadFailed: 'Failed to load DNS providers',
    addSuccess: 'Added',
    addFailed: 'Add failed',
    updateSuccess: 'Updated',
    deleteSuccess: 'Deleted',
    deleteFailed: 'Delete failed',
    emptyHint: 'No DNS providers yet',
    test: 'Connectivity check',
    testSuccess: 'Connected — credentials are valid',
    testFailed: 'Test failed',
    testFailedWithReason: 'Test failed: {reason}',
  },
  regions: {
    intro: 'A region is just a label for grouping nodes by location. What DNS actually resolves to is decided by line groups.',
    add: 'New region',
    addModalTitle: 'New region',
    editModalTitle: 'Edit region',
    deleteModalTitle: 'Delete region',
    deleteModalContent: 'Delete region "{name}"?',
    codeCol: 'Code',
    nameCol: 'Name',
    remarkCol: 'Remark',
    nodeCountCol: 'Nodes',
    codeHint: 'This is the code a node reports when it registers. It can be changed even while nodes use it — confirm, and those nodes move to the new code with it.',
    codePlaceholder: 'e.g. cn-east',
    namePlaceholder: 'e.g. East China',
    remarkPlaceholder: 'Optional',
    codeInvalid: 'Code must be 1-32 characters of letters, digits, hyphen or underscore',
    updateSuccessMoved: 'Saved — {count} node(s) moved to the new code',
    migrateModalTitle: 'Change the region code?',
    migrateConfirm: 'Move them',
    searchPlaceholder: 'Search code, name or remark',
    empty: 'No regions yet — create one to group your nodes',
    addSuccess: 'Region created',
    updateSuccess: 'Region updated',
    addFailed: 'Save failed',
    deleteFailed: 'Delete failed',
  },
  userGroups: {
    title: 'User Groups',
    add: 'New Group',
    nameCol: 'Name',
    descCol: 'Description',
    memberCountCol: 'Users',
    addModalTitle: 'New User Group',
    editModalTitle: 'Edit User Group',
    namePlaceholder: 'e.g. VIP Customers',
    descPlaceholder: 'Optional',
    deleteModalTitle: 'Delete User Group',
    deleteModalContent: 'Delete group "{name}"?',
    loadFailed: 'Failed to load user groups',
    addSuccess: 'Created',
    addFailed: 'Create failed',
    updateSuccess: 'Updated',
    deleteSuccess: 'Deleted',
    deleteFailed: 'Delete failed',
  },
  users: {
    add: 'New User',
    pfAddress: 'Mailing address',
    pfBackup: 'Backup contact',
    pfCompany: 'Company',
    pfIndustry: 'Industry',
    pfIndustry_ecommerce: 'E-commerce',
    pfIndustry_education: 'Education',
    pfIndustry_finance: 'Finance',
    pfIndustry_gaming: 'Gaming',
    pfIndustry_government: 'Government / public',
    pfIndustry_healthcare: 'Healthcare',
    pfIndustry_internet: 'Internet / software',
    pfIndustry_manufacturing: 'Manufacturing',
    pfIndustry_media: 'Video / live / media',
    pfIndustry_other: 'Other',
    pfNever: 'The customer has not filled in a profile yet',
    pfCountry: 'Country or region',
    pfNickname: 'Nickname',
    pfTeam: 'Team size',
    pfTeam_1000plus: '1000+',
    pfTeam_10_49: '10–49',
    pfTeam_1_9: '1–9',
    pfTeam_200_999: '200–999',
    pfTeam_50_199: '50–199',
    pfUpdated: 'Updated by the customer {time}',
    pfUsage: 'Sites are for',
    pfWechat: 'WeChat ID',
    searchPlaceholder: 'Search username / email / phone',
    filterStatus: 'Account Status',
    tabProfile: 'Profile',
    usernameCol: 'Username',
    emailCol: 'Email',
    phoneCol: 'Phone',
    groupCol: 'User Group',
    vipCol: 'VIP',
    lvCol: 'Level',
    vipOnly: 'VIP only',
    vipCellTip: '{n} growth points · click to change',
    lvCellTip: '{n} EXP · click to change',
    memberField: 'Level & VIP',
    memberAdjust: 'Change',
    statusCol: 'Status',
    realnameCol: 'Real-name',
    remark: 'Remark',
    qq: 'QQ Number',
    country: 'Country',
    addModalTitle: 'New User',
    editModalTitle: 'Edit User',
    tabBasic: 'Basic Info',
    tabSecurity: 'Security',
    tabRealname: 'Real-name Verification',
    password: 'Login Password',
    passwordKeepHint: 'Leave blank to keep unchanged',
    passwordRequiredHint: 'A login password is required to create a user',
    operationPassword: 'Operation Password',
    operationPasswordHint: 'A second password confirming sensitive actions, independent of the login password',
    securityQuestion: 'Security Question',
    securityAnswer: 'Security Answer',
    realnameType: 'Verification Type',
    realnameStatus: 'Verification Status',
    realName: 'Full Name',
    enterpriseName: 'Company Name',
    idCardNumber: 'ID Card Number',
    socialCreditCode: 'Unified Social Credit Code',
    currentPreview: 'Current',
    idCardEncryptionHint: 'ID card number / social credit code are encrypted at rest (AES-256-GCM) and shown masked; admins can show the full number, and every look goes into the audit log.',
    statusActive: 'Active',
    statusBanned: 'Banned',
    statusClosed: 'Closed',
    statusDisabled: 'Disabled',
    statusLocked: 'Locked',
    realnameUnverified: 'Unverified',
    realnamePending: 'Pending',
    realnameVerified: 'Verified',
    realnameRejected: 'Rejected',
    realnameIndividual: 'Individual',
    realnameEnterprise: 'Enterprise',
    deleteModalTitle: 'Delete User',
    deleteModalContent: 'Delete user "{name}"? This cannot be undone.',
    loadFailed: 'Failed to load users',
    addSuccess: 'Created',
    addFailed: 'Create failed',
    updateSuccess: 'Updated',
    deleteSuccess: 'Deleted',
    deleteFailed: 'Delete failed',
    emptyHint: 'No users yet',
    mfaOn: 'Bound {time}. Reset it if the customer has lost the device.',
    mfaOff: 'Not bound',
    resetMfa: 'Reset MFA',
    resetMfaTitle: 'Reset MFA device',
    resetMfaConfirm: 'Unbind the MFA device of {name}? Their sign-in then takes only the password, and they can bind a device again in the Security Center. Make sure the request is really theirs.',
    resetMfaDone: 'MFA device reset',
    sessions: 'Sessions',
    sessionsDesc: 'If the customer thinks the account is in other hands, end every session it has at once.',
    endSessions: 'Sign out everywhere',
    endSessionsTitle: 'Sign out everywhere',
    endSessionsConfirm: 'Every session of {name}, on every device, ends at once and must sign in again. Continue?',
    endSessionsDone: 'Signed out everywhere',
    actionFailed: 'Action failed',
    phoneProof: 'Phone',
    phoneNone: 'Not set',
    phoneProved: 'Verified by text ({time}): it protects sign-in and resets the password.',
    phoneUnproved: 'Not verified. Once the customer verifies it in the Security Center, it can protect sign-in and reset the password.',
    loginSms: 'Text sign-in protection',
    loginSmsOn: 'On: signing in asks for a texted code. Turn it off if the customer can no longer receive texts at that number.',
    loginSmsOff: 'Off',
    resetLoginSms: 'Turn off',
    resetLoginSmsTitle: 'Turn off text sign-in protection',
    resetLoginSmsConfirm: 'Turn off text sign-in protection for {name}? Their sign-in then takes only the password. Make sure the request is really theirs.',
    resetLoginSmsDone: 'Text sign-in protection off',
  },
  packageGroups: {
    nameRequired: 'A group name is required',
    add: 'New group',
    nameCol: 'Name',
    descCol: 'Description',
    countCol: 'Packages',
    namePlaceholder: 'e.g. Retail',
    descPlaceholder: 'Optional',
    addModalTitle: 'New package group',
    editModalTitle: 'Edit package group',
    deleteModalTitle: 'Delete package group',
    deleteModalContent: 'Delete the group “{name}”? A group with packages in it cannot be deleted.',
    addSuccess: 'Group created',
    updateSuccess: 'Group saved',
    deleteSuccess: 'Group deleted',
    saveFailed: 'Save failed',
    deleteFailed: 'Delete failed',
    empty: 'No groups yet',
    hint: 'A group is just a label for filing packages so the list stays readable. Quotas, pricing and entitlements are still decided by the package itself.',
  },
  payment: {
    title: 'Payment settings',
    figAlipay: 'Alipay',
    state_ready: 'Enabled',
    state_incomplete: 'Incomplete',
    state_off: 'Off',
    noAppId: 'No AppID yet',
    figProducts: 'Products',
    productShort_page: 'Web',
    productShort_wap: 'Mobile',
    productShort_qr: 'QR code',
    noProducts: 'None turned on',
    figMode: 'Signing method',
    mode_key: 'Public key',
    mode_cert: 'Certificate',
    sandbox: 'Sandbox',
    production: 'Production',
    figAmounts: 'Amount per top-up',
    presetCount: '{n} quick amounts',
    noEncryption: 'The control plane has no encryption key (secrets.encryption_key in control.yaml), so the app private key cannot be saved. Set one and restart the control plane.',
    topUpTitle: 'Top-up settings',
    baseURL: 'Customer console address',
    baseURLHelp: "Alipay's notifications and the buyer's return after paying go to this address. It must be reachable from the internet; HTTPS is recommended.",
    suggest: 'Use the customer console address from Console domains:',
    plainHttp: 'This is an HTTP address. Notifications are protected by their signature, but buyers return over an unencrypted link. HTTPS is recommended.',
    notifyURL: 'Notify URL',
    returnURL: 'Return URL',
    derivedNote: 'Sent to Alipay with each order. Nothing to enter on the Alipay Open Platform.',
    subject: 'Order title',
    subjectHelp: "Shown on the buyer's Alipay bill.",
    subjectPlaceholder: 'Account top-up',
    amountRange: 'Amount per top-up',
    amountRangeHelp: 'The smallest and largest amount a customer can top up at once.',
    to: 'to',
    presets: 'Quick amounts',
    presetsHelp: 'Amounts customers can pick with one click on the top-up page. Up to {n}, within the amount range.',
    presetPlaceholder: 'Amount',
    addPreset: 'Add',
    saved: 'Saved',
    copyFailed: 'Could not copy. Copy it manually',
    fileTooBig: 'The file is too large. Key and certificate files are usually a few KB',
    alipayTitle: 'Alipay',
    testSavedFirst: 'Save your changes first. The test uses the saved settings',
    test: 'Test connection',
    test_ok: 'Connection OK',
    test_invalidSignature: 'Alipay rejected the request signature',
    test_invalidAppId: 'Invalid AppID',
    test_answerSignature: "Could not verify Alipay's response",
    test_unreachable: 'Cannot reach the Alipay gateway',
    test_notReady: 'Settings incomplete',
    test_other: 'Alipay returned an error',
    testHint_ok: 'The AppID, app private key and Alipay public key all check out ({gateway}).',
    testHint_invalidSignature: 'The app private key does not match the app public key (or certificate) set on the Alipay Open Platform.',
    testHint_invalidAppId: 'Alipay cannot find this app, or it is not live yet. Production and sandbox AppIDs are different.',
    testHint_answerSignature: "The signature on Alipay's response did not verify. Check the Alipay public key (or the Alipay public key and root certificates).",
    testHint_unreachable: 'The control plane cannot reach {gateway}. Check its network and DNS.',
    testHint_notReady: 'Turn Alipay on, fill in the AppID and the keys (or certificates), turn on a product, then save and test again.',
    testHint_other: 'Alipay returned this error:',
    alipayIntro: 'Create an app on the Alipay Open Platform and sign up for the products you need. Set the signing method (RSA2) under Development settings, then enter the AppID, the app private key and the Alipay public key (or the three certificates) here.',
    enable: 'Enable Alipay',
    enableHelp: 'When on, customers can top up with Alipay on the Billing page of the customer console.',
    appIdHelp: 'The APPID on the app details page of the Alipay Open Platform.',
    signMode: 'Signing method',
    environment: 'Environment',
    modeNote_key: 'Public key mode: upload the app public key on the Open Platform, then enter the Alipay public key it gives you below.',
    modeNote_payouts: ' Paying out withdrawals needs certificate mode.',
    modeNote_cert: 'Certificate mode: sign with certificates on the Open Platform and download the app public key certificate, the Alipay public key certificate and the Alipay root certificate.',
    privateKey: 'App private key',
    privateKeyKeep: 'Saved. Paste a new app private key to replace it',
    privateKeyPlaceholder: 'MIIEvQIBADANBgkqhkiG9w0BAQEFAASC… or -----BEGIN PRIVATE KEY-----',
    privateKeySet: 'Stored encrypted. It is never shown again',
    privateKeyHelp: 'The RSA2 app private key made with the Alipay key tool. It is stored encrypted.',
    fromFile: 'Read from file',
    alipayKey: 'Alipay public key',
    alipayKeyHelp: 'The Alipay public key the Open Platform shows after you upload the app public key.',
    appCert: 'App public key certificate',
    alipayCert: 'Alipay public key certificate',
    rootCert: 'Alipay root certificate',
    products: 'Products',
    productsHelp: 'Turn on only the products signed up for on the Alipay Open Platform. Orders through the others fail.',
    product_page: 'Web payment',
    product_wap: 'Mobile web payment',
    product_qr: 'Face-to-face (QR)',
    productSub_page: 'Desktop browsers go to the Alipay checkout',
    productSub_wap: 'Phone browsers open the Alipay app',
    productSub_qr: 'A QR code on the page, scanned to pay',
    noEncryptionShort: 'No encryption key on the control plane: the Alipay settings cannot be saved yet',
  },
  topups: {
    title: 'Top-up orders',
    statTotal: 'Total top-ups',
    statToday: 'Today',
    statOrders: 'Orders',
    statPending: 'Awaiting payment',
    unitYuan: 'CNY',
    unitOrders: 'orders',
    count: '{n} in total',
    all: 'All',
    state_paid: 'Paid',
    state_pending: 'Unpaid',
    state_expired: 'Expired',
    state_closed: 'Closed',
    customer: 'Customer',
    clear: 'Clear filters',
    noMatch: 'No orders match',
    empty: 'No top-up orders yet',
    method_page: 'Alipay · Web',
    method_wap: 'Alipay · Mobile',
    method_qr: 'Alipay · QR code',
    colOrderNo: 'Order number',
    colCustomer: 'Customer',
    colAmount: 'Amount',
    colMethod: 'Payment method',
    colCreated: 'Created',
    colPaid: 'Paid',
    details: 'Details',
    check: 'Check',
    detailTitle: 'Order details',
    tradeNo: 'Alipay trade no.',
    buyer: 'Buyer account',
    expires: 'Pay by',
    checkAlipay: 'Check with Alipay',
    viewBalance: 'Customer balance',
    checkHelp: "Asks Alipay how this trade stands. If the buyer paid but the order was never credited (for example, the notification did not arrive), the customer's balance is credited right away.",
    checkMismatch: 'Alipay received ¥{paid}, not the order amount of ¥{amount}, so nothing was credited. Check, then adjust the customer balance manually.',
    checkCredited: "Payment confirmed. ¥{amount} has been added to {user}'s balance",
    checkPaid: 'Alipay confirms this order was paid',
    checkWaiting: 'The trade exists and is waiting for the buyer to pay',
    checkRefunded: 'Alipay shows the trade as closed. This credited order may have been fully refunded. Check, then deduct the customer balance manually',
    checkClosed: 'The trade is closed: it was not paid in time',
    checkNotExist: 'Alipay has no such trade: the buyer neither opened the checkout nor scanned the code',
  },
  // 财务管理: the review pages, 套餐订单 and 财务设置.
  finDoc: {
    details: 'Details',
    reject: 'Reject',
    rejectReason: 'Reason',
    rejectReasonHelp: 'The customer sees this beside the document',
    rejectPlaceholder: 'Say why it is rejected',
    rejected: 'Rejected',
    rejectedFor: 'Rejected: {note}',
    reviewNote: 'Note',
    notePlaceholder: 'Optional, shown to the customer',
    reviewedAt: 'Handled',
    check: 'Check',
    noMatch: 'Nothing matches',
    copyFailed: 'Could not copy. Select the text and copy it instead',
    remit: {
      pending: 'Pending',
      approved: 'Credited',
      rejected: 'Rejected',
      cancelled: 'Cancelled',
    },
    withdraw: {
      pending: 'Pending',
      processing: 'Paying out',
      success: 'Paid out',
      failed: 'Failed',
      rejected: 'Rejected',
      cancelled: 'Cancelled',
    },
    invoice: {
      pending: 'Pending',
      issued: 'Issued',
      rejected: 'Rejected',
      cancelled: 'Cancelled',
    },
    refund: {
      pending: 'Pending',
      processing: 'Refunding',
      success: 'Refunded',
      failed: 'Failed',
      rejected: 'Rejected',
      cancelled: 'Cancelled',
    },
  },
  remits: {
    title: 'Bank transfers',
    statRemitted: 'Total credited',
    statWaitingAmount: 'Awaiting confirmation',
    statPending: 'Pending',
    statApproved: 'Credited',
    listTitle: 'Transfers',
    empty: 'No transfers reported yet',
    colNo: 'Transfer number',
    colAmount: 'Amount',
    colPayer: 'Paid by',
    colDate: 'Transfer date',
    colSubmitted: 'Submitted',
    colTo: 'Paid to',
    payerAccount: 'Payer account',
    reference: 'Bank reference',
    note: "Customer's note",
    receipt: 'Receipt',
    openReceipt: 'Open in a new tab',
    pdfReceipt: 'PDF receipt, click to view',
    noReceipt: 'No receipt',
    approve: 'Credit',
    approveTitle: 'Credit this transfer?',
    approveContent: 'Confirm that ¥{amount} from {payer} has arrived in the receiving account? It is added to the balance of {user} and cannot be undone.',
    approved: 'Credited: ¥{amount} added to the balance of {user}',
    approveHelp: "Check the amount, the payer's name and the date against the bank account before crediting.",
    detailTitle: 'Transfer details',
    rejectTitle: 'Reject transfer',
    rejectPlaceholder: 'e.g. We could not find this transfer. Check the amount and the payer and submit it again',
  },
  withdrawals: {
    title: 'Withdrawals',
    statPaidOut: 'Paid out',
    statWaitingAmount: 'Awaiting review',
    statPending: 'Pending',
    statFailed: 'Failed payouts',
    listTitle: 'Withdrawal requests',
    empty: 'No withdrawals yet',
    notReady: 'Alipay is not set up with certificate signing, so withdrawals cannot be paid out. Switch to certificate signing in Payment settings and sign up for "Transfer to Alipay account" on the Alipay Open Platform.',
    toPayment: 'Payment settings',
    colNo: 'Withdrawal number',
    colAmount: 'Amount',
    colNet: 'Payout',
    colTo: 'Pay to',
    colApplied: 'Applied',
    pay: 'Pay out',
    retry: 'Retry',
    payTitle: 'Pay out this withdrawal',
    retryTitle: 'Retry this payout',
    payee: 'Payee',
    fee: 'Fee',
    transfer: 'Transfer',
    noteHelp: 'The customer sees it in their withdrawal history',
    payConfirm: "The money is sent through Alipay at once and cannot be recalled once it arrives. Make sure the platform's Alipay balance covers it.",
    paid: 'Paid ¥{amount} out to {user}',
    payFailed: 'Alipay refused the transfer: {reason}',
    payPending: 'Alipay has not answered yet. It is asked again every minute',
    stillProcessing: 'Alipay is still processing the transfer',
    checked: 'Checked: {state}',
    rejected: "Rejected. ¥{amount} returned to the customer's balance",
    rejectTitle: 'Reject withdrawal',
    rejectHint: '¥{amount} returns to the balance of {user}.',
    detailTitle: 'Withdrawal details',
    failedFor: 'Alipay refused the transfer: {reason}. Retry once checked, or reject it to return the money to the balance.',
    processingNote: 'Sent to Alipay and waiting for its answer. It is asked again every minute.',
    realName: 'Real name',
    account: 'Alipay account',
    attempts: 'Attempts',
    orderId: 'Alipay order',
    finishedAt: 'Finished',
    checkAlipay: 'Ask Alipay',
    payHelp: 'Paying out transfers through Alipay at once; a failed transfer can be retried or rejected.',
    rejectPlaceholder: 'e.g. The real name does not match the Alipay account. Check it and apply again',
  },
  invoices: {
    title: 'Invoices',
    statIssuedAmount: 'Invoiced',
    statWaitingAmount: 'Awaiting issue',
    statPending: 'Pending',
    statIssued: 'Issued',
    unit: 'invoices',
    listTitle: 'Invoice requests',
    count: '{n} in total',
    empty: 'No invoice requests yet',
    colApplied: 'Requested',
    colKind: 'Type',
    colAmount: 'Amount',
    colNumber: 'Invoice number',
    colNo: 'Request number',
    header: 'Invoice title',
    titleKind: 'Title type',
    kind_company: 'Company',
    kind_personal: 'Personal',
    type_normal: 'General',
    type_special: 'Special',
    typeLong_normal: 'General VAT invoice',
    typeLong_special: 'Special VAT invoice',
    medium_electronic: 'Electronic',
    medium_paper: 'Paper',
    taxNo: 'Taxpayer ID',
    address: 'Registered address',
    phone: 'Registered phone',
    bank: 'Bank',
    bankAccount: 'Bank account',
    email: 'Email',
    recipient: 'Recipient',
    mailAddress: 'Mailing address',
    express: 'Courier',
    issuedAt: 'Issued',
    issue: 'Issue',
    issueTitle: 'Issue invoice',
    numberHelp: '8–24 digits or letters, shown to the customer',
    numberPlaceholder: 'The number on the invoice',
    file: 'Invoice file',
    fileHelp: 'PDF or image, up to 10 MB. The customer downloads it from their invoice history',
    filePick: 'Upload file',
    fileReplace: 'Replace',
    fileTooLarge: 'The file must be 10 MB or smaller',
    expressCompany: 'Courier',
    expressCompanyPlaceholder: 'e.g. SF Express',
    expressNo: 'Tracking number',
    issued: 'Invoice issued for {user}',
    download: 'Download',
    detailTitle: 'Invoice details',
    rejectTitle: 'Reject invoice request',
    rejectHint: 'The amount becomes available to invoice again.',
    rejectPlaceholder: 'e.g. The title does not match the payer. Check it and apply again',
  },
  refunds: {
    title: 'Refunds',
    statRefunded: 'Refunded',
    statWaitingAmount: 'Awaiting review',
    statPending: 'Pending',
    statFailed: 'Failed refunds',
    listTitle: 'Refund requests',
    empty: 'No refund requests yet',
    notReady: 'Alipay is not set up, so top-ups cannot be refunded the way they came. Package refunds go to the balance and are not affected.',
    colNo: 'Refund number',
    colOrder: 'Order',
    colAmount: 'Amount',
    colApplied: 'Requested',
    target_topup: 'Top-up',
    target_package: 'Package',
    approve: 'Refund',
    retry: 'Retry',
    approveTitle: 'Refund this request',
    retryTitle: 'Retry this refund',
    asked: 'Requested',
    paid: 'Refund',
    paidHelp: 'At most the ¥{max} requested',
    revokeLabel: 'Take the time this order bought off the package',
    revokeHelp: 'Unchecked, the customer keeps the time and only gets the money back.',
    topUpNote: '¥{amount} goes back to the Alipay account that paid it (it left the balance when requested).',
    doneTopUp: '¥{amount} refunded to the Alipay account of {user}',
    donePackage: '¥{amount} refunded to the balance of {user}',
    refundFailed: 'Alipay refused the refund: {reason}',
    refundPending: 'Alipay has not answered yet. It is asked again every minute',
    stillProcessing: 'Alipay is still processing the refund',
    checked: 'Checked: {state}',
    detailTitle: 'Refund details',
    failedFor: 'Alipay refused the refund: {reason}. Retry once checked, or reject it to return the money to the balance.',
    processingNote: 'Sent to Alipay and waiting for its answer. It is asked again every minute.',
    where: 'Refunded to',
    where_topup: 'The paying Alipay account',
    where_package: 'The balance',
    revoke: 'Package time',
    revokeYes: 'Taken off',
    revokeNo: 'Kept',
    reason: 'Reason',
    finishedAt: 'Finished',
    rejectTitle: 'Reject refund',
    rejectHintTopUp: "¥{amount} returns to the customer's balance.",
    rejectPlaceholder: 'e.g. The service is already in use, so the order cannot be refunded',
  },
  finOrders: {
    title: 'Package orders',
    statSales: 'Package sales',
    statRefunded: 'Refunded',
    statOrders: 'Orders',
    statRefunds: 'Refunds to review',
    listTitle: 'Orders',
    empty: 'No package orders yet',
    colOrderNo: 'Order number',
    colPackage: 'Package',
    colAmount: 'Amount',
    refundedAmount: '¥{amount} refunded',
    colSpan: 'Service period',
    colCreated: 'Ordered',
    kind_buy: 'New',
    kind_renew: 'Renewal',
    period_month: '1 month',
    period_quarter: '3 months',
    period_year: '1 year',
    state_paid: 'Paid',
    state_partly_refunded: 'Part refunded',
    state_refunded: 'Refunded',
  },
  finSettings: {
    title: 'Finance settings',
    saved: 'Finance settings saved',
    storeTitle: 'Buying packages online',
    storeIntro: 'When on, customers buy new packages and renew theirs with their balance in the customer console. Only packages in service with a CNY price are sold.',
    onSale: '{n} package(s) can be sold now',
    toPackages: 'Set prices in Packages',
    remitTitle: 'Bank transfers',
    remitIntro: 'When on, customers transfer money to the accounts below and upload the bank receipt; finance credits it in Bank transfers once it arrives.',
    accounts: 'Receiving accounts',
    accountsCount: '{n} / {max}',
    acctName: 'Name',
    acctBank: 'Bank',
    acctNo: 'Account number',
    acctNote: 'Note',
    acctNamePlaceholder: 'Company name',
    acctBankPlaceholder: 'e.g. CMB Hangzhou Branch',
    acctNoPlaceholder: 'Account number',
    acctNotePlaceholder: 'Optional',
    addAccount: 'Add receiving account',
    remitMin: 'Minimum per transfer',
    remitMinHelp: 'Smaller transfers cannot be reported',
    remitNote: 'Instructions',
    remitNoteHelp: "Shown at the top of the customer's bank transfer page, e.g. what to write in the transfer's memo",
    withdrawTitle: 'Withdrawals',
    withdrawIntro: 'When on, customers withdraw their balance to their own Alipay account: the amount leaves the balance when they apply, and Alipay transfers it once approved. Invoiced money cannot be withdrawn.',
    transferNotReady: 'Alipay cannot transfer yet. Before turning withdrawals on:',
    transferStep1: 'In Payment settings, switch signing to certificates and upload the three certificates;',
    transferStep2: 'On the Alipay Open Platform, sign the app up for "Transfer to Alipay account".',
    transferReady: "Alipay signs with certificates: approved withdrawals are transferred automatically. Keep the platform's Alipay balance topped up.",
    withdrawRange: 'Amount per withdrawal',
    withdrawRangeHelp: 'Alipay transfers at least ¥0.10',
    fee: 'Fee',
    feeAtLeast: 'at least',
    feeHelp: 'A per-mille rate of the amount, at least the minimum fee. E.g. withdrawing ¥{amount}: fee ¥{fee}, payout ¥{net}.',
    invoiceTitle: 'Invoices',
    invoiceIntro: 'When on, customers request invoices for what they paid (top-ups and transfers, less refunds, withdrawals and what was invoiced), issued by finance in Invoices.',
    invoiceTypes: 'Invoice types',
    invoiceMedia: 'Delivery',
    invoiceMediaHelp: 'Electronic invoices are uploaded for the customer to download; paper ones go by courier with a tracking number',
    invoiceMin: 'Minimum per invoice',
    invoiceNote: 'Instructions',
    invoiceNoteHelp: "Shown at the top of the customer's invoice page, e.g. what invoices say and when they are issued",
    refundTitle: 'Refunds',
    refundIntro: 'When on, customers ask for refunds within the windows below: a top-up goes back to the Alipay account that paid it, a package order to the balance with its time taken off the package. Refunds are reviewed; invoiced money cannot be refunded.',
    refundNotReady: 'Alipay is not set up, so top-up refunds cannot go back the way they came yet.',
    topupDays: 'Top-up refund window',
    topupDaysHelp: 'Days after payment; 0 turns top-up refunds off',
    packageDays: 'Package refund window',
    packageDaysHelp: 'Days after purchase; 0 turns package refunds off',
    days: 'days',
  },
  balance: {
    col: 'Balance',
    kind_realname: 'ID verification',
    kind_realname_back: 'ID verification refund',
    open: 'View transactions and adjust the balance',
    title: 'Balance · {user}',
    current: 'Current balance',
    adjustTitle: 'Adjust balance',
    credit: 'Add',
    debit: 'Deduct',
    amount: 'Amount',
    notePlaceholder: 'Reason, shown to the customer',
    apply: 'Apply',
    adjustHelp: 'For example an offline transfer, a credit or a refund. A deduction cannot take the balance below zero.',
    confirmCredit: 'Add ¥{amount} to {user}?',
    confirmDebit: 'Deduct ¥{amount} from {user}?',
    credited: 'Added ¥{amount} to {user}',
    debited: 'Deducted ¥{amount} from {user}',
    ledgerTitle: 'Transactions',
    ledgerCount: '{n} in total',
    noLedger: 'No transactions yet',
    kind_topup: 'Top-up',
    kind_adjust: 'Adjustment',
    ledgerTopUp: 'Alipay top-up',
    after: 'Balance ¥{amount}',
    colTime: 'Time',
    colKind: 'Type',
    colChange: 'Amount',
    colAfter: 'Balance',
    colNote: 'Description',
    kind_remittance: 'Bank transfer',
    kind_withdraw: 'Withdrawal',
    kind_withdraw_back: 'Withdrawal returned',
    kind_refund: 'Top-up refund',
    kind_refund_back: 'Refund returned',
    kind_purchase: 'Package purchase',
    kind_order_refund: 'Package refund',
    desc_remittance: 'Bank transfer credited',
    desc_withdraw: 'Withdrawal to Alipay',
    desc_withdraw_back: 'Withdrawal not completed, returned',
    desc_refund: 'Top-up refunded to Alipay',
    desc_refund_back: 'Refund not completed, returned',
    desc_purchase: 'Package "{name}"',
    desc_order_refund: 'Package "{name}" refunded',
  },
  subscriptions: {
    autoFailed: 'Failed',
    autoFailed_insufficientBalance: 'The last automatic renewal failed: the customer\'s balance is short',
    autoFailed_other: 'The last automatic renewal failed: it cannot be renewed online',
    autoFailed_periodUnavailable: 'The last automatic renewal failed: that period is no longer sold',
    title: 'Subscriptions',
    intro: 'Packages customers hold. Once one expires (plus the grace period set in Default pages), the sites under it are suspended; renewing, moving the expiry or resuming brings them back within a minute.',
    tabAll: 'All',
    state_active: 'Active',
    state_expiring: 'Expiring',
    state_expired: 'Expired',
    state_cancelled: 'Cancelled',
    searchPlaceholder: 'Search user or package',
    allPackages: 'All packages',
    assign: 'Assign package',
    userCol: 'User',
    packageCol: 'Package',
    stateCol: 'State',
    startedCol: 'Started',
    expiresCol: 'Expires',
    remainingCol: 'Remaining',
    sitesCol: 'Sites',
    autoRenewCol: 'Auto-renew',
    autoRenewHelp: 'When on, the package is renewed from the customer\'s balance 3 days before it expires (for the period the customer chose, a month by default); the customer is told when the balance is short. Needs online buying on in Finance settings.',
    daysLeft: '{n} days',
    hoursLeft: '{n} hours',
    expiredAgo: 'Expired {n} days ago',
    renew: 'Renew',
    edit: 'Edit',
    cancel: 'Cancel',
    resume: 'Resume',
    pickUser: 'Choose a user',
    pickPackage: 'Choose a package',
    pickUserAndPackage: 'Choose a user and a package',
    pickDate: 'Choose an expiry',
    validity: 'Validity',
    byDays: 'Duration',
    byDate: 'Expiry date',
    nDays: '{n} days',
    days: 'days',
    assigned: 'Assigned',
    renewTitle: 'Renew',
    renewFor: 'Renew {pkg} for {user}',
    renewPreview: 'New expiry: {at}. A running subscription is extended from its current expiry; an expired one from now.',
    renewed: 'Renewed. Its sites are served again within a minute',
    editTitle: 'Edit subscription',
    editEndsNow: 'The expiry is in the past: saving ends this subscription now and suspends its {n} site(s).',
    updated: 'Saved',
    cancelTitle: 'Cancel this subscription?',
    cancelWithSites: 'The customer\'s {n} site(s) under this package will be suspended within a minute. It can be resumed until its original expiry.',
    cancelNoSites: 'No sites use this package. It can be resumed until its original expiry.',
    cancelOk: 'Cancel subscription',
    cancelled: 'Cancelled',
    resumed: 'Resumed',
    actionFailed: 'Action failed',
  },
  packages: {
    accessNote: 'A CNAME is generated from this and written to DNS when a customer adds a site',
    cnameZoneLabel: 'Access domain',
    cnameZonePlaceholder: 'Choose an access domain',
    lineGroupLabel: 'Line group',
    lineGroupPlaceholder: 'Choose a line group',
    cnameValueLabel: 'CNAME value',
    cnameValuePlaceholder: 'e.g. cdn',
    cnameCol: 'CNAME',
    cnameNone: 'Not generated',
    chainTitle: 'Resolution chain',
    chainSharedNote: 'Per package: every site on this package shares this one record.',
    chainPerSiteNote: 'Per site: the d prefix is followed by the site ID, one record per site.',
    chainIncomplete: 'Set the access domain, line group and CNAME value together to generate a CNAME.',
    secPricing: 'Pricing',
    pricingNote: 'Priced per currency; 0 means free',
    cnyPricing: 'CNY pricing',
    usdPricing: 'USD pricing',
    termMonthly: 'Monthly',
    termQuarterly: 'Quarterly',
    termYearly: 'Yearly',
    unitMillion: 'M',
    unitCount: '',
    unitRules: '',
    pendingTag: 'Not built',
    sectionZeroNote: '0 = unlimited',
    secBasic: 'Basics',
    secCapacity: 'Capacity',
    secQuotas: 'Quotas',
    secProtection: 'Protection',
    secFeatures: 'Features',
    secAccess: 'Access',
    descLabel: 'Description',
    descPlaceholder: 'One line on what this tier sells. Optional.',
    bandwidthLabel: 'Bandwidth',
    connectionsLabel: 'Concurrent connections',
    siteQuotaLabel: 'Sites',
    siteQuotaHint: 'One site is one row in the site list',
    domainQuotaHint: 'Every hostname, subdomains included',
    apexQuotaLabel: 'Apex domains',
    apexQuotaHint: 'Registrable domains only, subdomains not counted',
    customPortLabel: 'Custom ports',
    l4PortLabel: 'App Acceleration rules',
    l4PortHint: 'Applies with App Acceleration on',
    ruleQuotaLabel: 'Rules',
    ccCapacityLabel: 'CC protection',
    ddosCapacityLabel: 'DDoS protection',
    logRetentionLabel: 'Log retention',
    days: 'days',
    allowCustomCc: 'Custom CC rules',
    allowWebsocket: 'WebSocket',
    allowHttp3: 'HTTP/3',
    allowWaf: 'WAF',
    allowL2Origin: 'L2 origin shield',
    allowCustomCert: 'Custom certificates',
    allowOpenapi: 'OpenAPI',
    allowL4: 'App Acceleration',
    cnameModeLabel: 'CNAME mode',
    cnamePerSite: 'Per site',
    cnamePerPackage: 'Per package (shared)',
    unlimited: 'Unlimited',
    zeroMeansUnlimited: '0 means unlimited',
    capacityHint: 'A figure to show and compare, not a rate limit',
    notBuiltYet: 'Not implemented yet — recorded only',
    enforcement: 'Everything here is enforced. Switches: a feature the package lacks does not apply to its sites; the settings are kept and come back when a site moves to a package that has it, and uploaded certificates keep working. Counts: at the limit customers cannot add sites, domains or rules; what they have stays, and operators are not limited. Traffic and requests reset monthly from the start date and suspend the sites when used up; bandwidth and connections are ceilings for all nodes together. Items marked Not built have no effect yet.',
    tabPackages: 'Packages',
    tabGroups: 'Groups',
    groupCol: 'Group',
    groupLabel: 'Group',
    groupPlaceholder: 'Leave empty for ungrouped',
    groupHint: 'A group only affects how the console files and filters packages. It does not change quotas or pricing.',
    groupFilter: 'Filter by group',
    groupFilterAll: 'All groups',
    ungrouped: 'Ungrouped',
    title: 'Packages',
    sectionTitle: 'Package management',
    nameCol: 'Name',
    priceCol: 'Monthly price',
    trafficCol: 'Monthly traffic (GB)',
    requestCol: 'Monthly requests (M)',
    domainQuotaCol: 'Domain quota',
    statusCol: 'Status',
    statusActive: 'Active',
    statusDisabled: 'Disabled',
    create: 'New package',
    edit: 'Edit',
    delete: 'Delete',
    deleteConfirmTitle: 'Delete package',
    deleteConfirm: 'Delete package "{name}"? This cannot be undone.',
    nameLabel: 'Package name',
    trafficLabel: 'Monthly traffic',
    requestLabel: 'Monthly requests',
    domainQuotaLabel: 'Domains',
    saveSuccess: 'Saved',
    saveFailed: 'Save failed',
    deleteSuccess: 'Deleted',
    deleteFailed: 'Delete failed',
    assignToUser: 'Assign to user',
    userIdLabel: 'User ID',
    expiresAtLabel: 'Expires at (RFC3339)',
    assignSuccess: 'Assigned',
    assignFailed: 'Assign failed',
  },
  systemUpdate: {
    title: 'System update',
    controlTitle: 'Control plane',
    controlIntro: 'The control plane checks the portal\'s release repository for a new version every hour. An update is carried out by the update service on its host: it backs the database up, replaces the files, restarts and migrates, and puts this version back if the new one does not come up.',
    check: 'Check for updates',
    stateRunning: 'Updating',
    stateCheckFailed: 'Check failed',
    stateAvailable: 'Update available',
    stateLatest: 'Up to date',
    stateUnchecked: 'Not checked',
    noReleaseKey: 'This is not a release build (it has no release public key), so it cannot verify updates. Install a release once first.',
    noUpdaterTitle: 'The updater is not installed on the control plane\'s host',
    noUpdater: 'Run this once on the control plane\'s host (as root); then update from here:',
    current: 'Running',
    latest: 'Latest',
    releasedAt: 'released {time}',
    checkedAt: 'Last checked',
    never: 'Never',
    updater: 'Updater',
    updaterInstalled: 'Installed ({time})',
    updaterMissing: 'Not installed',
    checkError_noRelease: 'Nothing has been published to the repository yet',
    checkError_badSignature: 'The repository manifest failed signature verification',
    checkError_badManifest: 'The repository manifest is malformed',
    checkError_unreachable: 'The repository cannot be reached',
    foundNew: '{v} is out',
    upToDate: 'Up to date',
    incoming: 'What\'s new',
    comp_control: 'Control plane',
    comp_agent: 'Agent',
    comp_edge: 'Edge',
    confirmTitle: 'Update the control plane to {v}?',
    confirmBody: 'The database is backed up first, then the control plane is replaced and restarted; the console is away for a minute or two. If the new version does not come up, this one is put back.',
    confirmOk: 'Update',
    phase_download: 'Download',
    phase_backup: 'Back up',
    phase_swap: 'Replace',
    phase_build: 'Build',
    phase_restart: 'Restart',
    phase_migrate: 'Migrate',
    phase_check: 'Check',
    restarting: 'The control plane is restarting and the console is away; this page reloads when it is back…',
    run_succeeded: 'Updated from {from} to {to} at {time}',
    run_rolled_back: 'Updating to {to} failed; {from} is back',
    run_failed: 'Updating to {to} failed; nothing changed',
    backupAt: 'Database backup: {path}',
    updateTo: 'Update to {v}',
    updateHint: 'Backs the database up first; puts this version back on failure',
    done: 'Updated to {v}; reloading',
    nodesTitle: 'Nodes',
    nodesIntro: 'Nodes get new versions from the control plane: once a check finds a release, it downloads the agent and edge from the repository and verifies them. Each node verifies and swaps them in itself; the edge hands its connections to the new process, so nothing drops.',
    latestNode: 'Latest',
    nodesOutdated: 'Behind',
    nodesCount: '{n} of {total}',
    toNodes: 'Node list',
    upgradeAll: 'Update all ({n})',
    nodesConfirmTitle: 'Update {n} nodes?',
    nodesConfirmBody: 'Each node downloads and verifies the new version, then swaps the edge (without dropping connections) and then the agent. Offline nodes update when they are back.',
    nodesConfirmOk: 'Update',
    nodesQueued: '{n} updates queued',
    nodeFirstTime: 'Before a node is first updated from here, run this once on it (as root):',
    settingsTitle: 'Update settings',
    settingsIntro: 'Releases are built on the build host, signed with the release key and published to the portal; control planes and nodes take only what verifies. The repository opens to licensed control planes only.',
    autoCheck: 'Check automatically',
    autoCheckHelp: 'Hourly; the menu shows a dot when an update is out',
    saved: 'Saved',
    historyTitle: 'Releases',
    historySub: 'in the repository',
    historyEmpty: 'The repository has not been checked yet',
    colVersion: 'Version',
    colReleased: 'Released',
    colChanged: 'Changed',
    colNotes: 'Notes',
    runsTitle: 'Updates',
    runsEmpty: 'No updates yet',
    colTime: 'Time',
    colVersions: 'Versions',
    colResult: 'Result',
    result_success: 'Succeeded',
    result_failed: 'Failed',
    stateNoLicense: 'No license',
    noRepository: 'This control plane has no license: the release repository opens to licensed control planes only.',
    repoTokenExpired: 'The repository download token has expired: the license has not been renewed for too long.',
    toLicense: 'Go to License',
    repository: 'Release repository',
    repositoryHelp: 'Comes with the license from the portal; it cannot be changed here',
    repositoryNone: 'Shown once a license is activated',
    checkError_unauthorized: 'The repository refused the download token: the license is not active',
    nodeArtifacts: 'Node versions',
    nodeArtifactsReady: 'Downloaded and verified: nodes can update',
    nodeArtifactsPreparing: 'Downloading from the repository…',
    nodeArtifactsFailed: 'Download failed: {reason}',
    nodeArtifactsNone: 'Downloaded once a check finds a release',
    tokenNote: 'The command downloads from the portal\'s repository, which needs a download token: make one in the portal console, run export CDNX_REPO_TOKEN=your-token, then the command above.',
  },
  systemSettings: {
    skin: 'Theme colour',
    skinHelp: 'One colour for the whole platform: the customer console, this console and the login page; users cannot change it. Pick a recommended colour or any colour of your own',
    uiSection: 'Interface',
    navbarHeight: 'Default top bar height',
    menuWidth: 'Default menu width',
    layoutHelp: 'Used for whoever has not set their own in Customize, where users can still change it',
    title: 'System Settings',
    intro: 'Platform-wide settings. The name and icon are used by both consoles and by the edge verification page.',
    brandingSection: 'Branding',
    systemName: 'System name',
    systemNameHelp: 'The public name of this platform. Shown at the top left of both consoles and on their sign-in pages; browser tabs read "<page> - <system name>".',
    challengeBrand: 'Verification page name',
    challengeBrandHelp: 'Brand shown on the human-verification page. It is rendered at the edge, so it takes effect once the config reaches the nodes.',
    favicon: 'Favicon',
    faviconHelp: '.ico files only, up to 256 KB. The browser tab icon of both consoles and the challenge page; also used as the logo while none is uploaded.',
    noFavicon: 'None',
    uploadFavicon: 'Upload .ico',
    faviconUploaded: 'Icon updated',
    faviconFailed: 'Icon upload failed',
    registrationSection: 'Sign-up and sign-in',
    allowRegistration: 'Allow self-service registration',
    allowRegistrationHelp: 'When off, the registration endpoint itself refuses requests — the entry point is not merely hidden. Limited to 5 signups per hour per IP address.',
    defaultPackage: 'Default package',
    defaultPackageHelp: 'The package each new account gets. Optional: without one, a new account buys a package before it can add a site.',
    noEmailVerification: 'This system has no email capability, so addresses given at registration are unverified. Do not treat them as confirmed contact details.',
    saved: 'Saved',
    saveFailed: 'Save failed',
    websiteUrl: 'Official site',
    websiteUrlHelp: 'The "Official site" links of the customer sign-in and sign-up pages, at the top right and in the footer, go here. Leave empty to hide them.',
    verifyEmail: 'Verify email at sign-up',
    verifyEmailHelp: 'A code is mailed to the address; registering needs it.',
    verifyPhone: 'Verify phone at sign-up',
    verifyPhoneHelp: 'A mobile number and the code texted to it are needed to register; the verified number then works for signing in.',
    serviceOff: '{name} must be set up first.',
    mailService: 'Mail',
    smsService: 'SMS',
    goSetUp: 'Set up',
    noVerification: 'No verification at sign-up: the email and phone given are unverified — do not treat them as confirmed contact details.',
    verifyServiceDown: 'A service that sign-up verification or code sign-in needs is down: customers cannot get their codes.',
    agreementsSection: 'Agreements',
    agreementsIntro: 'The customer sign-in page says that signing in means agreeing to them, and registering needs them accepted. An agreement with nothing in it is not shown. The default text is a general template: fit it to your business before relying on it.',
    agreement_terms: 'Terms of Use',
    agreement_privacy: 'Privacy Policy',
    agreementMode: 'Provided as',
    agreementContent: 'Written here',
    agreementLink: 'A link',
    agreementUrl: 'Address',
    agreementUrlHelp: 'Clicking the agreement opens this address in a new tab.',
    agreementText: 'Text',
    agreementTextHelp: 'Shown in a dialog when the agreement is clicked. The English console shows the English text, or the Chinese one when there is none.',
    agreementPlaceholder: '输入协议内容，可从文档中直接粘贴',
    agreementPlaceholderEn: 'Paste or write the English version',
    noDefaultPackage: 'No package',
    loginBySms: 'Sign in by SMS code',
    loginBySmsHelp: 'The customer sign-in page offers "Code": a code texted to the phone the account verified.',
    loginByEmail: 'Sign in by email code',
    loginByEmailHelp: 'The customer sign-in page offers "Code": a code mailed to the account\'s address.',
    authPagesSection: 'Sign-in and sign-up pages',
    authPagesIntro: 'The notice at the top and the footer at the bottom of the customer sign-in and sign-up pages. Each page has its own notice, drawn the same; both share the footer.',
    login_notice: 'Sign-in page notice',
    register_notice: 'Sign-up page notice',
    noticeShow: 'Show the notice',
    noticeShowHelp: 'Shown at the top of the page. Visitors can close it with the × at its right; it shows again once its text changes.',
    noticeText: 'Notice text',
    noticeTextHelp: 'Bold and links work; links open in a new window. The English console shows the English text, or the Chinese one when there is none.',
    noticePlaceholder: '例如：【重要】平台将于今晚 23:00 至 24:00 进行升级维护，期间控制台可能无法访问',
    noticePlaceholderEn: 'e.g. [Important] Maintenance tonight from 23:00 to 24:00: the console may be unavailable',
    restoreDefault: 'Restore default',
    restoreDefaultConfirm: 'Replace the Chinese and English text with the default? It takes effect when the page is saved.',
    restoreFooterConfirm: 'Replace the footer links and copyright lines with the defaults? It takes effect when the page is saved.',
    footerTab: 'Footer',
    backgroundTab: 'Background',
    background: 'Sign-in and sign-up background',
    backgroundHelp: 'Fills the whole page, cropped to fit. Use a JPG or WebP of 2560×1440 or more, at most {max} MB. Without one the pages show the built-in illustration; without a dark one the dark theme uses the light one.',
    backgroundBuiltIn: 'Built-in illustration',
    backgroundUploaded: 'Background updated',
    backgroundRemoved: 'Back to the built-in illustration',
    backgroundFailed: "Couldn't upload the background",
    removeBackgroundConfirm: 'Delete this background?',
    footerShow: 'Show the footer',
    footerShowHelp: 'Shown at the foot of both pages, the system name and icon first.',
    footerLinks: 'Footer links',
    footerLinksHelp: 'Official site follows the official site address above and is hidden while none is set. An agreement link opens that agreement, and is hidden while the agreement is empty. At most 20.',
    linkKind: 'Type',
    linkKind_url: 'Custom link',
    linkKind_website: 'Official site',
    linkKind_terms: 'Terms of Use',
    linkKind_privacy: 'Privacy Policy',
    linkText: 'Name',
    linkTextEn: 'English name',
    linkUrl: 'Address',
    linkFollowsWebsite: 'Follows the official site: {url}',
    linkNoWebsite: 'No official site set: hidden for now',
    linkOpensAgreement: 'Opens the agreement',
    linkActions: 'Actions',
    moveUp: 'Up',
    moveDown: 'Down',
    removeLink: 'Remove',
    addLink: 'Add link',
    footerCopyright: 'Copyright line',
    footerCopyrightEn: 'English copyright line',
    footerCopyrightHelp: '{year} shows as this year and {name} as the system name. The English console shows the English line, or the Chinese one when there is none.',
    logo: 'Logo',
    logoHelp: 'Shown at the top left of both consoles and on the customer sign-in and sign-up pages: one for the light theme, one for the dark theme (also used on a dark navbar); with only one uploaded, both themes use it. PNG, JPG, WebP, GIF or SVG up to 512 KB, a transparent background at least 64px high works best; scripts, external links and anything else unsafe are removed from an SVG. Without one, the favicon is used.',
    uploadLogo: 'Upload logo',
    removeLogo: 'Remove',
    removeLogoConfirm: 'Remove this logo?',
    logoUploaded: 'Logo updated',
    logoRemoved: 'Logo removed',
    logoFailed: 'The logo could not be uploaded',
    logoMini: 'Collapsed menu logo',
    logoMiniHelp: 'Shown at the top left while the side menu is collapsed: a square mark without words works best. Without one, the favicon is used.',
    logoLight: 'Light theme',
    logoDark: 'Dark theme',
    logoUpload: 'Upload',
    logoReplace: 'Replace',
    showBrandName: 'Show system name',
    showBrandNameHelp: 'Shows the system name beside the logo. Turn it off for a logo that already carries the words; without a logo the name always shows.',
  },
  banLogs: {
    title: 'Ban Log',
    intro: 'Addresses banned automatically by CC protection, failed verification and node protection. Current bans are enforced in the node kernel and clear themselves when they expire; with Ban on every node, they go to every node.',
    tabActive: 'Current',
    tabHistory: 'History',
    showingLatest: '{total} in all; the latest {shown} are shown. Search by IP, site or rule to find older ones.',
    searchPlaceholder: 'Search IP, site or rule',
    ipCol: 'IP',
    domainCol: 'Site',
    ruleCol: 'Rule',
    nodeCol: 'Node',
    bannedAtCol: 'Banned at',
    expiresCol: 'Expires',
    remainingCol: 'Remaining',
    outcomeCol: 'Ended by',
    inMinutes: '{n} min',
    inHours: '{n} h',
    release: 'Release',
    released: 'Released',
    expired: 'Expired',
    releaseQueued: 'Released; the node has been told to remove it',
    releaseQueuedAll: 'Released; {n} nodes have been told to remove it',
    releaseRecorded: 'Release recorded, but the node could not be notified — the kernel ban clears when it expires',
    releaseFailed: 'Could not release this ban',
    noMatch: 'Nothing matches that search',
    emptyActive: 'Nothing is currently banned',
    emptyHistory: 'No history yet',
    nodeWide: 'Whole node',
    rule_conn_flood: 'Connection rate exceeded',
    rule_tls_fail: 'Too many failed TLS handshakes',
    rule_unbound_access: 'Unbound domain / node IP access',
    rule_error_pages: 'Too many default pages',
    rule_block_kernel: 'Blocked (kernel)',
    rule_block_escalation: 'Blocked too often, escalated',
    rule_block_surge: 'Under attack, escalated',
  },
  defaultPages: {
    title: 'Default pages',
    intro: 'The pages edge nodes answer with themselves: blocks, bans, origin failures, suspended sites, domains not on the platform and so on. One set for every site; saving publishes to every node.',
    name_blocked: 'Blocked',
    name_forbidden: '403 Forbidden',
    name_waf: 'WAF block',
    name_geo_blocked: 'Region block',
    name_bad_request: '400 Bad request',
    name_rate_limited: 'Rate limited',
    name_conn_limited: 'Too many connections',
    name_bad_gateway: '502 Bad gateway',
    name_gateway_timeout: '504 Gateway timeout',
    name_internal_error: '500 Internal error',
    name_plan_expired: 'Plan expired',
    name_traffic_exceeded: 'Traffic exceeded',
    name_requests_exceeded: 'Request quota exceeded',
    name_unbound: 'Unbound domain',
    name_direct_ip: 'Node IP access',
    when_blocked: 'Shown when the visitor\'s IP is blocked or banned: the IP deny list, a CC ban, a failed-verification ban.',
    when_forbidden: 'Shown when an access-control, bot or CC rule denies the request.',
    when_waf: 'Shown when the WAF judges the request an attack and blocks it.',
    when_geo_blocked: 'Shown when the site\'s region block refuses the visitor\'s region.',
    when_bad_request: 'Shown for an incomplete or unparsable request, such as one without a Host.',
    when_rate_limited: 'Shown when a CC rule rate-limits the visitor (429).',
    when_conn_limited: 'Shown when the site\'s origin concurrency limit is reached and the node refuses new requests for now.',
    when_bad_gateway: 'Shown when the node cannot get a valid response from the origin: refused connection, failed SSL handshake, invalid certificate, dropped connection. The page states which.',
    when_gateway_timeout: 'Shown when connecting to the origin, or waiting for its response, times out. The page states which.',
    when_internal_error: 'Shown when the node hits an internal error handling the request.',
    when_plan_expired: 'Shown for every request to a site once its plan has expired. Certificate renewal keeps working.',
    when_traffic_exceeded: 'Shown for every request to a site whose package has used up this period\'s traffic, until the next period, a renewal or a top-up.',
    when_requests_exceeded: 'Shown when the site\'s package has used up this period\'s requests; works like Traffic exceeded.',
    when_unbound: 'Shown when a domain points at the node but is not on the platform (or is disabled).',
    when_direct_ip: 'Shown when the node is accessed by its IP address.',
    mode: 'Response',
    modeDefault: 'Default page (Chinese and English)',
    modeText: 'Custom text (default style)',
    modeHtml: 'Custom HTML',
    modeDrop: 'Close the connection without a response',
    status: 'Status code',
    statusHelp: 'Default {n}.',
    titleLabel: 'Title',
    messageLabel: 'Message',
    htmlLabel: 'HTML',
    htmlHelp: 'A complete HTML page, up to {kb} KB. Avoid external resources: when the origin or the network is the problem, they may not load either.',
    htmlPlaceholder: '<!doctype html> ...',
    useTemplate: 'Start from the default page',
    placeholdersTitle: 'Variables (escaped automatically)',
    ph_status: 'Status code',
    ph_request_id: 'Request ID, searchable in the access logs',
    ph_client_ip: 'Visitor IP',
    ph_host: 'Requested domain',
    ph_time: 'Time (UTC)',
    ph_brand: 'Brand name (the verification page brand in system settings)',
    ph_reason: 'Origin failure reason (502 / 504 pages only)',
    dropNote: 'Close the connection without sending anything (like 444). Cheaper than a page; useful where scanners are many.',
    expirySection: 'On expiry',
    suspend: 'Suspend sites when their plan expires',
    suspendHelp: 'Once a site\'s plan has expired (plus the grace period) the site stops being served and shows the page above; it comes back within a minute of the plan being assigned again.',
    grace: 'Grace period',
    graceHelp: 'How long a site keeps running after expiry; 0 suspends at once.',
    hours: 'hours',
    trafficNote: 'Suspension for exceeded traffic is not live yet: plan traffic quotas are display-only for now, so this page will not appear until quota enforcement ships. You can set it up ahead of time.',
    blockedNote: 'Whether a blocked IP sees this page, has its connection dropped, or gets a kernel ban is set under Firewall → Blocking; this only sets what the page shows.',
    countedNote: 'Each time this page is served it counts toward "Default pages served" under Firewall → Node protection; an IP over that limit is banned.',
    preview: 'Preview',
    previewDrop: 'No page is sent when the connection is closed',
    previewFailed: 'Preview failed',
    resetPage: 'Reset this page',
    saved: 'Saved. Publishing to every node',
    saveFailed: 'Save failed',
  },
  consoleDomains: {
    title: 'Control plane domains',
    intro: 'The addresses of the customer console and the admin console. A bound domain opens its console without a port: http://domain on port 80, and https://domain on port 443 once it has a certificate. The existing ways in (http://IP and IP:8000) keep working. The domain nodes use to reach the control plane is set on the Node communication page.',
    addresses: 'Addresses',
    addressHttp: ' (works as soon as it is saved, no port needed)',
    addressHttpsPending: 'HTTPS works too once a valid certificate is in place',
    commonSection: 'General',
    httpsPort: 'HTTPS port',
    httpsPortHelp: 'The port browsers reach the consoles\' HTTPS on. The control plane serves it on 8443 inside the container, mapped to 443 in docker-compose; allow 443 in the server\'s security group.',
    email: 'Certificate contact email',
    emailHelp: 'Used by the CA for expiry notices, and for issuing and renewing both domains\' certificates.',
    ca: 'Certificate authority',
    site_customer: 'Customer console',
    site_admin: 'Admin console',
    domain: 'Domain',
    domainPlaceholder_customer: 'e.g. console.example.com',
    domainPlaceholder_admin: 'e.g. admin.example.com',
    domainHelp: 'Must resolve to the control plane server. To issue a certificate the CA fetches http://domain/.well-known/acme-challenge/ on port 80.',
    url: 'HTTPS address',
    urlNotReady: 'Available once a valid certificate is in place',
    unsaved: 'There are unsaved changes. Save before issuing or uploading a certificate.',
    redirect: 'Redirect HTTP to HTTPS',
    redirectHelp: 'Plain-HTTP visits to this domain are sent to HTTPS. Needs a certificate valid for the domain; the redirect stops on its own if the certificate expires, so the console stays reachable.',
    adminOnly: 'Admin console on its domain only',
    adminOnlyHelp: 'Visits to the admin console by IP:8000 or any other name get a 404; only the admin domain opens it, which hides the entrance. Off by default.',
    adminOnlyWrongHost: 'This page was opened at {host}. Open the admin console at {domain} first, then turn this on, so you can still get in afterwards.',
    adminOnlyRecover: 'If the admin domain stops working and you are locked out, run this on the control plane host to lift the restriction (takes effect within a minute):',
    adminOnlyConfirmTitle: 'Admin console on its domain only',
    adminOnlyConfirm: 'Only {domain} will open the admin console; IP:8000 and any other address will get a 404. Turn it on?',
    saved: 'Saved',
    saveFailed: 'Save failed',
  },
  clickhouse: {
    title: 'ClickHouse',
    connState: 'Connection status',
    intro: 'Access logs, security logs and node metrics history live in ClickHouse. Change the connection and how many days each table keeps here; when the disk fills up, the oldest days are deleted automatically.',
    connection: 'Connection',
    connected: 'Connected',
    disconnected: 'Disconnected',
    notConfigured: 'Not configured',
    versionUptime: 'ClickHouse {version} · up {uptime}',
    uptimeDays: '{d}d {h}h',
    uptimeHours: '{h}h {m}m',
    uptimeMinutes: '{m}m',
    disk: 'Disk usage',
    diskOf: '{used} of {total}',
    platformData: 'Platform data',
    rowsTotal: '{rows} rows',
    lastCleanup: 'Last cleanup',
    noCleanup: 'None yet',
    freed: '{size} freed',
    nothingTaken: 'Nothing deleted',
    test: 'Test connection',
    edit: 'Change connection',
    source: 'Source',
    sourceConsole: 'Set in the console',
    sourceFile: 'Config file',
    resetToFile: 'Use the config file connection',
    resetConfirm: 'Switch back to the connection in the config file (control.yaml or environment): {addr}?',
    resetDone: 'Now using the connection from the config file',
    addr: 'Address',
    database: 'Database',
    username: 'User',
    password: 'Password',
    passwordSet: 'Set',
    passwordEmpty: 'Not set',
    on: 'On',
    off: 'Off',
    status: 'Status',
    connectedSince: 'since {time}',
    failingSince: 'unreachable since {time}',
    version: 'Version',
    timezone: 'Time zone',
    schemaMissing: 'Tables are incomplete, missing: {items}',
    andMore: ' ({n} in all)',
    initSchema: 'Initialize tables',
    schemaDone: 'Tables initialized ({n} statements run)',
    passwordPlain: 'secrets.encryption_key is not set: the password saved here is stored unencrypted in the database',
    passwordUnreadable: 'The saved password cannot be decrypted: {error}',
    testOkLine: 'Connected · ClickHouse {version} · {ms} ms',
    testFailLine: 'Connection failed: {error}',
    tables: 'Tables',
    cleanNow: 'Clean up now',
    cleanConfirm: 'Clean up with the saved settings: delete data past its retention and, if the disk is over the threshold, the oldest days until it is back at the target. Deleted data cannot be recovered.',
    cleaned: 'Cleaned up: {what}',
    nothingToClean: 'Nothing to clean up',
    runSize: '{what}, {size} freed',
    runDays: '{n} days of data deleted',
    runLogs: '{n} system log tables emptied',
    listSep: ', ',
    noTables: 'The database has no tables yet; initialize them first',
    connectFirst: 'Connect to ClickHouse to see this',
    colTable: 'Data',
    colKeep: 'Keep',
    colRange: 'Range',
    colRows: 'Rows',
    colSize: 'Size on disk',
    days: 'days',
    defaultDays: 'default {n} days',
    dayCount: '{n} days',
    noData: 'No data',
    compressed: '{ratio}× compressed',
    ttlPending: 'Old TTL pending',
    ttlPendingHint: 'Retention is now enforced by the control plane, day by day. The TTL this table was created with is removed on the next cleanup (within 5 minutes); until then it still deletes data at its old age.',
    minuteStatsShort: 'Under 60 days, the Last 30 days comparison in Analytics is incomplete',
    table_edge_access_log: 'Access log',
    table_edge_security_log: 'Security log',
    table_node_metrics: 'Node metrics',
    table_edge_url_stats: 'Hourly URL summary',
    table_edge_ip_risk_stats: 'IP risk summary',
    table_edge_domain_minute_stats: 'Per-minute summary',
    tableHint_edge_access_log: 'One row per request. Access logs, access stats, origin stats and the Analytics rankings all read it, and its retention is how far back those pages can look.',
    tableHint_edge_security_log: 'What WAF, CC and access control blocked; the security events page reads it.',
    tableHint_node_metrics: 'One row per node per minute: CPU, memory, bandwidth, connections. The node detail charts read it.',
    tableHint_edge_url_stats: 'Requests and traffic per URL, by the hour.',
    tableHint_edge_ip_risk_stats: 'Blocks per IP, by five minutes.',
    tableHint_edge_domain_minute_stats: 'Requests, traffic, status codes and response times by the minute; the dashboard and Analytics trends read it.',
    systemLogs: 'ClickHouse system logs',
    usageLine: '{n} tables · {size}',
    truncate: 'Empty',
    truncateConfirm: 'Empty the log tables ClickHouse keeps about itself (query_log, trace_log and so on). They only serve to troubleshoot ClickHouse; platform data is not touched.',
    truncated: '{n} system log tables emptied, {size} freed',
    otherDatabases: 'Other databases',
    autoCleanup: 'Disk auto-cleanup',
    autoCleanupSwitch: 'Delete the oldest data automatically when the disk runs low',
    thresholdLine: 'Start when usage passes',
    thresholdThen: 'and clean down to',
    thresholdEnd: '',
    keepLine: 'Always keep the last',
    keepEnd: '(never deleted by auto-cleanup)',
    systemLogsFirst: 'Empty ClickHouse system logs first',
    systemLogsFirstHint: 'query_log, trace_log and the like only serve to troubleshoot ClickHouse, and are what usually fills the disk on a default install',
    order: 'Order: ClickHouse system logs → access log → security log → node metrics, URL and IP risk summaries → per-minute summary. Each from its oldest day, stopping at the target. Data past its retention is deleted regardless of this switch, checked every 5 minutes.',
    markHigh: 'Start {pct}%',
    markLow: 'Target {pct}%',
    diskLine: '{used} of {total} used · {free} free',
    pendingLine: ' · {size} pending deletion',
    history: 'Cleanup history',
    noHistory: 'No cleanups yet',
    colTime: 'Time',
    colTrigger: 'Trigger',
    colWhat: 'Deleted',
    colFreed: 'Freed',
    colDisk: 'Disk usage',
    colResult: 'Result',
    trigger_auto: 'Automatic',
    trigger_manual: 'Manual',
    trigger_policy: 'Settings saved',
    trigger_system_logs: 'System logs emptied',
    whatDays: '{table}: {n} days ({from} – {to})',
    whatDay: '{table}: {day}',
    whatLogs: 'System logs: {n} tables',
    resultOk: 'Done',
    resultShort: 'Still over the target',
    resultShortHint: 'What is left is all within the last {n} days that are always kept, or the disk is filled by other data',
    policySaved: 'Settings saved',
    policySavedCleaned: 'Settings saved and applied: {what}',
    problem: 'Could not read: {error}',
    connTitle: 'Change the ClickHouse connection',
    addrHelp: 'host:port, several separated by commas. The native-protocol port (9000 by default, usually 9440 with TLS), not HTTP 8123',
    databaseHelp: 'The database platform data lives in, cdnx_logs by default',
    passwordKeep: 'Leave empty to keep the current password',
    tls: 'Connect over TLS',
    tlsHelp: 'Usually needed for a cloud-managed ClickHouse; on port 9440 it is on anyway',
    initOnSave: 'Initialize tables when saving',
    initHelp: 'Creates the database and tables that do not exist yet; existing tables and data are left as they are',
    testFail: 'Connection failed',
    testOk: 'Connected · ClickHouse {version} · {ms} ms',
    testNoDatabase: 'The server has no database {database} yet; check Initialize tables when saving to create it',
    testMissing: '{n} schema items missing; check Initialize tables when saving to add them',
    testSchemaOk: 'Tables complete',
    connSaved: 'Switched to the new ClickHouse connection',
    savedNotConnected: 'Saved, but not reachable yet: {error}. It keeps retrying in the background',
  },
  controlTLS: {
    title: 'Node communication',
    intro: 'Give node-to-control traffic a communication domain and an SSL certificate, and nodes can reach the control plane over HTTPS. The config bundle nodes download holds every site\'s private key, and over plain HTTP it crosses the internet readable. Turning it on is your decision; it is off by default, and off behaves exactly as before. The addresses of the two consoles are set on the Control plane domains page.',
    domainSection: 'Communication domain',
    domain: 'Communication domain',
    domainPlaceholder: 'e.g. ctl.example.com',
    domainHelp: 'Used only by nodes to reach the control plane; must resolve to the control plane server. To issue a certificate the CA fetches http://domain/.well-known/acme-challenge/, so port 80 of the control plane has to be reachable from the internet.',
    port: 'Node port',
    portHelp: 'Nodes connect to https://domain:port. The control plane serves HTTPS on 18443 (mapped in docker-compose); if a port forward sits in front, enter the public port.',
    email: 'Certificate contact email',
    emailHelp: 'Used by the CA for expiry notices, and by automatic renewal.',
    ca: 'Certificate authority',
    unsavedDomain: 'The domain has unsaved changes. Save before issuing or uploading a certificate.',
    certSection: 'Certificate',
    noCert: 'No certificate yet. Issue a free one, or upload your own.',
    issue: 'Issue free certificate',
    reissue: 'Issue again',
    upload: 'Upload certificate',
    replace: 'Upload replacement',
    remove: 'Delete certificate',
    removeConfirm: 'Delete the control plane certificate? The HTTPS port will fail every handshake afterwards.',
    removeBlocked: 'Nodes are using this certificate. Set node transport to Off before deleting it.',
    removed: 'Certificate deleted',
    issueQueued: 'Issuance queued. It usually completes within a minute; follow it under System tasks.',
    issuing: 'Issuing certificate…',
    issueFailed: 'Certificate issuance failed',
    cancelIssue: 'Cancel',
    issueCancelled: 'Issuance cancelled',
    nextRetry: 'Retrying at {time} (attempt {attempt}/{max})',
    source: 'Source',
    sourceAcme: 'Issued automatically (renewed 30 days before expiry)',
    sourceUpload: 'Uploaded (replace it yourself before it expires)',
    names: 'Names',
    issuer: 'Issuer',
    validity: 'Valid',
    daysLeft: '{days} days left',
    status: 'Status',
    stateUsable: 'Usable',
    stateExpired: 'Expired or not yet valid',
    stateMismatch: 'Does not cover {domain}',
    trust: 'Trust',
    trusted: 'Issued by a public CA; nodes verify it as is',
    untrusted: 'Not issued by a public CA',
    untrustedHelp: 'Nodes trust public CAs only. With a private CA, set control_ca_file in /etc/cdnx/agent.json on every node to that CA certificate; otherwise nodes stay on HTTP and report why below.',
    keyEncrypted: 'Certificate private keys (every site\'s included) are stored encrypted with AES-256-GCM.',
    keyPlain: 'secrets.encryption_key (CDNX_SECRETS_ENCRYPTION_KEY) is not set, so certificate private keys are stored unencrypted. Set it and restart the control plane; existing keys are encrypted automatically.',
    uploadTitle: 'Upload control plane certificate',
    certPem: 'Certificate (PEM, with intermediates)',
    keyPem: 'Private key (PEM)',
    uploaded: 'Certificate saved',
    modeSection: 'Node transport',
    mode: 'Node transport',
    modeOff: 'Off',
    modeOffHint: 'Nodes keep using the address they were installed with (usually http://IP:18080).',
    modePrefer: 'Prefer HTTPS',
    modePreferHint: 'Nodes test the HTTPS address and switch once it works. While HTTPS is unreachable they fall back to the installed address, so they never lose contact.',
    modeRequire: 'HTTPS only',
    modeRequireHint: 'Nodes use HTTPS only and never fall back; the control plane refuses plain-HTTP node traffic. The most secure, but a failed control plane certificate cuts nodes off, so renewal must work.',
    needCert: 'A certificate valid for the domain is needed before HTTPS can be turned on',
    endpointNow: 'Address nodes are given',
    endpointNone: 'None (nodes use their installed address)',
    requireConfirmTitle: 'Some nodes still use HTTP',
    requireConfirm: '{message}. With HTTPS only these nodes cannot reach the control plane until fixed on the node. Turn it on anyway?',
    requireConfirmOk: 'Turn on anyway',
    nodesSection: 'Nodes',
    nodesIntro: 'The transport each node\'s last heartbeat arrived on. A node switches within seconds of receiving the new config.',
    nodesSummary: '{total} nodes: {https} on HTTPS, {http} on HTTP',
    colNode: 'Node',
    colTransport: 'Transport',
    colOnline: 'Online',
    colProblem: 'Problem',
    transportUnknown: 'Unknown',
    online: 'Online',
    offline: 'Offline',
    recoverHint: 'If a node loses contact under HTTPS only, run rm /var/lib/cdnx/control-endpoint.json && systemctl restart cdnx-agent on it; it goes back to its installed address and pulls the config again.',
    saved: 'Saved',
    saveFailed: 'Save failed',
  },
  firewall: {
    title: 'Firewall',
    intro: 'Which traffic from a kernel-banned IP the node firewall (nftables) drops. Saving publishes to every node; each node rebuilds its firewall rules as soon as it gets the config. Existing bans are kept.',
    scopeSection: 'Kernel ban scope',
    scope: 'Ban scope',
    scopePorts: 'Specified ports (recommended)',
    scopePortsHint: 'Drop only traffic from a banned IP to these ports',
    scopeAll: 'All ports',
    scopeAllHint: 'Drop all traffic from a banned IP, except to the exempt ports',
    tcpPorts: 'TCP ports',
    udpPorts: 'UDP ports',
    portsHelp: 'The node serves HTTP and HTTPS on 80 and 443.',
    udpHelp: 'UDP 443 is HTTP/3 (QUIC).',
    exemptTcp: 'Always-allowed TCP ports',
    exemptUdp: 'Always-allowed UDP ports',
    exemptHelp: 'Never affected by a ban. Usually the SSH port, so a mistaken ban cannot lock you out of the node.',
    portsPlaceholder: 'Type a port or range and press Enter, e.g. 443 or 8000-8100',
    summaryPorts: 'Traffic from a banned IP to {ports} is dropped in the kernel. Other ports are not affected.',
    summaryAll: 'All traffic from a banned IP to this node is dropped in the kernel, except {exempt}.',
    summaryAllNoExempt: 'All traffic from a banned IP to this node is dropped in the kernel, with no exceptions.',
    invalidPorts: 'Not a valid port or range: {ports}. Ports are 1-65535; write a range as 8000-8100.',
    noPorts: 'Specified-ports mode needs at least one port, or kernel bans block nothing.',
    warnEdgePorts: 'TCP 80 and 443 are not included: a banned IP can still reach the sites on the node.',
    warnAllPorts: 'All-ports mode drops every packet from a banned IP, including replies to connections the node opens itself: if a banned address happens to be an origin or a DNS server, the node cannot fetch from it or resolve names. The control plane is allowed automatically and is not affected.',
    warnNoSsh: 'TCP 22 is not allowed: a banned IP cannot SSH into the node. If SSH runs on another port, enter that port.',
    sync: 'Ban on every node',
    syncHelp: 'An address one node bans in its kernel is banned on every other node within seconds, for the rest of its ban. Releasing it in Ban Log releases it on every node.',
    trustSection: 'Always allowed',
    trustControl: 'Control plane',
    trustControlDesc: 'Each node resolves its control plane and trusts it, so no ban can cut a node off from it.',
    trustLoopback: 'Loopback',
    trustLoopbackDesc: 'Traffic from a node to itself (cache prefetch, for example) is always allowed.',
    trustOps: 'Ops / office IPs',
    trustOpsDesc: 'Add them to the IP list allow list; allow-list entries also go into every node\'s kernel allow set.',
    trustOpsLink: 'Open IP lists',
    blockSection: 'Blocking',
    blockMode: 'Default block action',
    blockPage: 'Show the block page',
    blockPageHint: 'its content is set under System → Default pages → Blocked',
    blockDrop: 'Drop the connection',
    blockDropHint: 'close it without a response (444)',
    blockKernel: 'Kernel ban',
    blockKernelHint: 'hand the IP to the node firewall; its packets are dropped in the kernel, the cheapest option',
    kernelBan: 'Kernel ban length',
    kernelBanHelp: 'How long a kernel ban lasts — in kernel mode, and when either condition below escalates. Bans can be lifted early in the ban log.',
    escalate: 'Escalate a repeat IP',
    escalateHelp: 'An IP blocked more often than this within the window is moved to a kernel ban: an address that keeps hitting the wall need not be handled in the edge every time.',
    blockedOver: 'Blocked over',
    surge: 'Escalate under attack',
    surgeHelp: 'When the node blocks more requests per second than this, every blocked IP goes straight to a kernel ban for the period that follows, instead of being handled in the edge one request at a time.',
    perSecondOver: 'Per second over',
    lasting: 'For',
    blockScopeNote: 'Blocking here means the platform deny list and the node\'s temporary bans (CC bans, failed-verification bans and so on). A customer\'s own deny list applies to their sites only, while a kernel ban covers every site on the node, so a customer\'s list is answered with the block page or a dropped connection and never escalates to the kernel.',
    guardSection: 'Node protection',
    guardIntro: 'Counted per source IP, before a request reaches any site. An IP over a limit is banned in the kernel; see and lift bans in the ban log. Addresses on the platform allow list are exempt.',
    guardBanLogs: 'Open the ban log',
    limit_conn_rate: 'Connection rate',
    limit_conn_rate_help: 'New TCP connections from one IP, 80 and 443 together, counted before the TLS handshake. Each HTTPS connection is one handshake, so this is also the TLS handshake flood limit. A banned IP is cut off before its handshake.',
    limit_tls_fail: 'Failed TLS handshakes',
    limit_tls_fail_help: 'No SNI (HTTPS to the bare IP), an SNI that is no domain on the platform, non-TLS data, or a handshake dropped midway each count as one failure. Such handshakes always fail outright and are shown no certificate.',
    limit_error_pages: 'Default pages served',
    limit_error_pages_help: 'How many default pages one IP is served: 403, WAF block, region block, rate limited, 400, unbound domain, node IP access (closing the connection counts too); blocks are handled by Blocking above. An IP collecting these is usually scanning or attacking, and is banned past the limit. Origin errors (502/504/500), too many connections and suspended sites do not count: those are the site\'s problem, not the visitor\'s.',
    openDefaultPages: 'Set up default pages',
    windowPrefix: 'Window',
    secondsSuffix: 's',
    thresholdPrefix: 'Over',
    timesSuffix: 'times',
    banPrefix: 'Ban',
    minutesSuffix: 'min',
    handshake: 'Handshake rate ceiling',
    handshakeHelp: 'The most new connections a node accepts per second, against handshake floods spread over too many addresses for the per-address limits to notice. Over the ceiling, visitors the node served recently still get in and new addresses are turned away for that second. With the fixed ceiling at 0, each node uses per-core × its own CPU cores. New free certificates are ECDSA, about a tenth of the handshake cost of RSA.',
    handshakePerCore: 'Per core',
    handshakeFixed: 'Fixed (0 = by cores)',
    handshakeKnown: 'Remember visitors',
    perSecondSuffix: '/s',
    crossSite: 'Block cross-site requests',
    crossSiteHelp: 'Answer 421 when an HTTPS connection made for one customer\'s domain (its SNI) carries a request for another customer\'s site — domain fronting. Sites of one customer are not affected: browsers reuse a connection across the names its certificate covers.',
    resetDefaults: 'Restore defaults',
    saved: 'Saved. Publishing to every node',
    saveFailed: 'Save failed',
    confirmAllTitle: 'Switch to all-ports bans?',
    confirmAll: 'All traffic from a banned IP to the node is dropped (except the exempt ports), including replies from origins and DNS servers. Publish to every node?',
    confirmAllNoSsh: 'No SSH port is allowed: if your own IP is ever banned by mistake, you cannot SSH into the node. All traffic from a banned IP to the node is dropped, including replies from origins and DNS servers. Publish to every node?',
    confirmAllOk: 'Publish',
  },
  ipLists: {
    title: 'IP Lists',
    introAdmin: 'Platform-wide allow and deny lists, applied to every site on every node.',
    introUser: 'Account-level allow and deny lists. Entries here apply to every site you own.',
    searchPlaceholder: 'Search address or note',
    checkEmpty: 'Cannot be empty',
    checkBadAddress: 'Not a valid IP address',
    checkBadCidr: 'Not a valid network',
    checkTooBroad: '/{bits} is too broad; the minimum is /{min}',
    checkDuplicate: 'Duplicate of a line above',
    problemsHead: '{n} problem(s) to fix before this can be submitted:',
    lineNo: 'line {n}',
    fixProblemsFirst: 'Fix the problems listed first',
    batchAddedSkipped: 'Added {n}; {s} were already listed and were skipped',
    modeSingle: 'Single',
    modeBatch: 'Bulk',
    bulkPlaceholder: 'One per line, e.g.\n1.2.3.4\n10.0.0.0/8\n2001:db8::/32',
    bulkHelp: '{n} recognised, up to {max} per batch. Commas work as separators too.',
    batchAdded: 'Added {n}',
    addDeny: 'Add to deny list',
    addAllow: 'Add to allow list',
    targetRequired: 'Enter an IP address or network',
    noMatch: 'Nothing matches that search',
    empty: 'No entries yet',
    tabDeny: 'Deny list',
    tabAllow: 'Allow list',
    enforceKernel: 'Kernel',
    enforceEdge: 'Edge',
    enforcementCol: 'Enforced at',
    enforcementNote: 'Kernel blocking drops the packet in nftables, so attack traffic costs the node no TLS handshake and almost no CPU — but it applies to the whole node, because the kernel has no idea which site a packet was for. It covers traffic to ports 80/443 only, so SSH and the link between the node and its control plane are never cut. Edge blocking refuses the request in the proxy, after the handshake.',
    userKernelHint: 'Account-level deny entries are always edge-enforced: a kernel drop applies to the entire node and would affect other customers on it.',
    tabAuto: 'Automatic bans',
    allowNote: 'The allow list wins over everything: an address on it is never stopped by a deny list, a CC ban, the WAF or human verification. Use it for monitoring probes, payment callbacks and anything else that must not be caught by a broad block.',
    autoNote: 'Addresses banned automatically by CC protection, already pushed to the node kernel with an expiry. The kernel clears them on its own; releasing one early also queues a task telling that node to remove it.',
    activeOnly: 'Active only',
    add: 'Add',
    added: 'Added',
    addFailed: 'Could not add this entry',
    targetPlaceholder: 'IP or network, e.g. 1.2.3.4 or 10.0.0.0/8',
    notePlaceholder: 'Note (optional)',
    targetCol: 'Address',
    noteCol: 'Note',
    addedCol: 'Added',
    ipCol: 'IP',
    nodeCol: 'Node',
    domainCol: 'Domain',
    ruleCol: 'Rule',
    bannedAtCol: 'Banned at',
    expiresCol: 'Expires',
    release: 'Release',
    released: 'Released',
    releaseQueued: 'Released; the node has been told to remove it',
    releaseRecorded: 'Release recorded, but the node could not be notified — the kernel ban clears when it expires',
    releaseFailed: 'Could not release this ban',
    confirmDeleteTitle: 'Delete this entry?',
    confirmDelete: '{target} will be removed from the list and the config republished to the nodes.',
    statTotal: 'Entries',
    statCap: 'up to {n}',
    statKernel: '{n} in kernel',
    statToday: 'Added today',
    listCount: '{n} in all',
    typeCol: 'Type',
    typeIp: 'IP',
    typeCidr: 'Range',
    denyHint: 'Kernel entries are dropped in nftables before any handshake and cover ports 80/443 on the whole node; edge entries are refused by the proxy.',
    filterAllLevels: 'Any enforcement',
  },
  cacheJobs: {
    targetsCount: '{n} target(s)',
    progress: '{done}/{total} nodes',
    historyCount: '{n} in all',
    section: 'Cache Purge',
    intro: 'Purging makes the nodes discard what they have cached, so the next request refetches from the origin. Prefetching pulls content to the nodes ahead of time so the first visitor already gets a hit. Jobs are sent to every node; one that is offline keeps its job queued and runs it when it returns.',
    kind: 'Type',
    sectionPurge: 'Cache Purge',
    sectionPrefetch: 'Cache Prefetch',
    prefetchIntro: 'Pull content to the nodes ahead of time so the first visitor already gets a hit. Useful before a release or a sale, to spread new assets out in advance.',
    modeNow: 'Run now',
    modeScheduled: 'Schedule',
    scheduledAt: 'Run at',
    scheduledHint: 'The job is sent to every node at this time. Up to 30 days ahead.',
    scheduledRequired: 'Pick a time',
    prefetchHistory: 'Prefetch history',
    purgeHistory: 'Purge history',
    status_scheduled: 'Scheduled',
    scheduledFor: 'scheduled for {t}',
    emptyPrefetch: 'No prefetch jobs yet',
    kindPurgeUrl: 'Purge URLs',
    kindPurgeDir: 'Purge directories',
    kindPurgeAll: 'Purge everything',
    kindPrefetch: 'Prefetch URLs',
    kind_purge_url: 'Purge URLs',
    kind_purge_dir: 'Purge dirs',
    kind_purge_all: 'Purge all',
    kind_prefetch: 'Prefetch',
    targets: 'Targets',
    targetsPlaceholder: 'One per line, e.g.\n/index.html\n/assets/app.js\nhttps://example.com/logo.png',
    targetsDirPlaceholder: 'One directory per line, e.g.\n/assets/\n/static/img/',
    targetsHelp: '{n} recognised, up to 1000 per job. Paths or full URLs; a URL must be on this site.',
    purgeAllWarning: 'This discards everything cached for this site on every node. Requests will go to the origin for a while afterwards and its load will rise noticeably — avoid doing this at peak.',
    submit: 'Submit',
    scheduledOk: 'Scheduled; it will be sent to the nodes at that time',
    submitted: 'Submitted; sending to the nodes',
    submitFailed: 'Could not submit this job',
    history: 'Job history',
    nodes: 'Nodes',
    failedN: '{n} failed',
    status_pending: 'Pending',
    status_running: 'Running',
    status_done: 'Done',
    status_failed: 'Partly failed',
    createdAt: 'Submitted',
    wholeSite: '(whole site)',
    empty: 'No jobs yet',
  },
  audit: {
    title: 'Audit logs',
    intro: 'Every console mutation plus Agent / Open API write is recorded here.',
    timeCol: 'Time',
    actorTypeCol: 'Actor',
    actorCol: 'Identity',
    actionCol: 'Action',
    resourceCol: 'Resource',
    ipCol: 'IP',
    detailCol: 'Detail',
    filterActorType: 'Actor type',
    filterResourceType: 'Resource type',
    filterAction: 'Action',
    filterRange: 'Time range',
    actorUser: 'User',
    actorSystem: 'System',
    actorAgent: 'Agent',
    actorApiKey: 'API key',
    refresh: 'Refresh',
    detailModalTitle: 'Audit detail',
    before: 'Before',
    after: 'After',
    empty: 'No audit records match the current filters',
  },
  license: {
    title: 'License',
    sectionTitle: 'License',
    stateNone: 'Not activated',
    stateActive: 'Licensed',
    stateExpired: 'Expired',
    stateRefused: 'Refused',
    stateDev: 'Development build',
    stateOverdue: 'Renewal overdue',
    noneTitle: 'This control plane has no license',
    noneBody: 'Licenses come from the portal only: activate one below with a license code. Until then customers can view but not change anything, and no node or site can be added; this console is unaffected.',
    expiredTitle: 'The license has expired',
    expiredBody: 'Its lease or term is over, so customers can view but not change anything. It renews itself once the portal can be reached; if the term is over, renew it on the portal and click Renew now.',
    refusedTitle: 'The portal refuses to renew the license',
    refusedBody: '{reason}. The customer console is read-only. Once the portal restores the license, the control plane, which asks again every hour, comes back by itself.',
    devTitle: 'Development build',
    devBody: 'This binary has no license key built in (it is not a release build), so it checks no license and limits nothing. Release builds come from the release pipeline.',
    overdueTitle: 'The license has not been renewed for a while',
    overdueBody: 'Half of its lease is gone without a renewal. If it is still not renewed by {at}, the customer console becomes read-only. Last failure: {reason}',
    licenseId: 'License ID',
    issuedTo: 'Licensed to',
    edition: 'Edition',
    kind: 'Kind',
    kindOnline: 'Online (renews itself)',
    kindOffline: 'Offline license file',
    termEndsAt: 'License ends',
    leaseEndsAt: 'Lease ends',
    noLease: 'An offline license has no lease',
    nodesLimit: 'Node limit',
    domainsLimit: 'Site limit',
    unlimited: 'Unlimited',
    renewedAt: 'Last renewed',
    nextTry: 'Next renewal',
    never: 'Not yet',
    channel: 'Release channel',
    channel_stable: 'Stable',
    channel_beta: 'Beta',
    features: 'Features',
    feature_waf: 'WAF',
    feature_cc: 'CC protection',
    feature_cache: 'Caching',
    renewNow: 'Renew now',
    renewed: 'Renewed',
    instanceTitle: 'This instance',
    instanceIntro: 'The portal knows this control plane by its instance ID. The instance key lives in the state volume and is made on first start; a reinstall or a new host is a new instance ID and needs activating again. The portal lists the instance ID and machine fingerprint too, to match against these; for an offline license, give it this instance ID.',
    instanceId: 'Instance ID',
    fingerprint: 'Machine fingerprint',
    portal: 'Portal',
    release: 'Release instance',
    releaseTitle: 'Release this control plane from its license?',
    releaseBody: 'The portal takes back the instance slot this control plane holds, and it is not activated from then on: customers can view but not change anything, and no node or site can be added. Use it to move the license to another control plane.',
    releaseOk: 'Release',
    released: 'Released: this control plane is not activated now',
    activateTitle: 'Activate a license',
    activateAnother: 'Change license',
    activateIntro: 'Find the license code in the portal console. The control plane signs the activation with its instance key and gets back the license bound to this instance, its lease and a download token for the release repository.',
    code: 'License code',
    codeHelp: 'CDNX-XXXX-XXXX-XXXX-XXXX, in any case',
    activate: 'Activate',
    activated: 'License {id} activated',
    offlineTitle: 'Offline license file',
    offlineIntro: 'For a control plane that cannot reach the portal: issue an offline license for this instance ID on the portal, download the .cdnx file and upload it here. It does not renew itself; issue a new one before it ends.',
    offlineUpload: 'Upload license file',
    uploaded: 'Offline license {id} installed',
  },
  dashboard: {
    welcome: 'Welcome back, {name}',
    sites: 'Sites',
    nodes: 'Nodes',
    users: 'Users',
    subscriptions: 'Packages',
    unitSites: 'sites',
    unitNodes: 'nodes',
    unitUsers: 'customers',
    unitSubs: 'packages',
    unitCurrency: 'CNY',
    today: 'Today',
    recharge: 'Total top-ups',
    certs: 'Certificates',
    unitCerts: 'certs',
    certsDue: '{n} to renew',
    nodesLost: '{n} unreachable',
    trend: 'Growth',
    trendTotal: '{n} {unit} in the last {days} days',
    metric_sites: 'Sites',
    metric_users: 'Users',
    metric_subscriptions: 'Packages',
    series_sites: 'New sites',
    series_users: 'New users',
    series_subscriptions: 'Packages sold',
    last7: 'Last 7 days',
    last30: 'Last 30 days',
    viewMore: 'More',
    topSites: 'Top 10',
    topUnavailable: 'Log storage (ClickHouse) is not configured, so sites cannot be ranked by traffic',
    siteStatus: 'Site status',
    siteActive: 'Serving',
    siteDraft: 'Setting up',
    siteSuspended: 'Suspended',
    siteDisabled: 'Disabled',
    certStatus: 'Certificate status',
    certValid: 'Valid',
    certExpiring: 'Expiring',
    certExpired: 'Expired',
    subStatus: 'Package status',
    subsSold: 'Sold',
    subActive: 'Active',
    subExpiring: 'Expiring',
    subExpired: 'Expired',
    subCancelled: 'Cancelled',
    quick: 'Shortcuts',
    attention: 'Needs attention',
    allClear: 'All clear — nothing needs attention',
    tag_node: 'Node',
    tag_cert: 'Cert',
    tag_site: 'Site',
    tag_sub: 'Package',
    tag_task: 'Task',
    lostNodes: '{n} unreachable for 5+ min',
    servingAlerts: '{n} not serving as published',
    pendingNodes: '{n} awaiting setup',
    certsExpired: '{n} expired',
    certsExpiring: '{n} expiring within 14 days',
    sitesSuspended: '{n} suspended',
    sitesDraft: '{n} awaiting CNAME',
    subsExpiring: '{n} expiring within 7 days',
    tasksFailed: '{n} failed in the last 24h',
    tag_ticket: 'Ticket',
    ticketsOpen: '{n} awaiting support',
    tag_license: 'License',
    licenseNone: 'This control plane has no license',
    licenseExpired: 'The license has expired; customers are read-only',
    licenseRefused: 'The portal refuses to renew the license; customers are read-only',
    licenseOverdue: 'Half the license lease is gone without a renewal',
  },
  layout: {
    navbarHeight: 'Bar height',
    menuWidth: 'Menu width',
    colorWeak: 'Color weakness',
    grayscale: 'Grayscale',
  },
  custom: {
    notify: 'Notifications',
    sound: 'New message sound',
    soundDesc: 'A chime when a ticket gets a reply',
    speech: 'Spoken alert',
    speechDesc: 'Reads out “You have a new ticket message” when a reply comes in',
    title: 'Customize',
    theme: 'Theme',
    theme_light: 'Light',
    theme_dark: 'Dark',
    theme_twotone: 'Two-tone',
    navbar: 'Top bar',
    navbar_on: 'Show the top bar',
    navbar_onDesc: 'Search, messages and your account at the top',
    navbar_off: 'Hide the top bar',
    navbar_offDesc: 'More room; open these settings from the corner button',
    menu: 'Side menu',
    menu_on: 'Show the menu',
    menu_onDesc: 'The navigation menu on the left',
    menu_off: 'Hide the menu',
    menu_offDesc: 'Pages take the full width',
    pageTitle: 'Page title',
    pageTitle_on: 'Show page titles',
    pageTitle_onDesc: "The page's name above its content",
    pageTitle_off: 'Hide page titles',
    pageTitle_offDesc: 'No page name, a tighter layout',
    access: 'Accessibility',
    fullscreenDesc: 'The console fills the screen; Esc leaves',
    colorWeakDesc: 'Inverted colours, easier to tell apart',
    grayscaleDesc: 'The whole console in greys',
    reset: 'Restore defaults',
  },
  skin: {
    ultra: 'Ultra Blue',
    tech: 'Tech Blue',
    sea: 'Sea Blue',
    haze: 'Haze Blue',
    starry: 'Starry Purple',
    night: 'Night Purple',
    youth: 'Youth Purple',
    magenta: 'Magenta',
    romantic: 'Romantic Red',
    china: 'China Red',
    autumn: 'Autumn Red',
    vibrant: 'Vibrant Orange',
    dusk: 'Dusk Gold',
    meadow: 'Meadow Green',
    forest: 'Forest Green',
    turquoise: 'Turquoise',
    wave: 'Wave Cyan',
    slate: 'Slate Grey',
    custom: 'Custom colour',
    inUse: 'In use',
  },
  monitor: {
    title: 'Monitoring',
    bandwidth: 'Peak bandwidth',
    requests: 'Requests',
    traffic: 'Traffic',
    bans: 'Bans',
    banIps: 'Banned IPs',
    hits: 'Cache hits',
    range_1h: '1h',
    range_today: 'Today',
    range_yesterday: 'Yesterday',
    range_7d: '7d',
    range_30d: '30d',
    window_1h: 'Last hour',
    window_today: 'Today',
    window_yesterday: 'Yesterday',
    window_7d: 'Last 7 days',
    window_30d: 'Last 30 days',
    vs_1h: 'vs the hour before',
    vs_today: 'vs yesterday so far',
    vs_yesterday: 'vs the day before',
    vs_7d: 'vs the 7 days before',
    vs_30d: 'vs the 30 days before',
    unitTimes: 'times',
    unitIps: 'IPs',
    loadFailed: 'Could not load the monitoring data',
    noLogs: 'Log storage (ClickHouse) is not configured, so bandwidth, requests, traffic and cache hits cannot be counted',
  },
  top: {
    dim_domain: 'Domains',
    dim_url: 'URLs',
    dim_ip: 'IPs',
    dim_country: 'Countries',
    dim_status: 'Status',
    dim_isp: 'ISPs',
    dim_referer: 'Referrers',
    dim_node: 'Nodes',
    direct: 'Direct',
    nodeId: 'Node #{id}',
    unknown: 'Unknown',
    requests: 'Requests',
    traffic: 'Traffic',
  },
  nodePanel: {
    title: 'Nodes',
    summary: '{online} of {total} online',
    justNow: 'just now',
    secondsAgo: '{n}s ago',
    minutesAgo: '{n} min ago',
    hoursAgo: '{n} h ago',
    daysAgo: '{n} d ago',
    lost: 'Lost',
    cpu: 'CPU',
    mem: 'Mem',
    tx: 'Out',
    empty: 'No nodes yet.',
    add: 'Add a node',
  },
  stats: {
    title: 'Statistics',
    hostnames: 'Hostnames',
    l4Forwards: 'App Acceleration',
    lineGroups: 'Line groups',
    nodeIps: 'Node IPs',
    denyIps: 'IP denylist',
    allowIps: 'IP allowlist',
    activeBans: 'Active bans',
    pendingTasks: 'Pending tasks',
    unitItems: '',
    unitRules: '',
    unitEntries: '',
  },
  licenseCard: {
    title: 'License',
    paid: 'Licensed',
    edition_trial: 'Trial',
    edition_standard: 'Standard',
    edition_enterprise: 'Enterprise',
    expired: 'Expired',
    nodes: 'Nodes',
    sites: 'Sites',
    unlimited: 'Unlimited',
    expiresAt: 'Expires',
    daysLeft: '{n} days left',
    dueToday: 'Expires today',
    expiredShort: 'Expired',
    holder: 'Licensed to',
    readOnly: 'The license has expired: customers can view but not change anything until it is renewed. This console is unaffected.',
    unavailable: 'Could not read the license.',
    none: 'Not activated',
    noneBody: 'This control plane has no license: customers can view but not change anything, and no node or site can be added.',
    activate: 'Activate',
    refused: 'Refused',
    refusedBody: 'The portal refuses to renew the license: customers can view but not change anything.',
    dev: 'Development build',
    overdue: 'Renewal overdue',
  },
  // 工单管理.
  tickets: {
    vipFirstTip: 'VIP{n} · priority support',
    confidential: 'Send confidentially',
    confidentialHelp: 'For passwords, keys and the like: the message is masked until opened, never shown in mail or in-app messages, and its content and files are destroyed when the ticket closes.',
    confidentialNoClose: 'A confidential message is destroyed when the ticket closes, so it cannot close the ticket',
    title: 'Tickets',
    detailTitle: 'Ticket',
    unit: 'tickets',
    statOpen: 'Open',
    statProcessing: 'In progress',
    statReplied: 'Awaiting customer',
    statRating: 'Satisfaction',
    ratingUnit: '/ 5 · {n} ratings',
    listTitle: 'Tickets',
    count: '{n} in total',
    searchPlaceholder: 'Search descriptions or ticket numbers',
    filter_active: 'Not closed',
    filter_open: 'Open',
    filter_processing: 'In progress',
    filter_replied: 'Awaiting customer',
    filter_closed: 'Closed',
    filter_all: 'All states',
    allAssignees: 'Anyone',
    mine: 'Mine ({n})',
    unassigned: 'Unassigned ({n})',
    allCategories: 'All categories',
    allPriorities: 'All priorities',
    noMatch: 'No tickets match',
    empty: 'No tickets yet',
    nobody: 'Unassigned',
    handle: 'Handle',
    colTicket: 'Ticket',
    colNo: 'Ticket no.',
    colPriority: 'Priority',
    colAssignee: 'Assignee',
    colUpdated: 'Updated',
    status_open: 'Open',
    status_processing: 'In progress',
    status_replied: 'Awaiting customer',
    status_closed: 'Closed',
    priority_normal: 'Normal',
    priority_high: 'High',
    priority_urgent: 'Urgent',
    missing: 'Ticket not found',
    toList: 'Back to tickets',
    category: 'Category',
    site: 'Site',
    filedAt: 'Filed',
    accept: 'Take on',
    accepted: 'Taken on: the customer sees it in progress',
    closeTicket: 'Close ticket',
    closeTitle: 'Close ticket',
    closeContent: 'Close "{title}"? The customer can no longer reply, but can rate the help they got.',
    close: 'Close',
    closedDone: 'Ticket closed',
    modeReply: 'Reply',
    modeNote: 'Internal note',
    insertTemplate: 'Insert canned reply',
    manageTemplates: 'Manage canned replies',
    closedNoteOnly: 'The ticket is closed: only internal notes can be added.',
    replyPlaceholder: 'Reply to the customer; paste or drop pictures in; Ctrl / ⌘ + Enter sends',
    notePlaceholder: 'Only support sees internal notes; Ctrl / ⌘ + Enter adds',
    send: 'Send',
    sendClose: 'Send and close',
    addNote: 'Add note',
    bodyRequired: 'Write something',
    replied: 'Reply sent',
    repliedClosed: 'Reply sent and ticket closed',
    noted: 'Note added',
    handling: 'Handling',
    takeIt: 'Assign to me',
    meTag: '(me)',
    priority: 'Priority',
    assigned: 'Assigned to {name}',
    unassignedDone: 'Unassigned',
    prioritySet: 'Priority set to {priority}',
    customerTitle: 'Customer',
    username: 'Username',
    email: 'Email',
    phone: 'Phone',
    realname: 'Verification',
    account: 'Account',
    allOfCustomer: 'All tickets of this customer',
    infoTitle: 'Details',
    staffReplyAt: 'Last reply',
    closedAt: 'Closed',
    closedBy_customer: 'by the customer',
    closedBy_staff: 'by support',
    closedBy_auto: 'automatically',
    rating: 'Rating',
    notRated: 'Not rated',
  },
  ticketTemplates: {
    title: 'Canned replies',
    count: '{n} of {max}',
    add: 'New canned reply',
    editTitle: 'Edit canned reply',
    intro: "Inserted into a ticket's reply box with a click. {u} becomes the customer's username and {n} the ticket number.",
    empty: 'No canned replies yet',
    colTitle: 'Name',
    colBody: 'Reply',
    colUpdated: 'Updated',
    titlePlaceholder: 'e.g. Ask for the origin details',
    bodyHelp: "{u}: the customer's username; {n}: the ticket number. Filled in as it is inserted.",
    bodyPlaceholder: 'Hello {u}, …',
    saved: 'Canned reply saved',
    added: 'Canned reply added',
    deleteTitle: 'Delete canned reply',
    deleteContent: 'Delete the canned reply "{title}"?',
    deleted: 'Deleted',
  },
  ticketSettings: {
    supportTitle: 'Support name',
    supportIntro: 'What customers call support in ticket conversations and the service assistant\'s messages, set for each console language. Mail and in-app message wording is edited in Message templates.',
    supportName: 'Chinese name',
    supportNameHelp: 'Used in the Chinese console. Empty shows "客服".',
    supportNameEn: 'English name',
    supportNameEnHelp: 'Used in the English console. Empty shows "Support".',
    title: 'Ticket settings',
    filingTitle: 'Online filing',
    filingIntro: 'Switched off, customers cannot file new tickets; the ones filed can still be read and answered.',
    notice: 'Notice',
    noticeHelp: 'Shown at the top of the form customers file tickets with: support hours, how to reach you in an emergency.',
    noticePlaceholder: 'e.g. Tickets are answered 9:00–21:00 every day. For emergencies call 400-000-0000',
    categoriesTitle: 'Categories',
    categoriesCount: '{on} on, {n} in all, at most {max}',
    categoriesIntro: 'Customers pick one when filing, in this order. Rather than delete a category no longer used, switch it off: it leaves the form, and tickets filed under it keep its name.',
    colNo: 'No.',
    colName: 'Name',
    colEnabled: 'On',
    categoryPlaceholder: 'Name, at most 20 characters',
    moveUp: 'Move up',
    moveDown: 'Move down',
    addCategory: 'Add category',
    autoCloseTitle: 'Auto-close',
    autoCloseIntro: 'When support has replied and the customer does not answer within the days set, the ticket closes by itself and the customer is told.',
    autoCloseDays: 'Wait for the customer',
    autoCloseHelp: '0–90 days; 0 never closes a ticket by itself.',
    days: 'days',
    notifyTitle: 'Notifications',
    notifyIntro: 'In-console alerts are always on: the menu and the notifications at the top right tell customers and support of new replies. Mail needs the mail service set up.',
    mailNotReady: 'The mail service is not set up: no mail is sent.',
    mailReady: 'The mail service is on: notifications come from {from}.',
    toMail: 'Mail settings',
    notifyCustomer: 'Mail customers',
    notifyCustomerHelp: "When support replies or closes a ticket, mail the customer's account address.",
    notifyStaff: 'Mail support',
    notifyStaffHelp: "When a ticket is filed or a customer replies, mail the ticket's assignee; while it has none, the addresses below.",
    staffEmails: 'Support addresses',
    staffEmailsHelp: 'Unassigned tickets are mailed here; at most {max}.',
    staffEmailsPlaceholder: 'Type an address and press Enter',
    saved: 'Ticket settings saved',
  },
  assistantSettings: {
    animated: 'Animation',
    animatedHelp: 'When on, the mark moves a little: the spark twinkles, the pinwheel turns, and the mascots\' eyes follow the pointer and blink; faster while an answer is written. Not shown to customers whose system asks for reduced motion.',
    icon: 'Icon',
    icon_bubble: 'Bubble',
    icon_cloud: 'Cloud',
    icon_cube: 'Cube',
    icon_orb: 'Orb',
    icon_pinwheel: 'Pinwheel',
    icon_spark: 'Spark',
    iconHelp: 'The mark on the assistant\'s button, panel title and greeting in the customer console.',
    inputGlow: 'Glowing input border',
    inputGlowHelp: 'A band of colour runs round the input box\'s border. A static colour border for customers whose system asks for reduced motion.',
    inputHints: 'Rotating hints in the input',
    inputHintsHelp: 'While the box is empty, the suggested questions turn over inside it; Enter or Send asks the one showing.',
    launcher: 'Button shape',
    launcher_capsule: 'Tall capsule',
    launcher_circle: 'Round',
    launcherHelp: 'The capsule shows the name down it, under the icon.',
    navLabel: 'Name in the navbar',
    navLabelHelp: 'On, the navbar entry shows the icon and the name; off, the icon alone, with the name on hover. Phones always show the icon alone.',
    placement: 'Placement',
    placement_both: 'Both',
    placement_float: 'Bottom right',
    placement_navbar: 'Navbar',
    placementHelp_both: 'Both the floating button and the navbar entry; they open the same panel.',
    placementHelp_float: 'A floating button at the bottom right of the page; the panel opens there.',
    placementHelp_navbar: 'An entry in the navbar, right of the search box; the panel opens under the navbar.',
    title: 'AI Assistant',
    mainTitle: 'AI Assistant',
    mainIntro: 'When on, the customer console offers the AI assistant (where: see Placement below), and customers can ask about adding sites, troubleshooting, packages and billing. Answers come from the model configured below.',
    stateOff: 'Off',
    stateReady: 'Live',
    stateIncomplete: 'Incomplete',
    name: 'Chinese name',
    nameHelp: 'Title and greeting in the Chinese console. Empty shows "智能助手".',
    nameEn: 'English name',
    nameEnHelp: 'Title and greeting in the English console. Empty shows "AI Assistant".',
    modelTitle: 'Model',
    modelIntro: 'Any model service with an OpenAI-compatible Chat Completions API; DeepSeek by default. Picking a provider fills in its address and a suggested model.',
    provider: 'Provider',
    provider_deepseek: 'DeepSeek',
    provider_qwen: 'Qwen',
    provider_ark: 'Volcano Ark',
    provider_openai: 'OpenAI',
    provider_custom: 'Custom',
    baseUrl: 'API address',
    baseUrlHelp: 'Requests go to "API address/chat/completions".',
    model: 'Model',
    modelHelp_deepseek: 'deepseek-chat answers fast; deepseek-reasoner reasons first — slower and costlier.',
    modelHelp_qwen: 'For example qwen-plus or qwen-max.',
    modelHelp_ark: 'The endpoint ID from the Ark console (starting ep-) or a model name.',
    modelHelp_openai: 'For example gpt-4o-mini or gpt-4o.',
    modelHelp_custom: 'The model name your provider gives.',
    apiKey: 'API key',
    keyHelp: 'Stored encrypted and never shown again.',
    keyKept: 'Saved; leave empty to keep it.',
    keyAgain: 'The API address changed: enter the API key again. The old key is never sent to a new address.',
    keySet: 'Set; leave empty to keep',
    temperature: 'Temperature',
    temperatureHelp: '0 to 2: lower is steadier, higher is more varied. 0.3 to 0.8 suits support.',
    maxTokens: 'Answer limit',
    maxTokensHelp: '256 to 8192 tokens; longer answers are cut off.',
    answerTitle: 'Answers',
    answerIntro: 'What the assistant can see, how much each customer may ask, and your own instructions to the model.',
    accountContext: 'Read the customer\'s account',
    accountContextHelp: 'When on, each question is sent to the model provider with the customer\'s own sites and their state, package expiry, balance and ticket counts, so it can answer questions like "why is my site suspended". Never keys, phone numbers or email addresses.',
    dailyLimit: 'Questions per customer per day',
    dailyLimitHelp: 'Resets at midnight, Beijing time. 0 is no limit.',
    unitTimes: '',
    prompt: 'Instructions',
    promptHelp: 'Added after the platform\'s own: support contacts, promotions, rules to stress.',
    promptPlaceholder: 'For example: when you cannot solve a problem, ask the customer to open a ticket or call 400-000-0000.',
    suggestions: 'Suggested questions',
    suggestionsHelp: 'Shown under "You might ask" on the assistant\'s home: at most {max}, 60 characters each.',
    suggestionPlaceholder: 'For example: why has my CNAME not taken effect?',
    suggLangZh: 'Chinese console',
    suggLangEn: 'English console',
    suggestionPlaceholderEn: 'e.g. How do I put my website on the CDN?',
    addSuggestion: 'Add a question',
    testTitle: 'Connection test',
    testIntro: 'Sends the model a short message with the saved settings, to check the address, model and API key.',
    testRun: 'Test the connection',
    testUnsaved: 'You have unsaved changes; the test uses the saved settings.',
    testNoKey: 'Enter and save an API key first.',
    testOk: 'Connected: {model} answered in {ms} ms: "{reply}"',
    usageTitle: 'Usage',
    usageToday: 'Questions today',
    usageUsers: 'Customers today',
    usage30: 'Questions, 30 days',
    usageTokens: 'Tokens, 30 days',
    usageQuestions: 'Questions',
    usageFailed: '{n} answers failed in the last 30 days; the model provider\'s console says why.',
    saved: 'Saved',
  },
  identityReveal: {
    title: 'Full ID number',
    note: 'This look is in the audit log. Open numbers only when needed, such as for a police investigation, and do not share screenshots.',
    account: 'Account',
    name: 'Name',
    idCard: 'ID card number',
    creditCode: 'Unified social credit code',
    open: 'Show full number',
    openShort: 'Show',
    close: 'Close',
  },
  memberModal: {
    title: 'Level & VIP · {user}',
    tabVip: 'VIP growth',
    tabExp: 'EXP',
    notVip: 'Not a VIP',
    notVipShort: 'not a VIP',
    growthUnit: 'growth points',
    expUnit: 'EXP',
    toNextVip: '{n} growth points to VIP{lv}',
    vipTop: 'Top VIP level',
    toNextLv: '{n} EXP to LV{lv}',
    lvTop: 'Top level',
    adjustGrowth: 'Change growth',
    adjustExp: 'Change EXP',
    add: 'Add',
    sub: 'Take away',
    amount: 'Amount',
    notePlaceholder: 'Why (the customer sees it in their history)',
    apply: 'Apply',
    previewGrowth: 'After: {n} growth points · {level}',
    previewExp: 'After: {n} EXP · LV{lv}',
    confirmGrowthAdd: 'Give {user} {n} growth points?',
    confirmGrowthSub: 'Take {n} growth points from {user}?',
    confirmExpAdd: 'Give {user} {n} EXP?',
    confirmExpSub: 'Take {n} EXP from {user}?',
    growthHelp: 'The VIP level follows growth points through the thresholds in Level & VIP; every change goes into the growth history.',
    expHelp: "The level follows EXP; every change goes into the customer's EXP history.",
    doneGrowth: 'Growth changed',
    doneExp: 'EXP changed',
    recordsGrowth: 'Growth history',
    recordsExp: 'EXP history',
    recordsSub: 'latest {n}',
    after: 'after: {n}',
    colTime: 'Time',
    colChange: 'Change',
    colAfter: 'After',
    colNote: 'Why',
    colSource: 'Source',
    colActor: 'By',
    system: 'System',
    source_daily: 'Daily visit',
    source_task: 'Starter task · {task}',
    source_adjust: 'Platform change',
    empty: 'No history yet',
  },
  memberSettings: {
    title: 'Level & VIP',
    saved: 'Saved',
    saveFailed: 'Could not save',
    vipTitle: 'VIP',
    vipIntro: "A customer's VIP level (VIP1–VIP10) follows their growth, which is changed in the customer list; every change is recorded.",
    toUsers: 'VIP customers',
    thresholds: 'VIP growth thresholds',
    thresholdsHelp: 'Reaching a threshold makes a customer that VIP level; each must be higher than the one before. Saving moves every customer to the new thresholds at once, and each move goes into their growth history.',
    thresholdsBad: 'Each threshold must be higher than the one before',
    badge: 'VIP badge',
    badgeHelp: "Shown beside a VIP customer's name, the same in both consoles.",
    badge_standard: 'Standard shield',
    badge_facet: 'Faceted shield',
    badge_holo: 'Holo black card',
    badge_capsule: 'Shimmer capsule',
    badge_tiered: 'Tiered',
    ticketFirst: 'Priority support',
    ticketFirstHelp: "VIP customers' open tickets come first in the ticket list, the higher VIP level ahead.",
    expTitle: 'Earning EXP',
    expIntro: 'Customers climb from LV1 to LV100 with EXP. Each is 0 to {max} EXP; 0 gives none.',
    daily: 'Daily visit',
    dailyHelp: 'Given the first time a customer opens the console each day, China time.',
    expUnit: 'EXP',
    tasks: 'Starter tasks',
    tasksHelp: 'Each is given once; customers who have done one already get it the next time they open the console. 0 leaves the task out.',
    task_realname: 'Verify identity',
    task_phone: 'Bind a phone',
    task_guard: 'Turn on sign-in protection',
    task_site: 'Add the first site',
    taskHelp_realname: 'Passing individual or enterprise verification.',
    taskHelp_phone: 'Proving a phone with a texted code.',
    taskHelp_guard: 'Binding an MFA device, or turning on texted codes at sign-in.',
    taskHelp_site: 'Adding the first site.',
    curveTitle: 'Level curve',
    curveIntro: 'The next level takes 5 × the current level in EXP. Below: the EXP each level starts at, and roughly how long daily visits alone take.',
    stepExp: '{n} EXP',
    paceDays: '~{n} days',
    paceYears: '~{n} yrs',
    paceNote: 'At {daily} EXP a day, the top level (LV100) takes {top}; starter tasks speed up the first levels.',
    paceOff: 'Daily visits are off: customers earn EXP from starter tasks only.',
  },
  realnameSettings: {
    title: 'ID verification',
    stateOff: 'Off',
    stateReady: 'Ready',
    stateIncomplete: 'Incomplete',
    listTitle: 'Verification methods',
    listIntro: 'When on, customers verify themselves in the console by a method from this list, in this order, and are verified once it passes. Mainland China and international each have a list: accounts in mainland China see the first, the rest the second; only methods whose provider is set up are shown.',
    listDrag: ' Drag a row by its handle to reorder.',
    addMethod: 'Add method',
    listEmpty: 'No methods yet',
    listEmptySub: 'Set up a provider under Provider accounts below, then add its methods',
    colProvider: 'Provider',
    colReady: 'Provider status',
    colShown: 'Shown',
    colActions: 'Actions',
    statusOk: 'Usable',
    region_cn: 'Mainland China',
    region_intl: 'International',
    regionHint_cn: 'Accounts in mainland China are offered these (by the country in their profile)',
    regionHint_intl: 'Accounts elsewhere are offered these: a document and a face check on the provider\'s page',
    configRegion_cn: 'Mainland China',
    configRegion_intl: 'International',
    provider_sumsub: 'Sumsub',
    provider_veriff: 'Veriff',
    providerShort_sumsub: 'Sumsub',
    providerShort_veriff: 'Veriff',
    providerHint_sumsub: 'A Sumsub app\'s token and secret key; the verification level says which documents and checks it asks for',
    providerHint_veriff: 'A Veriff integration\'s API key and shared secret key',
    method_SUMSUB_IDV: 'Document and face check',
    method_VERIFF_IDV: 'Document and face check',
    methodHint_SUMSUB_IDV: 'A passport, ID card or driving licence photographed on Sumsub\'s page, then a liveness selfie; most countries',
    methodHint_VERIFF_IDV: 'A passport, ID card or driving licence photographed on Veriff\'s page, then a liveness selfie; most countries',
    appTokenHelp: 'Made in Sumsub\'s dashboard under Developers → App Tokens; prd: is production',
    sumsubSecretPlaceholder: 'Sumsub secret key',
    levelName: 'Verification level',
    levelNameHelp: 'A level made in Sumsub\'s dashboard: which documents and checks it asks for',
    veriffKeyHelp: 'Shown on the integration\'s page in Veriff\'s dashboard',
    veriffSecretPlaceholder: 'Veriff shared secret key',
    why_level: 'No level',
    whyHint_level: 'Enter the level\'s name under Provider accounts → International → Sumsub',
    addTitle_cn: 'Add mainland China methods',
    addTitle_intl: 'Add international methods',
    doc_PASSPORT: 'Passport',
    doc_ID_CARD: 'ID card',
    doc_DRIVERS: 'Driving licence',
    doc_RESIDENCE_PERMIT: 'Residence permit',
    why_account: 'Not set up',
    why_rule: 'No RuleId',
    why_authCode: 'No AuthCode',
    why_baseUrl: 'No return address',
    whyHint_account: 'Enter this provider\'s account under Provider accounts below',
    whyHint_rule: 'WeChat face verification needs the business rule\'s RuleId, under Provider accounts → Tencent Cloud FaceID',
    whyHint_authCode: 'Enter this method\'s AuthCode under Provider accounts → Alibaba Cloud CPNS',
    whyHint_baseUrl: 'People are sent back to the customer console afterwards: set its domain under Control plane domains',
    isDefault: 'Default',
    setDefault: 'Make default',
    remove: 'Remove',
    moveUp: 'Up',
    moveDown: 'Down',
    addIntro: 'Tick the methods to add to the list. Only a provider that is set up can be added.',
    addOk: 'Add',
    added: 'Added',
    configured: 'Set up',
    notConfigured: 'Not set up',
    notConfiguredNote: 'Enter and save this provider\'s account under Provider accounts first.',
    configTitle: 'Provider accounts',
    configIntro: 'Each provider\'s own account, apart from each other and from Payment settings. Each needs its identity verification product opened first.',
    method_SMART_FACE: 'Quick',
    method_FACE: 'Face scan',
    method_CERT_PHOTO: 'ID card photo',
    method_CERT_PHOTO_FACE: 'ID card photo + face scan',
    methodHint_SMART_FACE: 'Alipay picks the check from the account: the smoothest',
    methodHint_FACE: 'A face scan, compared with the ID card photo',
    methodHint_CERT_PHOTO: 'Photographs of both sides of the ID card',
    methodHint_CERT_PHOTO_FACE: 'The ID card, then a face scan: the strictest',
    limitsTitle: 'Limits and fee',
    limitsIntro: 'How many verifications an account may start a day, and how many accounts one ID card may verify. Past the free attempts each costs the fee from the customer\'s balance, given back when the provider would not start it or its service failed.',
    daily: 'Verifications per account per day',
    maxAccounts: 'Accounts per ID card',
    unitTimes: 'times',
    unitAccounts: 'accounts',
    saved: 'Real-name verification settings saved',
    recordsTitle: 'Verifications',
    recordsCount: '{n} in all',
    recordsEmpty: 'No verifications yet',
    filterAccount: 'Username / email / phone',
    filterName: 'Name',
    filterMethod: 'Method',
    filterStatus: 'State',
    colTime: 'Started',
    colAccount: 'Account',
    colName: 'Name',
    colCertNo: 'ID number',
    colMethod: 'Method',
    colState: 'State',
    colIp: 'IP',
    state_passed: 'Passed',
    state_pending: 'In progress',
    state_failed: 'Not passed',
    state_expired: 'Timed out',
    state_init: 'Starting',
    provider_alipay: 'Alipay identity verification',
    provider_tencent: 'Tencent Cloud FaceID',
    provider_aliyun: 'Alibaba Cloud CPNS',
    providerShort_alipay: 'Alipay',
    providerShort_tencent: 'Tencent',
    providerShort_aliyun: 'Aliyun',
    providerHint_alipay: 'An Alipay open platform app that has signed the Identity Verification product',
    providerHint_tencent: 'A Tencent Cloud API key with the FaceID service opened',
    providerHint_aliyun: 'An Alibaba Cloud AccessKey; apply for the tags you need in the CPNS console, then copy each approved tag\'s AuthCode',
    secretIdHelp: 'From Tencent Cloud CAM → API keys; a sub-account key allowed only FaceID is best',
    secretKeyKeep: 'Saved; leave empty to keep it',
    secretKeyPlaceholder: 'Tencent Cloud SecretKey',
    secretKeySet: 'Stored encrypted',
    secretKeyHelp: 'Stored encrypted once saved, never shown again',
    accessKeyIdHelp: 'From Alibaba Cloud AccessKey management; a RAM user allowed only CPNS is best',
    accessKeySecretPlaceholder: 'Alibaba Cloud AccessKey Secret',
    authCodeID2: 'ID check AuthCode',
    authCodeHelpID2: 'The approved Name + ID number tag\'s ID; needed when that method is shown',
    authCodePhone3: 'Mobile check AuthCode',
    authCodeHelpPhone3: 'The approved Name + ID + mobile tag\'s ID; needed when that method is shown',
    ruleId: 'Business rule RuleId',
    ruleIdHelp: 'Made in the FaceID console; needed for WeChat face verification',
    region: 'Region',
    regionHelp: 'Optional, e.g. ap-guangzhou',
    method_TC_FACE: 'WeChat face scan',
    method_TC_ID2: 'Name + ID number',
    method_TC_PHONE3: 'Name + ID + mobile',
    methodHint_TC_FACE: 'Open the page in WeChat; a liveness check, then a match against the photo on record',
    methodHint_TC_ID2: 'Does the name go with the ID number; answered at once, no face scan',
    methodHint_TC_PHONE3: 'Are the name, ID number and mobile one person\'s; answered at once',
    method_ALI_ID2: 'Name + ID number',
    method_ALI_PHONE3: 'Name + ID + mobile',
    methodHint_ALI_ID2: 'Does the name go with the ID number; answered at once, no face scan',
    methodHint_ALI_PHONE3: 'Are the name, ID number and mobile one person\'s by the carrier\'s records; answered at once',
    freeAttempts: 'Free attempts per account',
    freeHelp: 'Counted per account, ever; only attempts the provider took on count',
    fee: 'Fee per attempt after that',
    feeHelp: 'From the customer\'s balance; 0 keeps it free',
    unitPerTime: '/ attempt',
    colFee: 'Fee',
    free: 'Free',
    notBilled: 'Not billed',
  },
  messageTemplates: {
    title: 'Message templates',
    intro: 'What every mail, in-app message and text the platform sends says. Mails share one layout; the facts table and any quoted message are filled in by the system. Switch an event off and it sends nothing.',
    mailTab: 'Mail',
    smsTab: 'SMS',
    inboxTab: 'In-app messages',
    inboxIntro: 'In-app messages appear under the bell at the top right and in the Message Center, in the reader’s console language: each has a Chinese and an English version. Quoted ticket text, alarm details and the like are added after the body by the system.',
    colInboxTitle: 'Title',
    inboxLang: 'Language',
    inboxLangHelp: 'Readers on the Chinese console see the Chinese version, readers on the English console the English one; fill in both',
    langZh: '中文',
    langEn: 'English',
    inboxBodyHelp: 'Line breaks are kept; quoted text and details follow the body by themselves',
    inboxEnabledHelp: 'Switched off, this event sends no in-app message',
    inboxPreviewNote: 'The preview uses sample values; readers see real values in their own language, with quoted text and details after the body',
    smsIntro: 'The default template is used for every code text; a scene can set its own, and empty fields use the default. Alibaba Cloud takes an approved template CODE, SMSBao the message itself.',
    colEvent: 'Message',
    colTo: 'Recipient',
    colSubject: 'Subject',
    colEnabled: 'Send',
    colActions: 'Actions',
    colScene: 'Scene',
    colAliyun: 'Alibaba Cloud CODE',
    colSmsbao: 'SMSBao message',
    to_staff: 'Staff',
    to_customer: 'Customer',
    to_ops: 'Ops',
    custom: 'Customized',
    edit: 'Edit',
    save: 'Save',
    saved: 'Saved',
    turnedOn: 'Sending switched on',
    turnedOff: 'Sending switched off',
    cn: 'CN',
    intl: 'Intl',
    inheritedSample: 'Grey',
    inheritedNote: 'means the default template applies',
    inUse: 'In use',
    vars: 'Variables',
    varsHelp: 'Click one to insert it at the caret; it is replaced by the real value when sent',
    subject: 'Subject',
    heading: 'Heading',
    body: 'Body',
    bodyHelp: 'Line breaks are kept; the facts table and the button follow the body',
    button: 'Button text',
    enabledHelp: 'Switched off, this event sends no mail',
    restore: 'Restore the default',
    preview: 'Preview',
    previewNote: 'The preview uses sample values; real ones are filled in when sent',
    aliyunCn: 'Mainland template CODE',
    aliyunIntl: 'International template CODE',
    smsbaoCn: 'Mainland message',
    smsbaoIntl: 'International message',
    generalNote: 'An empty SMSBao message goes back to the default; Alibaba Cloud templates must be approved in its console first.',
    smsEmptyNote: 'Empty fields use the default template; Alibaba Cloud templates must be approved in its console first.',
    event_ticket_new_staff: 'New ticket',
    event_ticket_reply_staff: 'Customer replied',
    event_ticket_reply_customer: 'Staff replied',
    event_ticket_resolved: 'Ticket resolved',
    event_ticket_closed: 'Ticket closed',
    event_ticket_auto_closed: 'Ticket auto-closed',
    event_autorenew_ok: 'Auto-renew succeeded',
    event_autorenew_failed: 'Auto-renew failed',
    event_serving_alert: 'Node not serving',
    event_serving_recovered: 'Node recovered',
    eventHint_ticket_new_staff: 'To staff, when a customer opens a ticket',
    eventHint_ticket_reply_staff: 'To staff, when a customer replies',
    eventHint_ticket_reply_customer: 'To the customer, when staff reply',
    eventHint_ticket_resolved: 'To the customer, when staff reply and close',
    eventHint_ticket_closed: 'To the customer, when the ticket is closed',
    eventHint_ticket_auto_closed: 'To the customer, when a quiet ticket closes itself',
    eventHint_autorenew_ok: 'To the customer, after a renewal from balance',
    eventHint_autorenew_failed: 'To the customer, when a renewal could not be made',
    eventHint_serving_alert: 'To every admin and operator, when a node does not serve what was published',
    eventHint_serving_recovered: 'To every admin and operator, when the node is back to normal',
    scene_default: 'Default template',
    scene_bind_phone: 'Bind phone',
    scene_login: 'Login check',
    scene_reset_password: 'Password reset',
    sceneHint_default: 'Used unless a scene sets its own',
    sceneHint_bind_phone: 'Binding or changing a phone in Security Center',
    sceneHint_login: 'The SMS second step at sign-in, or signing in by SMS code',
    sceneHint_reset_password: 'Resetting a password by phone',
    var_system: 'Platform name',
    var_ticket_no: 'Ticket number',
    var_ticket_title: 'Ticket title',
    var_customer: 'Customer',
    var_category: 'Category',
    var_priority: 'Priority',
    var_days: 'Days to auto-close',
    var_package: 'Package',
    var_period: 'Period',
    var_amount: 'Amount',
    var_expires_at: 'Expires at',
    var_order_no: 'Order no.',
    var_reason: 'Reason',
    var_node: 'Node',
    var_problem: 'Problem',
    var_detail: 'What is wrong',
    var_duration: 'How long it lasted',
    to_visitor: 'Address given',
    event_register_code: 'Sign-up code',
    eventHint_register_code: 'Mailed to the address given when registering (with Verify email at sign-up on)',
    var_code: 'Code',
    var_minutes: 'Minutes valid',
    scene_register: 'Sign-up',
    sceneHint_register: 'Proving the phone when registering (with Verify phone at sign-up on)',
    alwaysOn: 'Always sent',
    event_login_code: 'Sign-in code',
    eventHint_login_code: 'Mailed to the account\'s address when signing in by email code (with Sign in by email code on)',
  },
  captchaSettings: {
    title: 'Captcha',
    serviceTitle: 'Verification service',
    stateOn: 'On',
    stateOff: 'Off',
    serviceIntro: 'Before codes are sent, accounts opened or (as set) sign-ins accepted, visitors pass a security check, so scripts cannot drain your text messages, emails and accounts. One service at a time, for both consoles.',
    provider: 'Provider',
    provider_local: 'Built-in captcha',
    provider_tencent: 'Tencent Cloud Captcha',
    provider_geetest: 'GeeTest',
    provider_google: 'Google reCAPTCHA',
    providerShort_local: 'Built-in',
    providerShort_tencent: 'Tencent',
    providerShort_geetest: 'GeeTest',
    providerShort_google: 'Google',
    providerHint_local: "A slider puzzle the control plane draws and checks itself: no outside service and no account. It is less able to tell bots apart than the services' own risk checks.",
    providerHint_tencent: 'Works inside and outside mainland China.',
    providerHint_geetest: 'GeeTest 4 (adaptive captcha). Works inside and outside mainland China.',
    providerHint_google: 'reCAPTCHA v2 checkbox, for platforms whose users are mostly abroad. Visitors in mainland China need it loaded from www.recaptcha.net, and it may be slow.',
    onError: 'When the service fails',
    onErrorAllow: 'Let through and record',
    onErrorAllowHint: 'go ahead as usual, recorded below',
    onErrorDeny: 'Refuse',
    onErrorDenyHint: 'ask the visitor to try again later',
    onErrorHelp: 'The service fails when the control plane cannot get a verdict from it: a timeout, an error, or keys it refuses. A visitor whose browser cannot load the check cannot pass it.',
    adminShutTitle: 'Administrators could be shut out too',
    adminShut: "The admin console's sign-in asks as well, so a service failure stops it too. Should that happen, run this on the control plane host to turn the check off:",
    recordTitle: 'Service failures',
    recordText: 'Since {since}: {n} in all, {allowed} let through, {denied} refused. Latest at {last} ({provider}, {scene}): {error}',
    recordClear: 'Clear',
    accountsTitle: 'Service accounts',
    localNoAccount: "The built-in captcha needs no account. These are the outside services' accounts, for when you switch to one.",
    accountIntro_tencent: 'Create a verification in the Tencent Cloud Captcha console and copy its CaptchaAppId and AppSecretKey. SecretId and SecretKey are a Tencent Cloud API key (CAM → API keys); the control plane signs its checks with it.',
    accountIntro_geetest: 'Create a business in GeeTest 4 (adaptive captcha) and copy its ID and KEY.',
    accountIntro_google: 'In the reCAPTCHA admin console, create a site of type reCAPTCHA v2 checkbox, add the console domains, and copy its site key and secret key.',
    geetestId: 'Captcha ID',
    geetestKey: 'Captcha KEY',
    siteKey: 'Site key',
    googleSecret: 'Secret key',
    googleHost: 'Load from',
    googleHostHelp: 'www.recaptcha.net is the same service at another address, reachable from mainland China too. Recommended.',
    secretSet: 'Set',
    secretKept: 'Saved. Leave empty to keep it',
    scenesTitle: 'Operations that ask',
    scenesIntro: 'Choose which operations need the check first. Code sends stay within the text-message limits as well.',
    scene_send_code: 'Sending codes',
    scene_register: 'Registering',
    scene_login: 'Console sign-in',
    scene_admin_login: 'Admin console sign-in',
    sendCodeHelp: 'Before a text or email code is sent: registering, signing in with a code, resetting a password, changing the phone.',
    registerHelp: 'When a customer submits the registration form.',
    login_off: 'Never',
    login_failed: 'After wrong passwords',
    login_always: 'Always',
    failures: 'Wrong passwords before asking',
    failuresUnit: 'times',
    failuresHelp: 'Once an account or an IP has given this many wrong passwords in 15 minutes, signing in needs the check first.',
    testTitle: 'Test',
    testIntro: 'Runs one check with the saved settings and has the control plane verify the result with the service, to confirm the keys.',
    testIntroLocal: 'Shows the built-in puzzle once and has the control plane check the slide, to confirm it works.',
    testRun: 'Run a test',
    testUnsaved: 'There are unsaved changes. Save them before testing.',
    testNotReady: 'Fill in every key of the selected service and save first.',
    testPass: 'Passed: the service confirmed the check. The settings work.',
    testPassLocal: 'Passed: the built-in captcha works.',
    testRejected: 'The service did not pass it: {detail}',
    testRejectedBare: 'The service did not pass it.',
    tencentFailed: 'Tencent Cloud Captcha failed with error {code}. ',
    tencent1006: "That means the verification's settings could not be fetched: check the CaptchaAppId and AppSecretKey, and that Tencent Cloud Captcha is activated and paid up.",
    tencentLoad: 'That is most likely the network: check the browser can reach Tencent Cloud Captcha (turing.captcha.qcloud.com).',
    testUnavailable: 'The check could not be verified: {detail}',
    saved: 'Captcha settings saved',
  },
  smsSettings: {
    title: 'SMS',
    providerTitle: 'SMS channels',
    providerIntro: 'Verification codes go out by text: proving phones, sign-in protection, password resets. Mainland China numbers go through one channel, the rest of the world through the other, each Aliyun SMS or SMSBao.',
    stateOff: 'Off',
    stateReady: 'Ready',
    stateIncomplete: 'Incomplete',
    provider: 'Provider',
    provider_aliyun: 'Alibaba Cloud SMS',
    provider_smsbao: 'SMSBao',
    channelCn: 'Mainland China channel',
    channelCnHelp: 'Texts codes to mainland China numbers',
    channelIntl: 'International channel',
    channelIntlHelp: 'Texts codes to numbers outside mainland China (Hong Kong, Macao and Taiwan included); off, only mainland numbers can be bound',
    channelOff: 'Off',
    accountsTitle: 'Provider accounts',
    templatesMoved: 'What the texts say and the template CODEs are set in Message templates. ',
    templatesLink: 'Open Message templates',
    accountsIntro: 'Each provider\'s account, used when it is a channel\'s; secrets are stored encrypted and never shown again.',
    intlSignName: 'International signature',
    intlSignHelp: 'Optional; the mainland signature when empty',
    intlTemplateHelp: 'A verification template approved under international messages in Aliyun\'s SMS console',
    smsbaoUser: 'Username',
    smsbaoUserHelp: 'The SMSBao account\'s username',
    smsbaoKeyType: 'Sign in with',
    smsbaoPassword: 'Password',
    smsbaoSecretHelp: 'Stored encrypted, never shown again; a password is sent as its MD5, as SMSBao asks',
    smsbaoSignHelp: 'The 【signature】 messages start with, registered with SMSBao first; without 【】',
    smsbaoTemplateHelp: "{'{'}code{'}'} is the code, {'{'}minutes{'}'} its life in minutes; the signature goes in front by itself",
    accessKeyId: 'AccessKey ID',
    accessKeySecret: 'AccessKey secret',
    secretHelp: 'Stored encrypted and never shown again',
    secretKept: 'Saved. Leave empty to keep it',
    secretSet: 'Set',
    secretPlaceholder: 'Enter the AccessKey secret',
    signName: 'Signature',
    signHelp: 'The approved signature, without the brackets',
    signPlaceholder: 'e.g. CloudSpeed',
    templateHelp: 'The approved verification template',
    templateParam: 'Template variable',
    templateParamHelp: "The variable the code goes in. For a template with ${'{'}code{'}'}, enter code",
    limitsTitle: 'Limits',
    limitsIntro: 'One address may ask for 20 codes an hour; a code dies after 5 wrong guesses.',
    ttl: 'Code lifetime',
    interval: 'Wait between codes to a number',
    daily: 'Codes per number per day',
    unitMinutes: 'min',
    unitSeconds: 's',
    unitTexts: 'texts',
    saved: 'SMS settings saved',
    testTitle: 'Test text',
    testIntro: 'Text a verification code to a number with the saved settings, to check the signature and the template work.',
    testPlaceholder: 'Mobile number',
    testSend: 'Send test text',
    testSent: 'Test text sent to {phone}. Check the phone',
    testUnsaved: 'The settings have changed. Save them before testing',
    testNotReady: 'Turn SMS on and complete the settings before testing',
    recordsTitle: 'Send record',
    recordsCount: '{n} in all',
    recordsEmpty: 'Nothing sent yet',
    filterPhone: 'Search number',
    filterPurpose: 'Purpose',
    filterStatus: 'Result',
    purpose_bind_phone: 'Verify phone',
    purpose_login: 'Sign-in',
    purpose_reset_password: 'Password reset',
    purpose_test: 'Test',
    status_sent: 'Sent',
    status_failed: 'Failed',
    status_pending: 'Sending',
    state_valid: 'Unused',
    state_used: 'Used',
    state_expired: 'Expired',
    state_failed: 'Failed',
    state_pending: 'Sending',
    colTime: 'Time',
    colPhone: 'Number',
    colPurpose: 'Purpose',
    colAccount: 'Account',
    colState: 'State',
    colNote: 'Note',
    colIp: 'Requested from',
    attempts: '{n} wrong guesses',
  },
  saveBar: {
    label: 'Save',
    unsaved: 'Unsaved changes',
    reset: 'Discard changes',
    fixFirst: 'Fix the errors above first',
  },
  mail: {
    title: 'Mail service',
    smtpTitle: 'SMTP',
    smtpIntro: "The platform sends its mail through this SMTP account; for now, ticket notifications. A business mailbox or a mail delivery service's SMTP account works best.",
    stateOff: 'Off',
    stateReady: 'Ready',
    stateIncomplete: 'Incomplete',
    host: 'SMTP server',
    port: 'Port',
    security: 'Security',
    security_ssl: 'SSL/TLS',
    security_starttls: 'STARTTLS',
    security_none: 'None',
    securityHelp_ssl: 'Encrypted from the start; usually port 465.',
    securityHelp_starttls: 'Connects in the clear, then upgrades to encryption; usually port 587.',
    securityHelp_none: 'Never encrypted: the password and the mail travel in the clear. Only for a private network; usually port 25.',
    username: 'Username',
    usernameHelp: 'Usually the full sending address; empty when the server needs no login.',
    usernamePlaceholder: "noreply{'@'}example.com",
    password: 'Password',
    passwordHelp: 'The SMTP password or app password, stored encrypted.',
    passwordKept: 'A password is stored; leave empty to keep it.',
    passwordSet: 'Stored (leave empty to keep)',
    passwordPlaceholder: 'SMTP password or app password',
    from: 'Sender address',
    fromName: 'Sender name',
    fromNameHelp: 'Who the mail is from, as recipients see it; the system name when empty.',
    fromNamePlaceholder: 'e.g. cdnX Support',
    linksTitle: 'Links in mail',
    linksIntro: 'The consoles the "View ticket" button in a notification opens.',
    customerURL: 'Customer console',
    adminURL: 'Admin console',
    urlFallback: "When empty, the console domain's: {url}",
    urlNone: 'When empty with no console domain set, mails carry no link.',
    toConsoleDomains: 'Console domains',
    testTitle: 'Test mail',
    testIntro: 'Sends a test mail now with the saved settings, to check they work.',
    testPlaceholder: 'Recipient',
    testSend: 'Send test mail',
    testSent: 'A test mail was sent to {to}. Check the inbox, and the spam folder.',
    testUnsaved: 'There are unsaved changes: the test uses the saved settings.',
    testNotReady: 'Turn the mail service on, fill in the server and the sender, and save first.',
    saved: 'Mail settings saved',
  },
  // A message's files and the conversation: components/tickets, the same
  // files in both consoles, so the same keys.
  ticketFiles: {
    add: 'Attach files',
    tip: 'Up to {max} files of {mb} MB each; screenshots can be pasted',
    uploading: 'Uploading…',
    tooMany: 'At most {max} files',
    tooLarge: '"{name}" is over {max} MB',
    empty: '"{name}" is empty',
    failed: '"{name}" could not be uploaded',
    downloadFailed: 'Download failed',
  },
  // ---- 投诉管理 ----
  l4: {
    title: 'Acceleration Rules',
    unit: '',
    statAll: 'All rules',
    statActive: 'Running',
    statDisabled: 'Disabled',
    statSuspended: 'Suspended',
    listTitle: 'Acceleration rules',
    listCount: '{n} in all',
    filterAll: 'All states',
    resetFilters: 'Reset',
    state_active: 'Running',
    state_disabled: 'Disabled',
    state_suspended: 'Suspended',
    reason_plan_expired: 'Package expired',
    reason_traffic_exceeded: 'Traffic used up',
    reason_requests_exceeded: 'Requests used up',
    reason_no_feature: 'Not in package',
    colName: 'Name',
    colAccess: 'Access address',
    colOrigins: 'Origins',
    noAccessHost: 'Package has no line',
    proto_tcp: 'TCP',
    proto_udp: 'UDP',
    proto_tcp_udp: 'TCP+UDP',
    stats: 'Stats',
    more: 'More',
    enable: 'Enable',
    disable: 'Disable',
    enabled: 'Enabled',
    disabled: 'Disabled',
    deleted: 'Deleted',
    disableTitle: 'Disable rule',
    disableContent: 'Disabling “{name}” closes port {port} at once and drops the connections on it.',
    deleteTitle: 'Delete rule',
    deleteContent: 'Deleting “{name}” closes and frees port {port} at once and drops the connections on it. This cannot be undone.',
    noMatch: 'No rule matches',
    searchPlaceholder: 'Search name, port or origin',
    filterCustomer: 'All customers',
    colOwner: 'Customer',
    colPort: 'Port',
    portRange: 'Port range',
    settingsTitle: 'App Acceleration port range',
    settingsIntro: 'Customers create and move rules only onto ports in this range; existing rules keep their ports. Node firewall bans cover the range.',
    settingsHint: 'Ports must be above 1024; staying below the 32768+ ephemeral range is advised. Cloud security groups must allow TCP and UDP on the range.',
    portMin: 'First port',
    portMax: 'Last port',
    settingsSaved: 'Port range saved',
    rangeNow: 'Now {min}–{max}',
    empty: 'No customer has a rule yet',
  },
  l4stats: {
    title: '{name} · Statistics',
    range_1h: '1h',
    range_today: 'Today',
    range_yesterday: 'Yesterday',
    range_7d: '7d',
    range_30d: '30d',
    loadFailed: 'Could not load the statistics',
    noLogs: 'Log storage is not connected, so there are no statistics yet',
    fig_trafficOut: 'Traffic out',
    fig_peakOut: 'Peak bandwidth out',
    fig_conns: 'New connections',
    fig_active: 'Peak concurrent',
    upNote: 'In {v}',
    connsNote: '{failed} no origin · {refused} refused',
    activeNote: 'Open at the same moment',
    tab_bandwidth: 'Bandwidth',
    tab_traffic: 'Traffic',
    tab_conns: 'Connections',
    tab_active: 'Concurrent',
    down: 'Out',
    up: 'In',
    newConns: 'New',
    failed: 'No origin',
    refused: 'Refused',
    activeLine: 'Concurrent',
    clientsTitle: 'Top visitors',
    colIp: 'Visitor IP',
    colConns: 'Connections',
    noClients: 'No visitors in this window',
  },
  complaints: {
    title: 'Complaints',
    unit: '',
    statPending: 'Pending',
    statProcessing: 'In progress',
    statResolved: 'Resolved',
    statWithdrawn: 'Withdrawn',
    listTitle: 'Complaints',
    count: '{n} in all',
    searchPlaceholder: 'Search number or text',
    filter_open: 'Waiting on support',
    filter_pending: 'Pending',
    filter_processing: 'In progress',
    filter_resolved: 'Resolved',
    filter_withdrawn: 'Withdrawn',
    filter_all: 'All complaints',
    noMatch: 'No complaints match',
    empty: 'No complaints waiting',
    cat_attitude: 'Attitude',
    cat_speed: 'Response time',
    cat_result: 'Outcome',
    cat_outage: 'Outage',
    cat_billing: 'Billing',
    cat_other: 'Other',
    status_pending: 'Pending',
    status_processing: 'In progress',
    status_resolved: 'Resolved',
    status_withdrawn: 'Withdrawn',
    colComplaint: 'Complaint',
    colTicket: 'Ticket',
    colHandler: 'Handler',
    colNo: 'Number',
    noTicket: 'None',
    nobody: 'Nobody yet',
    handle: 'Handle',
    detailTitle: 'Complaint',
    category: 'About',
    content: 'What happened',
    filedAt: 'Filed',
    result: 'Answer',
    handledAt: 'Answered {time}',
    resultPlaceholder: 'Say what was found and what was done. The customer reads it in My complaints.',
    accept: 'Take on',
    accepted: 'Taken on',
    resolve: 'Send answer',
    resolved: 'Answer sent',
    withdrawnNote: 'The customer withdrew this complaint.',
    pendingNote: 'Nobody has taken this complaint on yet. Take it on first, or answer it straight away.',
    close: 'Close',
  },
  richEditor: {
    image: 'Insert picture',
    bold: 'Bold',
    italic: 'Italic',
    underline: 'Underline',
    bulletList: 'Bulleted list',
    numberList: 'Numbered list',
    link: 'Insert link',
    unlink: 'Remove link',
    attach: 'Attach files',
    linkPlaceholder: 'Link address',
    linkApply: 'OK',
    badLink: 'That is not a valid link',
  },
  ticketThread: {
    secretTag: 'Confidential',
    secretReveal: 'Click to view',
    secretHide: 'Hide',
    secretPurged: 'Confidential content was destroyed when the ticket closed',
    newMessages: 'New messages, click to view',
    newSpoken: 'You have a new ticket message',
    infoBody: 'Description',
    infoFiles: 'Attachments',
    infoSite: 'Site',
    stage_filed: 'Created',
    stage_processing: 'In progress',
    stage_closed: 'Closed',
    me: 'Me',
    support: 'Support',
    roleCustomer: 'Customer',
    roleStaff: 'Support',
    note: 'Internal note',
    ev_accepted: '{actor} took the ticket on',
    ev_assigned: '{actor} assigned the ticket to {name}',
    ev_assignedSelf: '{name} is now the assignee',
    ev_unassigned: '{actor} unassigned {name}',
    ev_priority: '{actor} set the priority to {priority}',
    ev_closed_customer: 'The customer closed the ticket',
    ev_closed_staff: '{actor} closed the ticket',
    ev_closed_auto: 'Closed by itself: the customer did not answer',
    assistant: 'Service assistant',
    as_filed: 'Ticket received',
    as_filedText: 'We have your question. {support} will get to it soon, and you will hear about every step here. Add anything you think of below.',
    as_accepted: '{support} picked up your ticket',
    as_acceptedText: '{support} is working on your question and will reply here as soon as there is news.',
    as_closed_customer: 'You closed the ticket',
    as_closed_customerText: 'Thanks for letting us know. If the problem is not solved, file a new ticket.',
    as_closed_staff: '{support} closed the ticket',
    as_closed_staffText: 'Support has finished with this question. If anything is still unclear, file a new ticket.',
    as_closed_auto: 'The ticket closed itself',
    as_closed_autoText: 'There were no new replies for a long time, so the ticket was closed. If anything is still unclear, file a new ticket.',
  },
  menu: {
    grpNodes: 'Nodes',
    grpSites: 'Sites',
    grpL4: 'App Acceleration',
    grpDns: 'DNS & Routing',
    grpSecurity: 'Security',
    grpObserve: 'Logs & Analytics',
    grpCustomers: 'Customers & Plans',
    grpSystem: 'System',
    grpMessages: 'Messaging',
    grpFinance: 'Finance',
    grpTickets: 'Tickets',
  },
  // Messages the control plane produced, keyed by the stable code it ships
  // alongside the English text. The console looks the code up here so an
  // operator reads guidance in their own language; anything missing falls
  // back to the server's English rather than showing a bare key.
  quota: {
    usageCol: 'This period',
    traffic: 'Traffic',
    requests: 'Requests',
    bandwidth: 'Bandwidth',
    connections: 'Connections',
    unlimited: 'unlimited',
    withBonus: 'incl. top-up',
    resetsAt: 'resets {time}',
    exceeded_traffic_exceeded: 'Traffic used up',
    exceeded_requests_exceeded: 'Requests used up',
    exceededAlert_traffic_exceeded: 'Package "{pkg}" has used up this period\'s traffic. Its sites are suspended and visitors see the "Traffic exceeded" page. Service resumes at {time} when the next period starts, or sooner if the plan is topped up or upgraded.',
    exceededAlert_requests_exceeded: 'Package "{pkg}" has used up this period\'s requests. Its sites are suspended and visitors see the "Request limit exceeded" page. Service resumes at {time} when the next period starts, or sooner if the plan is topped up or upgraded.',
    topUp: 'Top up',
    reset: 'Reset usage',
    topUpTitle: 'Top up this period',
    topUpIntro: 'Add traffic or requests to {user}\'s "{pkg}" for the current period only. Sites suspended for running out resume within a minute.',
    millionSuffix: 'million',
    topUpDone: 'Topped up',
    resetTitle: 'Reset this period\'s usage',
    resetConfirm: 'Set the traffic and requests {user}\'s "{pkg}" used this period back to zero? Sites suspended for running out resume within a minute.',
    resetDone: 'Reset',
  },
  entitlements: {
    feature_waf: 'WAF',
    feature_custom_cc: 'Custom CC rules',
    feature_websocket: 'WebSocket',
    feature_http3: 'HTTP/3',
    feature_custom_cert: 'Custom certificates',
    feature_openapi: 'OpenAPI',
    feature_l4: 'App Acceleration',
  },
  // 人机验证 in the pages (utils/captcha.ts).
  captcha: {
    title: 'Security check',
    googleHint: 'Tick the box below and you will continue automatically.',
    loadFailed: 'The security check could not load. Check your network and try again',
    localTip: 'Slide to fit the piece',
    localPassed: 'Verified',
    localMissed: 'Not quite. Try again',
    localRefresh: 'New puzzle',
    localRetry: 'Retry',
    tencentError: 'Tencent Cloud Captcha failed (error {code}). Try again later',
  },
  smsCode: {
    send: 'Get code',
    resend: 'Resend',
    wait: 'Resend in {n}s',
    placeholder: '6-digit code',
    sent: 'Code sent to {phone}',
    failed: 'Could not send the code',
    required: 'Enter the 6-digit code from the text message',
  },
  securityCenter: {
    title: 'Security Center',
    accountId: 'Account ID: {id}',
    level: 'Security level',
    level_low: 'Low',
    level_medium: 'Medium',
    level_high: 'High',
    tipMfa: 'With an MFA device, a leaked password alone cannot sign in',
    tipPassword: 'Your password is more than {days} days old; consider changing it',
    tipGood: 'Every safeguard is on',
    recentFails: '{n} failed sign-ins in the last {days} days. If they were not you, change your password and bind an MFA device now.',
    email: 'Email',
    phone: 'Phone',
    registered: 'Signed up',
    lastLogin: 'Last sign-in',
    unbound: 'Not set',
    settingsTitle: 'Security settings',
    password: 'Password',
    passwordDesc: 'Change it from time to time, and do not use it on other sites.',
    passwordChanged: 'Last changed {time}.',
    mfa: 'MFA device',
    mfaOnDesc: 'Bound: signing in asks for the 6-digit code from your authenticator app. Bound {time}.',
    mfaOffDesc: 'Not bound. Once bound, signing in asks for a code from the authenticator app on your phone as well as the password.',
    emailDesc: '{email}, for ticket replies and platform notices.',
    sessions: 'Other sessions',
    sessionsDesc: 'Signed in on someone else\'s computer, or think the account is in other hands? End every session but this browser\'s, at once.',
    change: 'Change',
    bind: 'Bind',
    unbind: 'Unbind',
    endOthers: 'Sign out other devices',
    logsTitle: 'Sign-in history',
    logsSub: 'Last {n}',
    colTime: 'Time',
    colResult: 'Result',
    colIp: 'IP address',
    colDevice: 'Device',
    colMethod: 'Method',
    method_password: 'Password',
    method_code: 'Code',
    method_passkey: 'Passkey',
    method_sub_user: 'Sub-user {name}',
    passkeys: 'Passkeys',
    passkeysOnDesc: '{n} passkey(s) added. Sign in with your fingerprint, face or device PIN — no password needed.',
    passkeysOffDesc: 'Sign in with your fingerprint, face or device PIN instead of a password. The private key never leaves your device.',
    manage: 'Manage',
    add: 'Add',
    result_success: 'Signed in',
    result_bad_password: 'Wrong password',
    result_bad_mfa: 'Wrong code',
    result_inactive: 'Account disabled',
    unknownDevice: 'Unknown device',
    logsEmpty: 'No sign-ins yet',
    saveFailed: 'Could not save',
    passwordTitle: 'Change password',
    currentPassword: 'Current password',
    newPassword: 'New password',
    confirmPassword: 'Confirm new password',
    currentRequired: 'Enter your current password',
    newRequired: 'Enter a new password',
    confirmRequired: 'Enter the new password again',
    passwordRule: '{min}–{max} characters, with at least two of letters, digits and symbols',
    passwordSame: 'The new password must differ from the current one',
    passwordMismatch: 'The passwords do not match',
    passwordNote: 'Sessions on other devices end at once; this browser stays signed in.',
    strength: 'Strength',
    strength_1: 'Weak',
    strength_2: 'Fair',
    strength_3: 'Strong',
    passwordDone: 'Password changed; other devices are signed out',
    emailTitle: 'Change email',
    phoneTitle: 'Change phone',
    phoneBindTitle: 'Add phone',
    emailHint: 'Ticket replies and platform notices go to this address',
    emailRequired: 'Enter an email address',
    emailInvalid: 'Enter a valid email address',
    loginPassword: 'Password',
    passwordRequired: 'Enter your password',
    confirmWithPassword: 'Enter your password to confirm it is you',
    contactDone: 'Saved',
    mfaTitle: 'Bind an MFA device',
    mfaStep1: 'Install an authenticator app on your phone, such as Google Authenticator, Microsoft Authenticator or Tencent Authenticator.',
    mfaStep2: 'Scan the QR code below with the app to add the account.',
    mfaManual: 'Cannot scan? Enter this key in the app:',
    mfaStep3: 'Enter the 6-digit code the app shows and your password to finish.',
    mfaCode: 'Verification code',
    mfaCodeHint: 'Open your authenticator app and enter the 6 digits it shows',
    mfaCodeRequired: 'Enter the 6-digit code',
    mfaDone: 'MFA device bound; signing in will ask for a code',
    mfaUnbindTitle: 'Unbind MFA device',
    mfaUnbindWarn: 'Once unbound, signing in takes only the password, and the security level drops. If the device is lost and gives no code, ask the platform administrator to reset it.',
    mfaUnbindDone: 'MFA device unbound',
    endOthersTitle: 'Sign out other devices',
    endOthersConfirm: 'Every session of this account except this browser\'s ends at once and must sign in again. Continue?',
    endOthersDone: 'Other devices are signed out',
    tipSecondStep: 'With an MFA device or text message sign-in protection, a leaked password alone cannot sign in',
    loginSms: 'Sign-in protection',
    loginSmsOnDesc: 'On: signing in asks for a code texted to {phone}.',
    loginSmsOffDesc: 'Off. Once on, signing in asks for a code texted to your verified phone as well as the password.',
    loginSmsNeedsPhone: 'Off. Verify your phone first; then signing in can ask for a texted code.',
    loginSmsNeedsPhoneFirst: 'Verify your phone first',
    turnOn: 'Turn on',
    turnOff: 'Turn off',
    verify: 'Verify',
    phoneOffSmsDesc: 'Not set. Once added and verified, it protects sign-in and resets the password.',
    phoneProvedDesc: '{phone}, verified: it protects sign-in and resets the password.',
    phoneUnprovedDesc: '{phone}, not verified. Verify it to protect sign-in and reset the password with it.',
    phoneInvalid: 'Enter a valid mobile number',
    phoneVerifyTitle: 'Verify phone',
    phoneSmsHint: 'Choose the country code, then the number. Save it empty to remove the number',
    phoneDone: 'Phone verified',
    phoneRemoved: 'Phone removed',
    loginSmsOnTitle: 'Turn on sign-in protection',
    loginSmsOffTitle: 'Turn off sign-in protection',
    loginSmsOnNote: 'Once on, every sign-in asks for a code texted to {phone} as well as the password.',
    loginSmsOffWarn: 'Once off, signing in takes only the password, and the security level drops.',
    loginSmsOnDone: 'Sign-in protection on',
    loginSmsOffDone: 'Sign-in protection off',
    result_bad_sms: 'Wrong text code',
    result_bad_email_code: 'Wrong email code',
    result_password_reset: 'Password reset by text',
    phoneNoSmsDesc: 'Not set. Once the platform turns text messages on, bind a number with a texted code.',
    phoneUnprovedNoSmsDesc: '{phone}, not verified. Once the platform turns text messages on, verify it with a texted code.',
  },
  passkeys: {
    title: 'Passkeys',
    addTitle: 'Add a passkey',
    intro: "Passkeys let you sign in with your fingerprint, face or device PIN instead of a password. The private key stays on your device; the platform keeps only the public key, so phishing sites can't use it.",
    blocked_browser: "This browser doesn't support passkeys. Update it, then add one",
    blocked_domain: 'Passkeys need the console opened on a domain over HTTPS; this address cannot add or use them',
    colName: 'Name',
    colAdded: 'Added',
    colUsed: 'Last used',
    rename: 'Rename',
    deleteConfirm: "You won't be able to sign in with it any more. Remove the passkey saved on the device from the device's password manager.",
    empty: 'No passkeys yet',
    count: '{n} of {max} added',
    add: 'Add passkey',
    close: 'Close',
    name: 'Name',
    nameHint: 'To tell your devices apart, e.g. "Office MacBook"',
    nameRequired: 'Enter a name',
    nameTooLong: 'At most {max} characters',
    addNote: 'After Continue, follow your browser to verify with your fingerprint, face or device PIN.',
    continue: 'Continue',
    added: 'Passkey "{name}" added',
    deleted: 'Passkey "{name}" deleted',
    cancelled: 'Adding the passkey was cancelled',
    deviceHasOne: 'This device already holds a passkey for this account',
    addFailed: "Couldn't add the passkey",
    renameFailed: "Couldn't rename it",
    deleteFailed: "Couldn't delete it",
  },
  inbox: {
    title: 'Messages',
    settings: 'Message settings',
    settingsTitle: 'Message settings',
    settingsIntro: 'Choose how each kind of message reaches you: in-app messages appear under the bell and in Messages, mail goes to your account email. Changes apply at once.',
    settingsIntroStaff: 'Choose which messages you get in-app, under the bell and in Messages. Ticket mail goes to the notification addresses in Ticket settings (or to the assignee once a ticket has one).',
    prefSaved: 'Saved',
    unreadCount: '{n} unread',
    readAll: 'Mark all read',
    allRead: 'All marked read',
    more: 'View all',
    empty: 'No messages',
    emptyUnread: 'No unread messages',
    attention: '{n} to deal with',
    tabAll: 'All',
    tabUnread: 'Unread',
    categoryAll: 'All types',
    category_ticket: 'Tickets',
    category_billing: 'Billing',
    category_node: 'Nodes',
    markRead: 'Mark read',
    delete: 'Delete',
    deleted: 'Deleted',
    deleteTitle: 'Delete {n} message(s)?',
    deleteContent: 'This cannot be undone.',
    view: 'View',
    detail: 'Message',
    follow: 'Open',
    close: 'Close',
    colTitle: 'Title',
    colCategory: 'Type',
    colTime: 'Time',
    colActions: 'Actions',
    colEvent: 'Message',
    channelInbox: 'In-app',
    channelMail: 'Mail',
    event_ticket_new_staff: 'New ticket',
    event_ticket_reply_staff: 'Customer replied',
    event_ticket_reply_customer: 'Ticket reply',
    event_ticket_resolved: 'Ticket resolved',
    event_ticket_closed: 'Ticket closed',
    event_ticket_auto_closed: 'Ticket auto-closed',
    event_autorenew_ok: 'Auto-renew succeeded',
    event_autorenew_failed: 'Auto-renew failed',
    event_serving_alert: 'Node not serving',
    event_serving_recovered: 'Node recovered',
    eventHint_ticket_new_staff: 'When a customer opens a ticket; only the assignee once it has one',
    eventHint_ticket_reply_staff: 'When a customer replies; only the assignee once it has one',
    eventHint_ticket_reply_customer: 'When support replies to your ticket',
    eventHint_ticket_resolved: 'When support replies and closes your ticket',
    eventHint_ticket_closed: 'When your ticket is closed',
    eventHint_ticket_auto_closed: 'When a quiet ticket closes itself',
    eventHint_autorenew_ok: 'After a package renews from your balance',
    eventHint_autorenew_failed: 'When a package could not be renewed',
    eventHint_serving_alert: 'When a node does not serve what was published, e.g. config not in effect or probes failing',
    eventHint_serving_recovered: 'When the node is back to normal',
  },
  serverErrors: {
    emailCode: {
      unavailable: 'Mail is not set up on this platform, so no email code can be sent',
      badEmail: 'Enter a valid email address',
      tooMany: 'Too many codes asked for — try again later',
      wrong: 'The email verification code is not correct',
      expired: 'The email verification code is no longer valid — ask for a new one',
      tooSoon: 'Wait {seconds} seconds before asking for another code',
      dailyLimit: 'This address has had the most codes it may have today ({max}) — try again tomorrow',
    },
    assistant: {
      badBaseURL: 'The API address must start with http:// or https://',
      badDailyLimit: 'The daily limit is 0 (none) to 1000',
      badIcon: 'Unknown icon: {value}',
      badKey: 'The model service refused the API key; check it',
      badLauncher: 'Unknown button shape: {value}',
      badMaxTokens: 'An answer is 256 to 8192 tokens at most',
      badModel: "A model name is letters, digits and . _ : / {'@'} -",
      badName: 'The name is at most {max} characters',
      badPlacement: 'Unknown placement: {value}',
      badProvider: 'Unknown provider: {value}',
      badSuggestion: 'A suggested question is at most {max} characters',
      badTemperature: 'The temperature is 0 to 2',
      baseURLRequired: 'Enter the API address',
      busy: 'The last answer is still being written; wait or stop it',
      dailyLimit: 'You have used today\'s {limit} questions; ask again tomorrow',
      emptyAnswer: 'The model gave no answer; try again',
      emptyQuestion: 'Type a question',
      encryptionKeyMissing: 'Set secrets.encryption_key in control.yaml before saving the API key',
      keyRequired: 'Enter the API key',
      modelRequired: 'Enter the model',
      promptTooLong: 'The instructions are at most {max} characters',
      providerBalance: 'The model service account has no balance left; contact the platform admin',
      questionTooLong: 'A question is at most {max} characters',
      rateLimited: 'The model service is busy; try again shortly',
      timeout: 'The model took too long to answer; try again',
      tooManySuggestions: 'At most {max} suggested questions',
      unavailable: 'The AI assistant is not switched on',
      unreachable: 'The model service could not be reached; try again later',
      upstream: 'The model service answered with an error ({status}): {message}',
    },
    profile: {
      badNickname: 'A nickname is at most {max} characters',
      badBackupName: 'A contact name is at most {max} characters',
      badCompany: 'A company name is at most {max} characters',
      badAddress: 'An address is at most {max} characters',
      badSiteUsage: 'At most {max} characters',
      badRegion: 'Choose a province and a city',
      badQQ: 'A QQ number is 5 to 12 digits',
      badWeChat: 'A WeChat ID is 6 to 20 letters, digits, - or _, starting with a letter, or the mobile number it is bound to',
      badBackupPhone: 'Enter a phone number: digits, with + - ( ) or spaces',
      badIndustry: 'Unknown industry: {value}',
      badTeamSize: 'Unknown team size: {value}',
      badPostcode: 'A postcode is 6 digits',
      badCountry: 'Unknown country or region: {value}',
      countryLocked: 'The country or region cannot change once the account is verified',
      avatarBadImage: 'Upload a PNG, JPEG or GIF picture at least 64 pixels on each side',
      avatarTooLarge: 'A picture is at most {max} MB',
    },
    systemUpdate: {
      noReleaseKey: 'This build has no release public key, so it cannot verify updates',
      upToDate: 'The control plane is up to date',
      noUpdater: 'The updater (cdnx-updater) is not installed on the control plane\'s host',
      busy: 'An update is under way',
      notChecked: 'Check for updates first',
      badReleaseUrl: 'The repository address is not an http(s) address',
      checkFailed: 'The repository could not be read: {detail}',
      badComponent: 'Components are the agent and the edge',
      succeeded: 'Updated the control plane from {from} to {to}',
      rolled_back: 'Updating to {to} failed; {from} is back',
      failed: 'Updating to {to} failed',
      artifactsPreparing: 'The control plane is still downloading the new version for the nodes; try again in a minute',
      artifactsFailed: 'The control plane could not download the new version for the nodes (trying again): {detail}',
    },
    realname: {
      badFee: 'An attempt costs at most {max}',
      badFree: 'An account may have 0 to 100 attempts free',
      badPhone: 'Enter the mainland mobile number in your name',
      badProvider: 'Unknown provider: {value}',
      badRegion: '{value} is not a region like ap-guangzhou',
      badRuleId: 'A RuleId is digits',
      badSecretId: 'A SecretId is 16 to 64 letters and digits',
      badSecretKey: 'That is not a SecretKey',
      insufficientBalance: 'This verification costs {fee} and your balance is {balance}; top up first',
      numberGone: 'This record did not keep the ID number',
      ruleRequired: 'WeChat face verification needs the business rule RuleId',
      tencentKeyRequired: 'Enter the Tencent Cloud SecretId and SecretKey',
      aliyunKeyRequired: 'Enter the Alibaba Cloud AccessKey ID and AccessKey Secret',
      authCodeRequired: '{method} needs the AuthCode of its approved tag',
      badAccessKeyId: 'An AccessKey ID is 12 to 64 letters and digits',
      badAccessKeySecret: 'That is not an AccessKey Secret',
      badAuthCode: 'An AuthCode is 4 to 64 characters, no spaces',
      unavailable: 'Online real-name verification is not open on this platform',
      already: 'This account is verified already',
      badMethod: 'Choose one of the verification methods offered',
      badName: 'Enter your name as it is on your identity card',
      badCertNo: 'Enter a valid 18-digit resident identity card number',
      startFailed: 'The verification could not be started; try again later',
      notFound: 'No such verification',
      tooMany: '{max} verifications have been started today, the most allowed; try again tomorrow',
      identityTaken: 'This identity card has verified {max} accounts already, the most allowed',
      unknownMethod: 'Unknown verification method: {value}',
      noMethods: 'Show at least one method on the list',
      badDefault: 'The default method must be one shown on the list',
      duplicateMethod: '{method} is on the list already',
      sumsubKeyRequired: 'Enter the Sumsub app token and secret key',
      levelRequired: 'Enter the Sumsub verification level\'s name',
      veriffKeyRequired: 'Enter the Veriff API key and shared secret key',
      badAppToken: 'That is not a Sumsub app token',
      badLevelName: 'A level name is letters, digits, spaces, . _ or -',
      badVeriffKey: 'That is not a Veriff API key',
      badSumsubSecret: 'That is not a Sumsub secret key',
      badVeriffSecret: 'That is not a Veriff shared secret key',
      badDaily: 'An account may start 1 to 20 verifications a day',
      badMaxAccounts: 'One identity card may verify 1 to 10 accounts',
      encryptionKeyMissing: 'Set secrets.encryption_key in control.yaml before opening real-name verification',
    },
    notify: {
      unknownEvent: 'There is no such message type',
    },
    msgtpl: {
      badSubject: 'A subject is 1 to 200 characters',
      badTitle: 'A heading is 1 to 100 characters',
      badBody: 'The body is at most 2000 characters',
      badButton: 'A button says 1 to 20 characters',
      badInboxTitle: 'An in-app message title is 1 to 100 characters, in both Chinese and English',
      badInboxBody: 'An in-app message body is at most 1000 characters in each language',
      unknownVar: "This mail has no value {name}",
      unknownEvent: 'No such message: {value}',
    },
    captcha: {
      required: 'Complete the human verification first',
      failed: 'The human verification did not pass. Try again',
      unavailable: 'Human verification is unavailable right now. Try again later',
      changed: 'The verification method has changed. Verify again',
      busy: 'Too many verification requests. Try again in a minute',
      incomplete: 'Fill in every key of the selected service before switching human verification on',
      unknownProvider: 'Unsupported verification service: {value}',
      unknownOnError: 'Unsupported failure policy: {value}',
      unknownLoginMode: 'A sign-in asks never, after wrong passwords, or every time',
      failuresRange: 'Wrong passwords must be between {min} and {max}',
      badTencentAppId: 'A CaptchaAppId is digits',
      badSecretId: 'A SecretId is 16 to 64 letters and digits',
      badGeeTestId: 'A GeeTest ID is 16 to 64 letters and digits',
      badSiteKey: 'A reCAPTCHA site key is 20 to 64 letters, digits, - and _',
      badHost: 'reCAPTCHA loads from www.recaptcha.net or www.google.com',
      badSecret: 'That is not a valid secret key',
      encryptionKeyMissing: 'Set secrets.encryption_key in control.yaml before storing a key',
    },
    sms: {
      unavailable: 'Text messages are not set up on this platform',
      badPhone: 'Enter a valid mobile number',
      intlUnavailable: 'Codes cannot be texted to numbers outside mainland China here',
      intlTemplateRequired: 'Set the international Alibaba Cloud template CODE in Message templates → SMS → Default template first',
      smsbaoKeyRequired: 'Enter the 短信宝 username and password or ApiKey',
      badSmsbaoUser: "A 短信宝 username is letters, digits, _ . {'@'} or -",
      badSmsbaoTemplate: "The message must contain {'{'}code{'}'} where the code goes, and not run too long",
      tooSoon: 'Wait {seconds} seconds before asking for another code',
      dailyLimit: 'This number has had its {max} codes for today. Try again tomorrow',
      tooMany: 'Too many codes asked for. Try again later',
      sendFailed: 'The text message could not be sent. Try again later',
      codeWrong: 'The text message code is not correct',
      codeExpired: 'The text message code is no longer valid. Ask for a new one',
      providerError: 'Alibaba Cloud SMS answered {code}: {message}',
      unreachable: 'Could not reach the SMS provider: {reason}',
      badProvider: 'Unknown SMS provider: {value}',
      badAccessKey: 'An AccessKey ID is letters and digits only',
      badTemplate: '{value} is not a template code like SMS_123456789',
      badTemplateParam: '{value} is not a template variable name',
      badSign: 'A signature is at most 32 characters',
      badTTL: 'A code lasts 1–30 minutes',
      badInterval: 'The wait between codes to one number is 30–600 seconds',
      badDaily: 'A number may get 1–100 codes a day',
      encryptionKeyMissing: 'No encryption key is configured on the control plane (secrets.encryption_key in control.yaml), so the AccessKey secret cannot be saved yet',
      accessKeyRequired: 'Enter the AccessKey ID',
      secretRequired: 'Enter the AccessKey secret',
      signRequired: 'Enter the signature',
      templateRequired: 'Set the mainland Alibaba Cloud template CODE in Message templates → SMS → Default template first',
    },
    account: {
      wrongPassword: 'The password is not correct',
      passwordSame: 'The new password must differ from the current one',
      passwordWeak: 'A password needs {min}–{max} characters, with at least two of letters, digits and symbols',
      emailInvalid: 'Not a valid email address',
      emailTaken: 'Another account uses this email address',
      phoneInvalid: 'Not a valid phone number',
      mfaUnavailable: 'The platform has no encryption key configured, so MFA devices cannot be bound yet. Contact the platform administrator',
      mfaBound: 'An MFA device is already bound',
      mfaNotBound: 'No MFA device is bound',
      mfaSecretInvalid: 'The key is not valid. Close the window and bind again',
      phoneNeedsCode: 'A phone number is bound with a texted code',
      phoneNotVerified: 'Verify your phone first',
    },
    finance: {
      accountExists: 'This Alipay account has been added already',
      accountFormat: 'An Alipay account is an email address or an 11-digit mobile number',
      accountIncomplete: 'Receiving account {n} needs an account name, a bank and an account number',
      accountName: 'Enter the real name on the Alipay account',
      accountTooLong: 'Receiving account {n} has a field that is too long',
      approveAmount: 'Approve between ¥0.01 and ¥{max}',
      autoRenewCancelled: 'A cancelled package is not renewed automatically',
      badFee: 'The fee rate is 0‰–1000‰ and the minimum fee cannot be negative',
      badMin: 'A minimum must be between ¥0.01 and ¥{max}',
      badRefundDays: 'Refund windows are 0–{max} days',
      badUpload: 'The attachment was not found. Upload it again',
      badUploadPurpose: 'Unsupported upload',
      badUploadType: 'Only PNG, JPEG and WebP images and PDF files are accepted',
      badWithdrawRange: 'Withdrawals must be at least ¥0.10, at most ¥{max} and no less than the minimum',
      email: 'The email address is not valid',
      emailRequired: 'An electronic invoice needs an email address. Add one to the invoice title first',
      emptyUpload: 'The file is empty',
      expressRequired: 'Enter the courier and the tracking number',
      feeOverMin: 'At the minimum withdrawal, the fee would leave less than ¥0.10 to transfer. Lower the fee or raise the minimum',
      insufficientBalance: 'Your balance is ¥{balance} and this costs ¥{amount}. Top up first',
      invoiceBadProfile: 'Choose an invoice title',
      invoiceClosed: 'Invoices cannot be requested',
      invoiceFileRequired: 'Upload the electronic invoice',
      invoiceMedium: 'This invoice delivery is not offered',
      invoiceMin: 'An invoice must be for at least ¥{min}',
      invoiceNoKind: 'Offer at least one invoice type and one delivery method',
      invoiceNumber: 'Enter the invoice number (8–24 digits or letters)',
      invoiceType: 'This invoice type is not offered',
      labelTooLong: 'A label can be at most {max} characters',
      mailIncomplete: 'A paper invoice needs a recipient, a phone number and a mailing address. Add them to the invoice title first',
      noteRequired: 'Enter a reason',
      noteTooLong: 'A note can be at most {max} characters',
      overCashable: 'At most ¥{max} can be withdrawn or refunded: invoiced money cannot leave',
      overInvoiceable: 'At most ¥{max} can be invoiced',
      packageNotOnSale: 'This package is not on sale',
      periodUnavailable: 'The package "{package}" is not sold for this period',
      refundAmount: 'Enter the amount to refund',
      refundBadOrder: 'Choose a paid order',
      refundClosed: 'Refunds cannot be requested',
      refundExpired: 'This order can no longer be refunded',
      refundNoWindow: 'Set a refund window for top-ups or package orders before turning refunds on',
      refundOver: 'At most ¥{max} of this order can be refunded',
      refundReason: 'Enter a reason for the refund, at most {max} characters',
      refundUnavailable: 'Alipay is not set up, so the refund cannot go back to the payer',
      remitAmount: 'A transfer must be between ¥{min} and ¥{max}',
      remitBadAccount: 'Choose the account you transferred to',
      remitBadDate: 'The transfer date must be within the last 90 days',
      remitClosed: 'Bank transfers are not accepted',
      remitNoAccount: 'Add a receiving account before turning bank transfers on',
      remitPayerRequired: 'Enter the name on the account you transferred from',
      remitReceiptRequired: 'Upload the bank receipt of the transfer',
      remitTooLong: 'A field is too long',
      renewConflict: 'This package was renewed just now; refresh to see it',
      reviewNoteTooLong: 'A note can be at most {max} characters',
      specialIncomplete: 'A special invoice needs a company title with its registered address, phone number, bank and account',
      stale: 'This document has changed. Refresh and try again',
      storeClosed: 'Packages cannot be bought online',
      taxNo: 'A company title needs its taxpayer ID (15–20 digits or capital letters)',
      titleKind: 'Choose personal or company',
      titleRequired: 'Enter the invoice title, at most 100 characters',
      titleTooLong: 'A field is too long',
      tooManyAccounts: 'At most {max} receiving accounts',
      tooManyPending: '{max} requests are already being processed. Wait for them before submitting another',
      tooManyProfiles: 'At most {max} invoice titles',
      tooManyWithdrawAccounts: 'At most {max} withdrawal accounts',
      transferUnavailable: 'Alipay must use certificate signing to send transfers',
      uploadTooLarge: 'The file cannot be larger than {max} MB',
      withdrawAmount: 'A withdrawal must be between ¥{min} and ¥{max}',
      withdrawBadAccount: 'Choose a withdrawal account',
      withdrawClosed: 'Withdrawals are not available',
    },
    ticket: {
      confidentialClose: 'A confidential message is destroyed when the ticket closes, so it cannot close the ticket',
      badAssignee: 'Choose someone from support',
      badAttachment: 'An attached file is gone or not yours. Upload it again',
      badAutoClose: 'Auto-close is 0–{max} days',
      badCategory: 'Choose a category',
      badDomain: 'Choose one of your sites',
      badEmail: '"{value}" is not a valid email address',
      badPriority: 'Choose a priority',
      badRating: 'Rate from 1 to 5 stars',
      badUploadType: 'Only images, PDF, text and archive files are accepted',
      bodyRequired: 'Write something',
      bodyTooLong: 'A message is at most {max} characters',
      categoryName: 'Category {n} needs a name of at most 20 characters',
      categoryRequired: 'Turn on at least one category to let customers file tickets',
      closed: 'The ticket is closed and cannot be replied to. File a new one if you need to',
      closedAlready: 'The ticket is closed already',
      closedForNew: 'Tickets cannot be filed online. Contact support',
      commentTooLong: 'A comment is at most {max} characters',
      emptyUpload: 'The file is empty',
      notClosed: 'A ticket can be rated once it is closed',
      notOpen: 'Only a ticket waiting on support can be taken on',
      alreadyAccepted: 'Support has taken this ticket on already; reply to it',
      noticeTooLong: 'The notice is at most {max} characters',
      supportNameTooLong: 'The support name is at most {max} characters',
      rated: 'This ticket is rated already',
      templateBody: 'Enter the reply, at most {max} characters',
      templateTitle: 'Enter a name, at most {max} characters',
      titleLength: 'A title is 2–{max} characters',
      tooManyCategories: 'At most {max} categories',
      tooManyEmails: 'At most {max} notification addresses',
      tooManyFiles: 'At most {max} files on a reply',
      tooManyOpen: 'You have {max} tickets open. Close the ones that are solved first',
      tooManyTemplates: 'At most {max} canned replies',
      tooManyUploads: '{max} files are waiting to be sent. Send them or try again later',
      uploadTooLarge: 'A file is at most {max} MB',
    },
    complaint: {
      ticketRequired: 'File a complaint from the page of the ticket it is about',
      badCategory: 'Choose what the complaint is about',
      contentLength: 'Say what happened in {min}–{max} characters',
      badTicket: 'Choose one of your tickets',
      openForTicket: 'This ticket has a complaint being looked into already',
      tooManyOpen: '{max} complaints are being looked into already',
      done: 'The complaint is answered or withdrawn already',
      notPending: 'Only a pending complaint can be taken on',
      resultLength: 'Write the answer, at most {max} characters',
    },
    mail: {
      auth: 'The SMTP server refused the login: {reason}',
      badFrom: '"{value}" is not a valid sender address',
      badHost: '"{value}" is not a valid server name',
      badPort: 'The port is 1–65535',
      badRecipient: '"{value}" is not a valid email address',
      badSecurity: 'Unsupported connection security: {value}',
      badURL: '"{value}" is not a console address like https://cdn.example.com',
      connect: 'Could not reach the SMTP server: {reason}',
      encryptionKeyMissing: 'Set secrets.encryption_key in control.yaml before saving the SMTP password',
      failed: 'Sending failed: {reason}',
      fromRequired: 'Enter the sender address',
      hostRequired: 'Enter the SMTP server',
      notReady: 'Turn mail on and fill in the server and the sender first',
      passwordRequired: 'Enter the password for the username',
      rejected: 'The SMTP server refused the message: {reason}',
      timeout: 'The SMTP server did not answer in time',
      tls: 'The secure connection failed: {reason}',
      tooLong: 'A field is too long',
    },
    license: {
      readOnly: 'The platform is read-only for now, so changes cannot be made; contact the platform administrator',
      notActive: 'This control plane has no valid license: activate one on the License page',
      nodeQuota: 'The license allows {max} nodes, and there are {used}',
      domainQuota: 'The license allows {max} sites, and there are {used}',
      noRepository: 'The release repository opens to licensed control planes only: activate a license first',
      repoTokenExpired: 'The repository download token has expired: the license has not been renewed for too long',
      noKey: 'This binary has no license key built in, so no license can be verified; release builds have one',
      badPortalUrl: 'The portal address (license.portal_url) is not an http(s) address',
      notActivated: 'This control plane has no license yet',
      codeInvalid: 'No license has this code; check it and try again',
      revoked: 'This license was revoked',
      suspended: 'This license is suspended',
      expired: 'This license term has ended; renew it on the portal',
      notStarted: 'This license has not started yet',
      instancesFull: 'Every instance slot of this license is taken: release one on the portal first',
      instanceUnknown: 'The portal does not know this control plane: activate it again with the license code',
      instanceReleased: 'The portal released this control plane: activate it again with the license code',
      offlineOnly: 'The portal holds an offline license for this control plane: upload the newly issued file',
      clockSkew: 'This host clock is more than 5 minutes off the portal: set the time right (NTP) and try again',
      portalBusy: 'The portal is busy; try again in a moment',
      portalError: 'The portal answered HTTP {status}: {detail}',
      portalUnreachable: 'The portal {portal} cannot be reached: {detail}',
      portalBadAnswer: 'The portal answer cannot be used: {detail}',
      stateUnwritable: 'The license files cannot be written: {detail}',
      instanceCorrupt: 'The instance key {path} is damaged: fix or remove it by hand (removed, this is a new instance)',
      noStateDir: 'No license directory is configured (license.dir)',
      fileInvalid: 'This is not a valid license file, or its signature does not verify',
      unbound: 'This license is bound to no instance: licenses now come from the portal, activated with a license code',
      otherInstance: 'This license is for instance {instance}, not this one ({self})',
      notOffline: 'This is not an offline license file: activate an online license with its code',
      fileExpired: 'This license file has expired',
      offlineNoRenew: 'An offline license does not renew itself: upload the file the portal issues next',
    },
    billing: {
      adjustTooLarge: 'One adjustment can be at most ¥{max}',
      adjustZero: 'The amount cannot be zero',
      amountRange: 'A top-up must be between ¥{min} and ¥{max}',
      channelError: 'Alipay could not start the payment: {reason}',
      insufficientBalance: 'The balance is ¥{balance} and cannot go below zero',
      methodUnavailable: 'This payment method is not available. Try another one',
      noteRequired: 'Enter a reason for the adjustment',
      noteTooLong: 'The reason can be at most {max} characters',
      queryFailed: 'Could not query the order at Alipay: {reason}',
      tooManyPending: 'You already have {max} unpaid orders. Try again once they expire ({minutes} minutes)',
      unavailable: 'Online top-up is not available yet',
    },
    payment: {
      alipayPublicKeyRequired: 'Enter the Alipay public key',
      appIDRequired: 'Enter the AppID',
      badAlipayCert: 'The Alipay public key certificate is not a valid RSA certificate',
      badAlipayPublicKey: 'The Alipay public key is not a valid RSA public key',
      badAmountRange: 'The minimum must be at least ¥0.01, and the maximum no more than ¥{max} and no less than the minimum',
      badAppCert: 'The app public key certificate is not a valid RSA certificate',
      badAppID: '"{value}" is not a valid Alipay AppID',
      badBaseURL: '"{value}" is not a valid address. Use a form like https://cdn.example.com',
      badPrivateKey: 'The app private key is not a valid RSA private key',
      badRootCert: 'The Alipay root certificate contains no RSA certificate',
      badSignMode: 'Unsupported signing method: {value}',
      baseURLRequired: 'Set the customer console address before enabling Alipay',
      certKeyMismatch: 'The app public key certificate does not match the app private key',
      certsRequired: 'Certificate mode needs all three certificates: app public key, Alipay public key and Alipay root',
      encryptionKeyMissing: 'The control plane has no encryption key (secrets.encryption_key in control.yaml), so the app private key cannot be saved',
      noProduct: 'Turn on at least one payment product',
      presetOutOfRange: 'The quick amount ¥{value} is outside the allowed range',
      privateKeyRequired: 'Enter the app private key',
      subjectTooLong: 'The order title can be at most {max} characters',
      tooManyPresets: 'You can add at most {max} quick amounts',
    },
    credential: {
      nameTooLong: 'The note is at most {max} characters',
    },
    clickhouse: {
      addrRequired: 'Enter the server address',
      badAddr: '"{addr}" is not host:port',
      badDatabase: '"{database}" cannot be a database name (letters, digits and _, not starting with a digit)',
      badDays: '{table}: keep between {min} and {max} days',
      badHigh: 'The cleanup threshold must be between {min}% and {max}%',
      badKeep: 'Always keep between {min} and {max} days',
      badLow: 'Clean down to between {min}% and {max}% (at least 5% under the threshold)',
      busy: 'Another control plane replica is cleaning; try again in a minute',
      connectFailed: 'Cannot connect to ClickHouse: {error}',
      noDatabase: 'The server has no database {database}; save with "Initialize tables" to create it',
      notConfigured: 'No ClickHouse server is configured',
      notConnected: 'ClickHouse is not connected',
      schemaFailed: 'Creating the tables failed: {error}',
      unknownTable: 'Unknown table: {table}',
    },
    quota: {
      topUpEmpty: 'Enter some traffic or requests to add',
    },
    consoleTLS: {
      badSite: 'Unknown console',
      certInUse: 'Visitors are redirected to HTTPS on this certificate. Turn the redirect off first.',
      domainRequired: 'Enter and save this console\'s domain first',
      lockFromOtherHost: 'Open the admin console at {domain} first, then turn this on (this page was opened at {host})',
      noUsableCert: '{domain} has no valid certificate yet; issue or upload one before redirecting to HTTPS',
      sameDomain: 'The two consoles need different domains',
    },
    controlTLS: {
      badDomain: '"{value}" is not a domain name (no addresses or wildcards)',
      badMode: 'Unknown transport: {value}',
      badPort: 'The port must be 1-65535',
      certExpired: 'The certificate is not valid now (valid until {not_after})',
      certInUse: 'Nodes are using this certificate. Set node transport to Off first.',
      certNotForDomain: 'The certificate covers {names}, not {domain}',
      domainChanged: 'The domain changed while the certificate was being issued; issue again',
      domainRequired: 'Enter and save the communication domain first',
      emailRequired: 'An email address is required to issue a certificate',
      httpsRequired: 'This control plane only accepts node traffic over HTTPS',
      noUsableCert: 'No certificate valid for this domain yet; issue or upload one first',
      nodesOnHTTP: '{count} online node(s) still use HTTP: {nodes}',
    },
    cert: {
      notYours: 'That certificate belongs to another account',
      bindingUnavailable: 'Per-hostname certificates are not enabled on this platform',
      expired: 'The certificate expired on {not_after}',
      invalidPEM: 'The certificate is not a valid PEM-encoded X.509 certificate',
      keyMismatch: 'The private key does not belong to this certificate',
      notCovering: 'The certificate covers {names}, not {host}',
      notUsable: 'Certificate #{id} is expired or revoked',
    },
    linePool: {
      lineRequired: 'Choose a resolve line',
      lineUnsupported: 'The DNS plan of {zone} does not offer the {line} line — upgrade the plan to use it',
      wrongGroup: 'That pool belongs to another line group',
      roleInvalid: 'Role must be primary or backup (got {value})',
    },
    acme: {
      emailRequired: 'An email address is required',
      emailRequiredForZerossl: 'ZeroSSL needs an email address before EAB credentials can be obtained',
      issuanceInFlight: 'An issuance for {domain} is already in flight',
      issuanceOnAnotherReplica: 'Another control-plane replica is issuing this certificate',
      tosRequired: 'You must agree to the CA\'s terms of service',
      unknownCA: 'Unknown certificate authority {value}',
      zerosslNoStaging: 'ZeroSSL has no staging environment — issue against production, or use Let\'s Encrypt to test',
      notConfigured: 'Certificate issuance is not configured on this platform',
      challengeNotServed: 'The CA got {status} when fetching the challenge file for {domain} (it asked {ip}). Usually the file had not reached that node yet, or that node is not the one DNS points at.',
      challengeUnreachable: 'The CA could not reach {domain} on port 80 — check the node firewall and the DNS records',
      rateLimited: 'The CA is rate-limiting {domain}; try again later (repeated failures also trigger this)',
      dnsProblem: 'The CA could not resolve {domain} — make sure its DNS records are live first',
      caaForbids: 'A CAA record on {domain} forbids this CA from issuing',
      issueFailed: 'Issuing a certificate for {domain} failed: {detail}',
    },
    auth: {
      badCredentials: 'Incorrect username or password',
      inactiveUser: 'This account is not active',
      wrongPortal: 'This account cannot sign in through this console',
      throttled: 'Too many attempts. Try again in {minutes} minutes',
      badMfaCode: 'The code is wrong or already used. Enter a new one',
      mfaTicketExpired: 'Verification timed out. Enter your password again',
      resetUnavailable: 'This account cannot reset its password by text message (no verified phone). Ask the platform administrator',
      codeLoginOff: 'Sign-in by code is not offered',
      codeLoginUnavailable: 'No account here signs in with a code sent there — check it, or sign in with your password',
      subBadCredentials: 'The main account, sub-user name or password is incorrect',
      passkeyOff: 'Passkey sign-in is not available',
      mainAccountOnly: 'Only the main account can do this; sub-users cannot',
    },
    passkey: {
      needsDomain: 'Passkeys need the console opened on a domain over HTTPS (IP addresses are not supported)',
      originMismatch: "The page's address does not match the console's; refresh and try again",
      expired: 'The passkey request timed out; try again',
      failed: 'The passkey could not be verified; try again',
      unknown: 'This passkey is not registered here and may have been deleted. Sign in with your password and add it again',
      exists: 'This passkey has already been added',
      limit: 'An account can have at most {max} passkeys; delete one first',
      nameInvalid: 'Name the passkey, at most {max} characters',
    },
    subUser: {
      nameInvalid: "A sub-user name is 3–32 letters, digits, '_', '.' or '-', starting with a letter or digit",
      nameTaken: 'A sub-user with this name already exists',
      limit: 'An account can have at most {max} sub-users',
      remarkTooLong: 'A remark is at most {max} characters',
      badStatus: 'A sub-user is either enabled or disabled',
    },
    cacheJob: {
      noNodes: 'No active nodes to send this to',
      noTargets: 'Give at least one target',
      quota: 'Too many cache jobs in the last hour',
      scheduleNotAllowed: 'Only a prefetch can be scheduled',
      scheduleTooFar: 'A prefetch can be scheduled at most {days} days ahead',
      targetHasDotDot: '{value} must not contain ..',
      targetNotURL: '{value} is not a URL or a path starting with /',
      targetOffSite: '{value} is not on {host} — a job can only touch its own site',
      tooManyTargets: 'At most {max} targets per job, got {got}',
      unknownKind: 'Unknown cache job kind {value}',
    },
    cnameZone: {
      hasGroups: '{count} line group(s) use this domain — point them elsewhere first',
      inUse: '{count} line group(s) use {domain} — move them to another domain first',
      invalid: 'Enter an apex domain like example.com — no scheme, path, port or leading dot',
      notApex: 'Enter the base domain only (example.com), not a subdomain of it',
      providerRequired: 'Choose a DNS provider',
      ttlRange: 'TTL must be between {min} and {max} seconds',
      ttlBelowPlan: 'The DNS plan of this zone ({plan}) accepts no TTL below {min} seconds',
    },
    dns: {
      lineGroupNoResolveValue: 'The package\'s line group has no resolve value to point the CNAME at',
      cnameDomainBound: 'CNAME domain {domain} is still bound to package {package}',
      encryptionKeyMissing: 'No encryption key configured — set secrets.encryption_key in control.yaml before storing DNS credentials',
      unsupportedProvider: 'Unsupported DNS provider type {value}',
      cnameZoneMissing: 'Package {package} is bound to CNAME domain #{id}, which cannot be loaded — it may have been deleted',
      lineGroupMissing: 'Package {package} is bound to line group #{id}, which cannot be loaded — it may have been deleted',
      providerUnavailable: 'DNS provider account #{id} cannot be used: {detail}',
      providerListFailed: 'Listing records in {zone} failed: {detail}',
      providerWriteFailed: 'Writing record {name} failed: {detail}',
      cnameNameTaken: '{name} already has a {type} record (value {value}, record id {record_id}), and a CNAME cannot share its name',
      cnameNoZone: '{host} is under none of the platform\'s CNAME domains, so there is no DNS account to remove it through',
      lineGroupValueUnresolvable: 'The line group\'s resolve value {target} has no address in public DNS; sites using it will not be reachable',
      lineValueNameTaken: '{name} already has a {type} record (value {value}, record id {record_id}); a line group\'s resolve value must hold the node A records',
      lineNoActiveNodes: 'Line group {group} has no usable node (an active node with a public IPv4), so {name} resolves to no address',
      lineNoDefaultFallback: '{name} has records only on the {line} line. Resolvers on any other line fall back to the default line, which has none, so they get no answer.',
      supportedLinesFailed: 'Reading the resolve lines {zone} may use failed: {detail}',
    },
    domain: {
      badCityName: "Invalid city name: {value} (at most 64 characters, no {'|'} or line breaks)",
      badOriginHost: '"{value}" is not a valid host name',
      badRealIpHeader: '"{value}" is not a valid header name; use letters, digits and hyphens',
      challengeDifficultyRange: 'Difficulty must be between 8 and 24',
      challengeTTLRange: 'TTL must be between 60 and 86400 seconds',
      hostNotVerified: '{host} has not passed CNAME verification yet; a certificate can be requested once it has',
      siteNotServing: 'The site is disabled, so no certificate can be requested for {host}',
      cnameLookupFailed: 'Looking up {host} in DNS failed: {detail}',
      cnameNotFound: '{host} has no CNAME record yet — add one pointing at {target}',
      cnamePointsElsewhere: '{host} points at {resolved}, not {target}',
      cnameTargetMissing: '{target} does not resolve in public DNS, so the platform\'s CNAME record is not live. Check that the DNS account bound to the CNAME domain is the provider actually serving it',
      exemptPathNotAbsolute: 'Exempt path {value} must start with /',
      exemptPathTooLong: 'Exempt path {value} is too long',
      failBanDurationRange: 'The ban duration must be between {min} and {max} seconds',
      failBanMaxRange: 'The failure count must be between {min} and {max}',
      failBanWindowRange: 'The window must be between {min} and {max} seconds',
      forbidden: 'You do not have access to this site',
      geoBanDurationRange: 'The ban duration must be between {min} and {max} seconds',
      geoBlockNoRegions: 'Select at least one country or region',
      hostNotInSite: '{host} is not one of this site\'s domains',
      hostnameRequired: 'A hostname is required',
      nameRequired: 'A name is required',
      noCnameTarget: 'This site has no CNAME target — its package has no CNAME domain bound',
      originNotAHost: 'The origin address must be a bare hostname or IP — no scheme, port, path or spaces',
      originNotPublic: 'The origin address must be a public host — private, loopback and link-local addresses are not allowed',
      packageNotActive: 'Package {id} is not one of this account\'s active packages',
      packageRequired: 'Choose a package',
      tooManyCities: 'At most {max} cities',
      tooManyExemptPaths: 'At most {max} exempt paths',
      unknownCCLevel: 'Unsupported CC protection level: {value}',
      unknownCCAutoLevel: 'Unsupported adaptive CC sensitivity: {value}',
      unknownCCAutoMode: 'Unsupported adaptive CC verification: {value}',
      unknownChallengeMode: 'Unknown challenge mode {value}',
      unknownGeoBlockAction: 'Unsupported region block action: {value}',
      unknownGeoBlockMode: 'Unsupported region block mode: {value}',
      unknownProxyMode: 'Unsupported proxy mode: {value}',
      unknownRegion: 'Unknown country or region code: {value}',
      unknownSslMode: 'Unsupported SSL mode: {value}',
      unknownSubdivision: 'Unknown province code: {value}',
      upstreamLimitRange: 'Upstream concurrency limit must be between 0 and {max}',
    },
    firewall: {
      badPort: '"{value}" is not a port or port range (1-65535, e.g. 443 or 8000-8100)',
      blockMode: 'Unknown block mode: {mode}',
      noPorts: 'Specified-ports mode needs at least one port',
      limitRange: 'Out of range: must be between {min} and {max}',
      tooManyPorts: 'At most {max} ports or ranges per list',
      unknownScope: 'Unknown ban scope: {scope}',
    },
    pages: {
      badMode: 'Page "{key}" has an invalid mode: {mode}',
      dropNotAllowed: 'Page "{key}" cannot be set to close the connection',
      graceRange: 'The grace period must be between 0 and {max} hours',
      htmlRequired: 'Page "{key}" is set to custom HTML but the HTML is empty',
      htmlTooLarge: 'The HTML of page "{key}" must be at most {max} KB',
      messageTooLong: 'The message of page "{key}" must be at most {max} characters',
      statusRange: 'The status code of page "{key}" must be between 400 and 599',
      titleRequired: 'Page "{key}" is set to custom text and needs a title',
      titleTooLong: 'The title of page "{key}" must be at most {max} characters',
      unknownKey: 'There is no page named "{key}"',
    },
    subscription: {
      daysRange: 'The duration must be between {min} and {max} days',
      expiryBeforeStart: 'The expiry cannot be before the start',
      expiryInPast: 'The expiry must be in the future',
      notCancelled: 'This subscription is not cancelled',
      packageInactive: 'Package "{name}" is off sale and cannot be assigned',
      packageNotFound: 'The package does not exist',
      resumeExpired: 'This subscription has expired; renew it instead',
      userNotFound: 'The user does not exist',
    },
    ipList: {
      badEnforcement: 'Enforcement must be {edge} or {kernel}',
      badKind: 'Kind must be {allow} or {deny}',
      batchTooLarge: 'At most {max} addresses per batch, got {got}',
      full: 'This list is full',
      invalidTarget: 'Not a valid IP address or CIDR',
      noAddresses: 'Give at least one address',
      noteTooLong: 'The note must be at most {max} characters',
      targetTooBroad: 'This range is too broad to block',
      unknownScope: 'Unknown scope {value}',
    },
    node: {
      aliasTooLong: 'The alias must be at most {max} characters',
      cannotInitFromStatus: 'Cannot activate a node in status {status}',
      fingerprintTaken: 'This machine fingerprint is already registered with a different token',
      invalidRegisterToken: 'Invalid register token',
      ipNotPublic: 'This is not a routable public IP address',
      noActiveAgentToken: 'Node {id} has no active agent token',
      notAnIP: '{value} is not an IP address',
      primaryIPImmutable: 'The primary address is discovered from heartbeats and cannot be deleted',
      regionNotRegistered: 'Region {region} is not registered — add it on the Regions page first',
      registerFieldsRequired: 'Both the register token and the fingerprint are required',
      tokenExpired: 'This register token has expired',
      tokenUsed: 'This register token has already been used',
    },
    nodeGroup: {
      cnameZoneRequired: 'Choose a CNAME domain',
      hasMembers: 'This line group still has {count} node(s) — move them to another group first',
      resolveValueNotUnderZone: 'Resolve value {value} must be a subdomain of {zone}',
      resolveValueRequired: 'A resolve value is required',
      lineInvalid: 'Resolve line code {value} is not valid (lowercase letters, digits and underscores only)',
    },
    l4: {
      badStatsRange: 'Unsupported statistics range: {range}',
      badBalance: 'Load balancing must be round robin or source IP hash',
      badProtocol: 'The protocol must be TCP, UDP or TCP+UDP',
      badProxyProtocol: 'PROXY protocol must be off, v1 or v2',
      badRange: 'The port range must lie within {min}–{max}, the first port no higher than the last',
      nameLength: 'The name takes 1 to {max} characters',
      noFreePort: 'No free port is left in the range. Contact support.',
      originFormat: 'Origin {n} ({value}) must be host:port, an IPv6 address in brackets',
      originNotPublic: 'Origin {n} ({value}) is not a public address; private, loopback and link-local addresses cannot be origins',
      originRepeated: 'Origin {n} ({value}) is listed twice',
      originRequired: 'Add at least one origin',
      packageNotActive: 'The package chosen is not one of your active packages',
      packageRequired: 'Choose a package',
      portRange: 'The listen port must be between {min} and {max}',
      portReserved: 'Port {port} is reserved; choose another',
      portTaken: 'Port {port} is taken; choose another or leave it empty to have one assigned',
      remarkLength: 'The remark takes at most {max} characters',
      tooManyOrigins: 'At most {max} origins',
    },
    package: {
      cnameBindingIncomplete: 'Access domain, line group and CNAME value must be set together, or all left empty',
      cnameValueInvalid: 'CNAME value {value} is invalid — use letters, digits and hyphens, with dots between labels',
      cnameZoneNotFound: 'Access domain {id} does not exist',
      nodeGroupNoResolveValue: 'Line group {name} has no resolve value — set one first',
      nodeGroupNotFound: 'Line group {id} does not exist',
      descTooLong: 'The description must be at most {max} characters',
      nameRequired: 'A package name is required',
      unknownCnameMode: 'Unknown CNAME mode {value}',
      valueOutOfRange: '{field} must be between 0 and {max} (0 means unlimited)',
      groupNotFound: 'Package group {id} does not exist',
      noWaf: 'Your package “{package}” does not include WAF. Upgrade the package to use it.',
      noCustomCc: 'Your package “{package}” does not include custom CC rules; the CC protection level is available.',
      noWebsocket: 'Your package “{package}” does not include WebSocket.',
      noHttp3: 'Your package “{package}” does not include HTTP/3.',
      noCustomCert: 'Your package “{package}” does not include uploaded certificates; free certificates are available.',
      noOpenapi: 'None of your packages includes the Open API. Upgrade a package to use API keys.',
      noFeature: 'Your package “{package}” does not include this feature.',
      siteQuota: 'The package “{package}” allows at most {max} sites, and the limit is reached.',
      domainQuota: 'The package “{package}” allows at most {max} domains, subdomains included, and the limit is reached.',
      apexQuota: 'The package “{package}” allows at most {max} apex domains, and the limit is reached.',
      ruleQuota: 'The package “{package}” allows at most {max} rules per site, and the limit is reached.',
      noL4: 'Your package “{package}” does not include App Acceleration. Upgrade the package to use it.',
      l4Quota: 'The package “{package}” allows at most {max} App Acceleration rules, and the limit is reached.',
    },
    packageGroup: {
      descTooLong: 'The description must be at most {max} characters',
      hasPackages: 'This group still has {count} package(s) — move them to another group first',
      nameRequired: 'A group name is required',
      nameTaken: 'A package group with this name already exists',
      nameTooLong: 'The group name must be at most {max} characters',
    },
    publish: {
      nothingToPublish: 'Nothing to publish: the platform has no sites yet',
    },
    region: {
      codeInUse: '{count} node(s) still use {code} — confirm to move them along with the rename, or keep the code and change only the name',
      codeInvalid: 'A region code must be 1-32 characters of letters, digits, \'-\' or \'_\'',
      hasNodes: 'This region still has {count} node(s) — move them to another region first',
      nameRequired: 'A region name is required',
    },
    registration: {
      badUsername: 'A username is 3 to 32 letters, digits, _ . or -, starting with a letter or digit',
      usernameTaken: 'This username is taken',
      emailTaken: 'An account with this email exists already — sign in instead',
      phoneTaken: 'This phone is bound to another account already',
      agreeRequired: 'Read and accept the agreements first',
      closed: 'Registration is not open',
      noDefaultPackage: 'Registration is not configured: no default package',
      passwordTooShort: 'The password must be at least {min} characters',
      rateLimited: 'Too many registrations from this address — try again later',
    },
    rule: {
      aclBadHeader: "\"{value}\" is not a valid header name",
      aclBadMatch: 'The match is malformed',
      aclBadValue: "\"{value}\" is not valid for this rule type",
      aclNoValues: 'The rule matches nothing; add at least one value',
      aclTooManyValues: 'At most {max} values per rule; put more on an IP list',
      aclUnknownAction: 'Unsupported access control action: {value}',
      botBadSignature: 'Give either a pattern or a substring, not both',
      botUnknownAction: 'Unsupported bot rule action: {value}',
      browserTTLRange: 'Browser TTL must be -1 (inherit) or between 0 and {max}',
      ccBadConditions: 'The match conditions are malformed',
      ccBadCountStatus: '"{value}" is not a valid status; use a code like 404 or a class like 5xx',
      ccBadEscalation: 'The escalation tiers are malformed',
      ccBadParams: 'The action parameters are malformed',
      ccDimensionsEmpty: 'CC dimensions must not be empty',
      ccPathNotAbsolute: 'Path "{value}" must start with /',
      ccPathTooLong: 'The path can be at most 512 characters',
      ccStatusRange: 'The response status must be a 4xx or 5xx code',
      ccTTLRange: 'The action duration can be at most {max} seconds',
      ccThresholdRange: 'The threshold must be between 1 and 1000000',
      ccTooManyDimensions: 'At most {max} dimensions',
      ccTooManyTiers: 'At most {max} escalation tiers',
      ccUnknownAction: 'Unsupported action: {value}',
      ccUnknownMethod: 'Unsupported request method: {value}',
      ccUnknownMitigation: 'Unsupported mitigation: {value}',
      ccUnknownPathMode: 'Unsupported path match mode: {value}',
      ccWindowRange: 'The window must be between 1 and 86400 seconds',
      notAStatusCode: '{value} is not an HTTP status code',
      patternEmpty: 'The pattern is empty and would match every request',
      patternInvalid: "\"{value}\" is not a valid regular expression",
      patternTooLong: 'The pattern can be at most {max} characters',
      staleIfErrorRange: 'stale-if-error is out of range',
      staleWhileRevalidateRange: 'stale-while-revalidate is out of range',
      statusTTLRange: 'The cache TTL for status {code} is out of range',
      ttlRange: 'The cache TTL must be between 0 and {max}',
      unknownStatus: 'Unsupported rule status: {value}',
      unsupportedAclType: 'Unsupported ACL type {value}',
      unsupportedCcDimension: 'Unsupported CC dimension {value}',
      wafBadDefinition: 'The WAF rule is malformed',
      wafNoTargets: 'Pick at least one place to inspect',
      wafScoreRange: 'The score must be between {min} and {max}',
      wafUnknownCategory: 'Unsupported WAF category: {value}',
      wafUnknownTarget: 'Unsupported inspection target: {value}',
    },
    settings: {
      unknownLogo: 'There is no such logo',
      logoEmpty: 'The logo file is empty',
      logoTooLarge: 'The logo is at most {max} KB',
      logoBadSvg: 'The SVG could not be read: export it as a plain SVG and try again',
      unknownBackground: 'There is no such background',
      backgroundEmpty: 'The picture is empty',
      backgroundTooLarge: 'The background is at most {max} MB',
      backgroundBadType: 'The background is a PNG, JPG, WebP or SVG picture',
      logoBadType: 'The logo is a PNG, JPG, WebP, GIF or SVG picture',
      agreementTooLong: 'An agreement is at most {max} KB',
      footerBadLinkKind: 'Unknown footer link type: {value}',
      footerBadLinkURL: 'Footer link {n}: the address starts with http:// or https://',
      footerCopyrightTooLong: 'The copyright line is at most {max} characters',
      footerLinkNoText: 'Footer link {n} has no name yet',
      footerLinkTextTooLong: 'Footer link {n}: the name is at most {max} characters',
      footerTooManyLinks: 'The footer has at most {max} links',
      loginNoticeEmpty: 'The sign-in page notice is on: write its text',
      noticeTooLong: 'A notice is at most {max} KB',
      registerNoticeEmpty: 'The sign-up page notice is on: write its text',
      badAgreementMode: 'Unknown way of giving the agreement',
      badAgreementURL: 'An agreement link starts with http:// or https://',
      badWebsiteURL: 'The official site starts with http:// or https://',
      mailNotReady: 'Set up Mail first, then ask new accounts to prove their email',
      smsNotReady: 'Set up SMS first, then ask new accounts to prove their phone',
      badNavbarHeight: 'The top bar is {min}–{max} pixels high',
      badMenuWidth: 'The menu is {min}–{max} pixels wide',
      badSkin: '{value} is not one of the theme colours',
      badLevelBadge: 'That is not one of the VIP badge styles',
      defaultPackageRequired: 'Set a default package before opening registration',
      faviconEmpty: 'The icon file is empty',
      faviconNotIco: 'The icon must be a .ico file',
      faviconTooLarge: 'The icon must be at most {max} KB',
      tooLong: '{field} must be at most {max} characters',
    },
    stats: {
      unavailable: 'Statistics need ClickHouse, which is unavailable',
    },
    task: {
      autoRenewed: '{package} renewed from the balance for ¥{amount}, now until {until}',
      autoRenewError: 'The renewal could not be made: a database error; try again later',
      autoRenewGone: 'Subscription #{id} no longer exists',
      autoRenewNotDue: 'Nothing to renew: the package runs until {until}',
      autoRenewOff: 'The customer turned auto-renew off; nothing was charged',
      badResultStatus: 'A task result status must be success or failed, got {value}',
      certDeleted: 'Certificate #{cert_id} no longer exists',
      certIssued: 'Certificate for {domain} issued by {issuer}',
      certRenewed: 'Certificate for {domain} renewed by {issuer}',
      clickhouseDroppedBoth: 'Deleted {days} day(s) of data and emptied {logs} system log table(s), {size} freed',
      clickhouseDroppedDays: 'Deleted {days} day(s) of data, {size} freed',
      clickhouseDroppedLogs: 'Emptied {logs} system log table(s), {size} freed',
      clickhouseFailed: 'The cleanup failed: {error}',
      clickhouseNothing: 'Nothing needed deleting',
      clickhouseStillFull: 'The disk is still over the target: what is left is within the days always kept, or the disk holds other data',
      l4RuleDeleted: 'App Acceleration rule #{id} no longer exists',
      l4CnameNotBound: 'The rule’s package no longer hands out a CNAME (access domain, line group or CNAME value is unset)',
      cnameNotBound: 'The site\'s package no longer hands out a CNAME (CNAME domain, line group or CNAME value is unset)',
      aliasActivated: '{host} verified; the nodes now serve it',
      aliasAlreadyActive: '{host} is already verified',
      aliasDeleted: 'The alias {host} was deleted',
      cnamePublished: 'Published {host} → {target} ({action})',
      cnameRemoved: 'The site was deleted; removed its CNAME record {host}',
      cnameAlreadyGone: '{host} was already gone; nothing to remove',
      cnameStillUsed: '{host} is still used by {user}, so it was left in place',
      internal: 'Internal error: {detail}',
      lineGroupDeleted: 'Line group #{id} no longer exists',
      lineNotBound: 'The line group has no resolve value and CNAME domain to publish',
      linePublished: '{host} now resolves to {count} node address(es)',
      linePublishedWithBackup: '{host} now resolves to {count} address(es); {lines} line(s) fell back to standby addresses',
      lineUnchanged: '{host} is already up to date: {count} node IP(s), nothing changed',
      lineUnchangedWithBackup: '{host} is already up to date: {count} IP(s), {lines} line(s) still on standby addresses',
      notSystemTask: 'Only system tasks can be retried',
      renewNoNames: 'None of the certificate names belongs to {domain} any more; no renewal needed',
      renewNoSite: 'Certificate #{cert_id} belongs to no site; no renewal needed',
      renewSuperseded: 'Already renewed: certificate #{cert_id} covers the same names',
      running: 'The task is running right now; try again shortly',
      siteActivated: '{host} verified; the site is active',
      siteAlreadyActive: 'The site is already {status}; nothing to verify',
      siteDeleted: 'Site #{id} no longer exists',
      unsupportedType: 'Unsupported task type {value}',
      waitingForPublish: 'Waiting for the site\'s CNAME record to be published',
    },
    user: {
      encryptionKeyMissing: 'No encryption key configured — set secrets.encryption_key in control.yaml before storing ID numbers',
      noIdentity: 'This account has no ID number stored',
      passwordRequired: 'A password is required to create a user',
      unknownRealNameStatus: 'Unknown real-name status {value}',
      unknownRealNameType: 'Unknown real-name type {value}',
      unknownStatus: 'Unknown user status {value}',
    },
    member: {
      badExp: 'EXP is 0 to {max}',
      badThresholds: 'The {n} VIP thresholds must rise from at least 1, up to {max}',
      noteRequired: 'Say why: the customer sees it with the change',
      noteTooLong: 'A note is at most {max} characters',
      badChange: 'A change is 1 to {max}',
      expBelowZero: 'The customer has {n} EXP; no more can be taken back',
      noCustomer: 'No such customer; the account may have been deleted',
      growthBelowZero: 'The customer has {n} growth points; no more can be taken away',
    },
    userGroup: {
      hasMembers: 'This user group still has {count} member(s) — move them to another group first',
    },
    deployment: {
      badResultStatus: 'Invalid deployment result status: {value}',
    },
  },
}
